export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  date: { input: any; output: any };
  detailed_transport_mode: { input: any; output: any };
  float8: { input: any; output: any };
  geography: { input: any; output: any };
  geometry: { input: any; output: any };
  numeric: { input: any; output: any };
  reefer_mode: { input: any; output: any };
  timestamp: { input: any; output: any };
  timestamptz: { input: any; output: any };
  transport_mode: { input: any; output: any };
  uuid: { input: any; output: any };
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type EnergyUsage = {
  __typename?: 'EnergyUsage';
  activePowerKW: Scalars['Float']['output'];
  activePowerKWStable: Scalars['Float']['output'];
  activePowerKWTransition: Scalars['Float']['output'];
  co2eqKgPerHour: Scalars['Float']['output'];
  co2eqKgPerHourStable: Scalars['Float']['output'];
  co2eqKgPerHourTransition: Scalars['Float']['output'];
  month: Scalars['String']['output'];
};

export type EnergyUsageInputInput = {
  ages?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  end?: InputMaybe<Scalars['String']['input']>;
  manufacturers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reeferId?: InputMaybe<Scalars['String']['input']>;
  reeferMode?: InputMaybe<ReeferMode>;
  refrigerationUnitModels?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  shippingLine?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  tradelanes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EnergyUsageResponse = {
  __typename?: 'EnergyUsageResponse';
  data?: Maybe<Array<Maybe<EnergyUsage>>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum ReeferMode {
  Stable = 'STABLE',
  Transition = 'TRANSITION',
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "container_insights.ages" */
export type Container_Insights_Ages = {
  __typename?: 'container_insights_ages';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  max?: Maybe<Scalars['float8']['output']>;
  min?: Maybe<Scalars['float8']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "container_insights.ages" */
export type Container_Insights_Ages_Aggregate = {
  __typename?: 'container_insights_ages_aggregate';
  aggregate?: Maybe<Container_Insights_Ages_Aggregate_Fields>;
  nodes: Array<Container_Insights_Ages>;
};

/** aggregate fields of "container_insights.ages" */
export type Container_Insights_Ages_Aggregate_Fields = {
  __typename?: 'container_insights_ages_aggregate_fields';
  avg?: Maybe<Container_Insights_Ages_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Ages_Max_Fields>;
  min?: Maybe<Container_Insights_Ages_Min_Fields>;
  stddev?: Maybe<Container_Insights_Ages_Stddev_Fields>;
  stddev_pop?: Maybe<Container_Insights_Ages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Container_Insights_Ages_Stddev_Samp_Fields>;
  sum?: Maybe<Container_Insights_Ages_Sum_Fields>;
  var_pop?: Maybe<Container_Insights_Ages_Var_Pop_Fields>;
  var_samp?: Maybe<Container_Insights_Ages_Var_Samp_Fields>;
  variance?: Maybe<Container_Insights_Ages_Variance_Fields>;
};

/** aggregate fields of "container_insights.ages" */
export type Container_Insights_Ages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Container_Insights_Ages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Container_Insights_Ages_Avg_Fields = {
  __typename?: 'container_insights_ages_avg_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "container_insights.ages". All fields are combined with a logical 'AND'. */
export type Container_Insights_Ages_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Ages_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Ages_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Ages_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  max?: InputMaybe<Float8_Comparison_Exp>;
  min?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "container_insights.ages" */
export enum Container_Insights_Ages_Constraint {
  /** unique or primary key constraint on columns "label" */
  AgesLabelKey = 'ages_label_key',
  /** unique or primary key constraint on columns "id" */
  AgesPkey = 'ages_pkey',
}

/** input type for incrementing numeric columns in table "container_insights.ages" */
export type Container_Insights_Ages_Inc_Input = {
  max?: InputMaybe<Scalars['float8']['input']>;
  min?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "container_insights.ages" */
export type Container_Insights_Ages_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['float8']['input']>;
  min?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Container_Insights_Ages_Max_Fields = {
  __typename?: 'container_insights_ages_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['float8']['output']>;
  min?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Container_Insights_Ages_Min_Fields = {
  __typename?: 'container_insights_ages_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['float8']['output']>;
  min?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "container_insights.ages" */
export type Container_Insights_Ages_Mutation_Response = {
  __typename?: 'container_insights_ages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Container_Insights_Ages>;
};

/** on_conflict condition type for table "container_insights.ages" */
export type Container_Insights_Ages_On_Conflict = {
  constraint: Container_Insights_Ages_Constraint;
  update_columns?: Array<Container_Insights_Ages_Update_Column>;
  where?: InputMaybe<Container_Insights_Ages_Bool_Exp>;
};

/** Ordering options when selecting data from "container_insights.ages". */
export type Container_Insights_Ages_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: container_insights.ages */
export type Container_Insights_Ages_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "container_insights.ages" */
export enum Container_Insights_Ages_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Max = 'max',
  /** column name */
  Min = 'min',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "container_insights.ages" */
export type Container_Insights_Ages_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['float8']['input']>;
  min?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Container_Insights_Ages_Stddev_Fields = {
  __typename?: 'container_insights_ages_stddev_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Container_Insights_Ages_Stddev_Pop_Fields = {
  __typename?: 'container_insights_ages_stddev_pop_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Container_Insights_Ages_Stddev_Samp_Fields = {
  __typename?: 'container_insights_ages_stddev_samp_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "container_insights_ages" */
export type Container_Insights_Ages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Ages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Ages_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['float8']['input']>;
  min?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Container_Insights_Ages_Sum_Fields = {
  __typename?: 'container_insights_ages_sum_fields';
  max?: Maybe<Scalars['float8']['output']>;
  min?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "container_insights.ages" */
export enum Container_Insights_Ages_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Max = 'max',
  /** column name */
  Min = 'min',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Container_Insights_Ages_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Container_Insights_Ages_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Container_Insights_Ages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Container_Insights_Ages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Container_Insights_Ages_Var_Pop_Fields = {
  __typename?: 'container_insights_ages_var_pop_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Container_Insights_Ages_Var_Samp_Fields = {
  __typename?: 'container_insights_ages_var_samp_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Container_Insights_Ages_Variance_Fields = {
  __typename?: 'container_insights_ages_variance_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "container_insights.booking_legs" */
export type Container_Insights_Booking_Legs = {
  __typename?: 'container_insights_booking_legs';
  /** An object relationship */
  booking?: Maybe<Container_Insights_Bookings_Expanded>;
  booking_id?: Maybe<Scalars['uuid']['output']>;
  detailed_transport_mode?: Maybe<Scalars['detailed_transport_mode']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  end_gps?: Maybe<Scalars['geometry']['output']>;
  end_iso?: Maybe<Scalars['String']['output']>;
  end_location?: Maybe<Scalars['String']['output']>;
  end_long_location?: Maybe<Scalars['String']['output']>;
  end_unlocode?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  leg_expanded?: Maybe<Container_Insights_Legs_Expanded>;
  leg_id?: Maybe<Scalars['uuid']['output']>;
  linestring?: Maybe<Scalars['geometry']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  start_gps?: Maybe<Scalars['geometry']['output']>;
  start_iso?: Maybe<Scalars['String']['output']>;
  start_location?: Maybe<Scalars['String']['output']>;
  start_long_location?: Maybe<Scalars['String']['output']>;
  start_unlocode?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
  transport_mode?: Maybe<Scalars['transport_mode']['output']>;
};

/** aggregated selection of "container_insights.booking_legs" */
export type Container_Insights_Booking_Legs_Aggregate = {
  __typename?: 'container_insights_booking_legs_aggregate';
  aggregate?: Maybe<Container_Insights_Booking_Legs_Aggregate_Fields>;
  nodes: Array<Container_Insights_Booking_Legs>;
};

export type Container_Insights_Booking_Legs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Container_Insights_Booking_Legs_Aggregate_Bool_Exp_Count>;
};

export type Container_Insights_Booking_Legs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Container_Insights_Booking_Legs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Booking_Legs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "container_insights.booking_legs" */
export type Container_Insights_Booking_Legs_Aggregate_Fields = {
  __typename?: 'container_insights_booking_legs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Booking_Legs_Max_Fields>;
  min?: Maybe<Container_Insights_Booking_Legs_Min_Fields>;
};

/** aggregate fields of "container_insights.booking_legs" */
export type Container_Insights_Booking_Legs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Container_Insights_Booking_Legs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "container_insights.booking_legs" */
export type Container_Insights_Booking_Legs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Container_Insights_Booking_Legs_Max_Order_By>;
  min?: InputMaybe<Container_Insights_Booking_Legs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "container_insights.booking_legs" */
export type Container_Insights_Booking_Legs_Arr_Rel_Insert_Input = {
  data: Array<Container_Insights_Booking_Legs_Insert_Input>;
};

/** Boolean expression to filter rows from the table "container_insights.booking_legs". All fields are combined with a logical 'AND'. */
export type Container_Insights_Booking_Legs_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Booking_Legs_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Booking_Legs_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Booking_Legs_Bool_Exp>>;
  booking?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
  booking_id?: InputMaybe<Uuid_Comparison_Exp>;
  detailed_transport_mode?: InputMaybe<Detailed_Transport_Mode_Comparison_Exp>;
  end_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_gps?: InputMaybe<Geometry_Comparison_Exp>;
  end_iso?: InputMaybe<String_Comparison_Exp>;
  end_location?: InputMaybe<String_Comparison_Exp>;
  end_long_location?: InputMaybe<String_Comparison_Exp>;
  end_unlocode?: InputMaybe<String_Comparison_Exp>;
  leg_expanded?: InputMaybe<Container_Insights_Legs_Expanded_Bool_Exp>;
  leg_id?: InputMaybe<Uuid_Comparison_Exp>;
  linestring?: InputMaybe<Geometry_Comparison_Exp>;
  start_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  start_gps?: InputMaybe<Geometry_Comparison_Exp>;
  start_iso?: InputMaybe<String_Comparison_Exp>;
  start_location?: InputMaybe<String_Comparison_Exp>;
  start_long_location?: InputMaybe<String_Comparison_Exp>;
  start_unlocode?: InputMaybe<String_Comparison_Exp>;
  telematic_device_id?: InputMaybe<Uuid_Comparison_Exp>;
  tradelane?: InputMaybe<String_Comparison_Exp>;
  transport_mode?: InputMaybe<Transport_Mode_Comparison_Exp>;
};

/** input type for inserting data into table "container_insights.booking_legs" */
export type Container_Insights_Booking_Legs_Insert_Input = {
  booking?: InputMaybe<Container_Insights_Bookings_Expanded_Obj_Rel_Insert_Input>;
  booking_id?: InputMaybe<Scalars['uuid']['input']>;
  detailed_transport_mode?: InputMaybe<
    Scalars['detailed_transport_mode']['input']
  >;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  end_gps?: InputMaybe<Scalars['geometry']['input']>;
  end_iso?: InputMaybe<Scalars['String']['input']>;
  end_location?: InputMaybe<Scalars['String']['input']>;
  end_long_location?: InputMaybe<Scalars['String']['input']>;
  end_unlocode?: InputMaybe<Scalars['String']['input']>;
  leg_expanded?: InputMaybe<Container_Insights_Legs_Expanded_Obj_Rel_Insert_Input>;
  leg_id?: InputMaybe<Scalars['uuid']['input']>;
  linestring?: InputMaybe<Scalars['geometry']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  start_gps?: InputMaybe<Scalars['geometry']['input']>;
  start_iso?: InputMaybe<Scalars['String']['input']>;
  start_location?: InputMaybe<Scalars['String']['input']>;
  start_long_location?: InputMaybe<Scalars['String']['input']>;
  start_unlocode?: InputMaybe<Scalars['String']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
  transport_mode?: InputMaybe<Scalars['transport_mode']['input']>;
};

/** aggregate max on columns */
export type Container_Insights_Booking_Legs_Max_Fields = {
  __typename?: 'container_insights_booking_legs_max_fields';
  booking_id?: Maybe<Scalars['uuid']['output']>;
  detailed_transport_mode?: Maybe<Scalars['detailed_transport_mode']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  end_iso?: Maybe<Scalars['String']['output']>;
  end_location?: Maybe<Scalars['String']['output']>;
  end_long_location?: Maybe<Scalars['String']['output']>;
  end_unlocode?: Maybe<Scalars['String']['output']>;
  leg_id?: Maybe<Scalars['uuid']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  start_iso?: Maybe<Scalars['String']['output']>;
  start_location?: Maybe<Scalars['String']['output']>;
  start_long_location?: Maybe<Scalars['String']['output']>;
  start_unlocode?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
  transport_mode?: Maybe<Scalars['transport_mode']['output']>;
};

/** order by max() on columns of table "container_insights.booking_legs" */
export type Container_Insights_Booking_Legs_Max_Order_By = {
  booking_id?: InputMaybe<Order_By>;
  detailed_transport_mode?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  end_iso?: InputMaybe<Order_By>;
  end_location?: InputMaybe<Order_By>;
  end_long_location?: InputMaybe<Order_By>;
  end_unlocode?: InputMaybe<Order_By>;
  leg_id?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  start_iso?: InputMaybe<Order_By>;
  start_location?: InputMaybe<Order_By>;
  start_long_location?: InputMaybe<Order_By>;
  start_unlocode?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  tradelane?: InputMaybe<Order_By>;
  transport_mode?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Container_Insights_Booking_Legs_Min_Fields = {
  __typename?: 'container_insights_booking_legs_min_fields';
  booking_id?: Maybe<Scalars['uuid']['output']>;
  detailed_transport_mode?: Maybe<Scalars['detailed_transport_mode']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  end_iso?: Maybe<Scalars['String']['output']>;
  end_location?: Maybe<Scalars['String']['output']>;
  end_long_location?: Maybe<Scalars['String']['output']>;
  end_unlocode?: Maybe<Scalars['String']['output']>;
  leg_id?: Maybe<Scalars['uuid']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  start_iso?: Maybe<Scalars['String']['output']>;
  start_location?: Maybe<Scalars['String']['output']>;
  start_long_location?: Maybe<Scalars['String']['output']>;
  start_unlocode?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
  transport_mode?: Maybe<Scalars['transport_mode']['output']>;
};

/** order by min() on columns of table "container_insights.booking_legs" */
export type Container_Insights_Booking_Legs_Min_Order_By = {
  booking_id?: InputMaybe<Order_By>;
  detailed_transport_mode?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  end_iso?: InputMaybe<Order_By>;
  end_location?: InputMaybe<Order_By>;
  end_long_location?: InputMaybe<Order_By>;
  end_unlocode?: InputMaybe<Order_By>;
  leg_id?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  start_iso?: InputMaybe<Order_By>;
  start_location?: InputMaybe<Order_By>;
  start_long_location?: InputMaybe<Order_By>;
  start_unlocode?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  tradelane?: InputMaybe<Order_By>;
  transport_mode?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "container_insights.booking_legs". */
export type Container_Insights_Booking_Legs_Order_By = {
  booking?: InputMaybe<Container_Insights_Bookings_Expanded_Order_By>;
  booking_id?: InputMaybe<Order_By>;
  detailed_transport_mode?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  end_gps?: InputMaybe<Order_By>;
  end_iso?: InputMaybe<Order_By>;
  end_location?: InputMaybe<Order_By>;
  end_long_location?: InputMaybe<Order_By>;
  end_unlocode?: InputMaybe<Order_By>;
  leg_expanded?: InputMaybe<Container_Insights_Legs_Expanded_Order_By>;
  leg_id?: InputMaybe<Order_By>;
  linestring?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  start_gps?: InputMaybe<Order_By>;
  start_iso?: InputMaybe<Order_By>;
  start_location?: InputMaybe<Order_By>;
  start_long_location?: InputMaybe<Order_By>;
  start_unlocode?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  tradelane?: InputMaybe<Order_By>;
  transport_mode?: InputMaybe<Order_By>;
};

/** select columns of table "container_insights.booking_legs" */
export enum Container_Insights_Booking_Legs_Select_Column {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  DetailedTransportMode = 'detailed_transport_mode',
  /** column name */
  EndDatetime = 'end_datetime',
  /** column name */
  EndGps = 'end_gps',
  /** column name */
  EndIso = 'end_iso',
  /** column name */
  EndLocation = 'end_location',
  /** column name */
  EndLongLocation = 'end_long_location',
  /** column name */
  EndUnlocode = 'end_unlocode',
  /** column name */
  LegId = 'leg_id',
  /** column name */
  Linestring = 'linestring',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  StartGps = 'start_gps',
  /** column name */
  StartIso = 'start_iso',
  /** column name */
  StartLocation = 'start_location',
  /** column name */
  StartLongLocation = 'start_long_location',
  /** column name */
  StartUnlocode = 'start_unlocode',
  /** column name */
  TelematicDeviceId = 'telematic_device_id',
  /** column name */
  Tradelane = 'tradelane',
  /** column name */
  TransportMode = 'transport_mode',
}

/** Streaming cursor of the table "container_insights_booking_legs" */
export type Container_Insights_Booking_Legs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Booking_Legs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Booking_Legs_Stream_Cursor_Value_Input = {
  booking_id?: InputMaybe<Scalars['uuid']['input']>;
  detailed_transport_mode?: InputMaybe<
    Scalars['detailed_transport_mode']['input']
  >;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  end_gps?: InputMaybe<Scalars['geometry']['input']>;
  end_iso?: InputMaybe<Scalars['String']['input']>;
  end_location?: InputMaybe<Scalars['String']['input']>;
  end_long_location?: InputMaybe<Scalars['String']['input']>;
  end_unlocode?: InputMaybe<Scalars['String']['input']>;
  leg_id?: InputMaybe<Scalars['uuid']['input']>;
  linestring?: InputMaybe<Scalars['geometry']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  start_gps?: InputMaybe<Scalars['geometry']['input']>;
  start_iso?: InputMaybe<Scalars['String']['input']>;
  start_location?: InputMaybe<Scalars['String']['input']>;
  start_long_location?: InputMaybe<Scalars['String']['input']>;
  start_unlocode?: InputMaybe<Scalars['String']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
  transport_mode?: InputMaybe<Scalars['transport_mode']['input']>;
};

/** columns and relationships of "container_insights.bookings" */
export type Container_Insights_Bookings = {
  __typename?: 'container_insights_bookings';
  co2_setpoint?: Maybe<Scalars['float8']['output']>;
  created_at: Scalars['timestamptz']['output'];
  end_datetime: Scalars['timestamptz']['output'];
  end_gps: Scalars['geometry']['output'];
  end_iso: Scalars['String']['output'];
  end_location: Scalars['String']['output'];
  end_long_location: Scalars['String']['output'];
  /** Booking reference from the shipping line */
  external_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  o2_setpoint?: Maybe<Scalars['float8']['output']>;
  start_datetime: Scalars['timestamptz']['output'];
  start_gps: Scalars['geometry']['output'];
  start_iso: Scalars['String']['output'];
  start_location: Scalars['String']['output'];
  start_long_location: Scalars['String']['output'];
  /** An object relationship */
  telematic_device: Container_Insights_Telematic_Devices;
  telematic_device_id: Scalars['uuid']['output'];
  temperature_setpoint: Scalars['float8']['output'];
  tradelane: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "container_insights.bookings" */
export type Container_Insights_Bookings_Aggregate = {
  __typename?: 'container_insights_bookings_aggregate';
  aggregate?: Maybe<Container_Insights_Bookings_Aggregate_Fields>;
  nodes: Array<Container_Insights_Bookings>;
};

export type Container_Insights_Bookings_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Container_Insights_Bookings_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Container_Insights_Bookings_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Container_Insights_Bookings_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Container_Insights_Bookings_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Container_Insights_Bookings_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Container_Insights_Bookings_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Container_Insights_Bookings_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Container_Insights_Bookings_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Container_Insights_Bookings_Aggregate_Bool_Exp_Var_Samp>;
};

export type Container_Insights_Bookings_Aggregate_Bool_Exp_Avg = {
  arguments: Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Bookings_Aggregate_Bool_Exp_Corr = {
  arguments: Container_Insights_Bookings_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Bookings_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Container_Insights_Bookings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Container_Insights_Bookings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Container_Insights_Bookings_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Container_Insights_Bookings_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Bookings_Aggregate_Bool_Exp_Covar_Samp_Arguments =
  {
    X: Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
    Y: Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  };

export type Container_Insights_Bookings_Aggregate_Bool_Exp_Max = {
  arguments: Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Bookings_Aggregate_Bool_Exp_Min = {
  arguments: Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Bookings_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Bookings_Aggregate_Bool_Exp_Sum = {
  arguments: Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Bookings_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "container_insights.bookings" */
export type Container_Insights_Bookings_Aggregate_Fields = {
  __typename?: 'container_insights_bookings_aggregate_fields';
  avg?: Maybe<Container_Insights_Bookings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Bookings_Max_Fields>;
  min?: Maybe<Container_Insights_Bookings_Min_Fields>;
  stddev?: Maybe<Container_Insights_Bookings_Stddev_Fields>;
  stddev_pop?: Maybe<Container_Insights_Bookings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Container_Insights_Bookings_Stddev_Samp_Fields>;
  sum?: Maybe<Container_Insights_Bookings_Sum_Fields>;
  var_pop?: Maybe<Container_Insights_Bookings_Var_Pop_Fields>;
  var_samp?: Maybe<Container_Insights_Bookings_Var_Samp_Fields>;
  variance?: Maybe<Container_Insights_Bookings_Variance_Fields>;
};

/** aggregate fields of "container_insights.bookings" */
export type Container_Insights_Bookings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Container_Insights_Bookings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "container_insights.bookings" */
export type Container_Insights_Bookings_Aggregate_Order_By = {
  avg?: InputMaybe<Container_Insights_Bookings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Container_Insights_Bookings_Max_Order_By>;
  min?: InputMaybe<Container_Insights_Bookings_Min_Order_By>;
  stddev?: InputMaybe<Container_Insights_Bookings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Container_Insights_Bookings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Container_Insights_Bookings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Container_Insights_Bookings_Sum_Order_By>;
  var_pop?: InputMaybe<Container_Insights_Bookings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Container_Insights_Bookings_Var_Samp_Order_By>;
  variance?: InputMaybe<Container_Insights_Bookings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "container_insights.bookings" */
export type Container_Insights_Bookings_Arr_Rel_Insert_Input = {
  data: Array<Container_Insights_Bookings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Container_Insights_Bookings_On_Conflict>;
};

/** aggregate avg on columns */
export type Container_Insights_Bookings_Avg_Fields = {
  __typename?: 'container_insights_bookings_avg_fields';
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "container_insights.bookings" */
export type Container_Insights_Bookings_Avg_Order_By = {
  co2_setpoint?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "container_insights.bookings". All fields are combined with a logical 'AND'. */
export type Container_Insights_Bookings_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Bookings_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Bookings_Bool_Exp>>;
  co2_setpoint?: InputMaybe<Float8_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_gps?: InputMaybe<Geometry_Comparison_Exp>;
  end_iso?: InputMaybe<String_Comparison_Exp>;
  end_location?: InputMaybe<String_Comparison_Exp>;
  end_long_location?: InputMaybe<String_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  o2_setpoint?: InputMaybe<Float8_Comparison_Exp>;
  start_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  start_gps?: InputMaybe<Geometry_Comparison_Exp>;
  start_iso?: InputMaybe<String_Comparison_Exp>;
  start_location?: InputMaybe<String_Comparison_Exp>;
  start_long_location?: InputMaybe<String_Comparison_Exp>;
  telematic_device?: InputMaybe<Container_Insights_Telematic_Devices_Bool_Exp>;
  telematic_device_id?: InputMaybe<Uuid_Comparison_Exp>;
  temperature_setpoint?: InputMaybe<Float8_Comparison_Exp>;
  tradelane?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "container_insights.bookings" */
export enum Container_Insights_Bookings_Constraint {
  /** unique or primary key constraint on columns "id" */
  BookingsPkey = 'bookings_pkey',
}

/** columns and relationships of "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded = {
  __typename?: 'container_insights_bookings_expanded';
  ca?: Maybe<Scalars['Boolean']['output']>;
  co2_kg?: Maybe<Scalars['numeric']['output']>;
  co2eq_kg?: Maybe<Scalars['numeric']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  end_gps?: Maybe<Scalars['geometry']['output']>;
  end_iso?: Maybe<Scalars['String']['output']>;
  end_location?: Maybe<Scalars['String']['output']>;
  end_long_location?: Maybe<Scalars['String']['output']>;
  ets_euro?: Maybe<Scalars['numeric']['output']>;
  external_booking_id?: Maybe<Scalars['String']['output']>;
  internal_booking_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  legs: Array<Container_Insights_Booking_Legs>;
  /** An aggregate relationship */
  legs_aggregate: Container_Insights_Booking_Legs_Aggregate;
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  reefer?: Maybe<Container_Insights_Reefers_Expanded>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  start_gps?: Maybe<Scalars['geometry']['output']>;
  start_iso?: Maybe<Scalars['String']['output']>;
  start_location?: Maybe<Scalars['String']['output']>;
  start_long_location?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
  temperature_setpoint_id?: Maybe<Scalars['uuid']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_ExpandedLegsArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Booking_Legs_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Booking_Legs_Order_By>>;
  where?: InputMaybe<Container_Insights_Booking_Legs_Bool_Exp>;
};

/** columns and relationships of "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_ExpandedLegs_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Booking_Legs_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Booking_Legs_Order_By>>;
  where?: InputMaybe<Container_Insights_Booking_Legs_Bool_Exp>;
};

/** aggregated selection of "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Aggregate = {
  __typename?: 'container_insights_bookings_expanded_aggregate';
  aggregate?: Maybe<Container_Insights_Bookings_Expanded_Aggregate_Fields>;
  nodes: Array<Container_Insights_Bookings_Expanded>;
};

export type Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Var_Samp>;
};

export type Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Avg = {
  arguments: Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Bool_And = {
  arguments: Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Corr = {
  arguments: Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Corr_Arguments =
  {
    X: Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Corr_Arguments_Columns;
    Y: Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  };

export type Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<
    Array<Container_Insights_Bookings_Expanded_Select_Column>
  >;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Covar_Samp =
  {
    arguments: Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Covar_Samp_Arguments;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
  };

export type Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Covar_Samp_Arguments =
  {
    X: Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
    Y: Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  };

export type Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Max = {
  arguments: Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Min = {
  arguments: Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Stddev_Samp =
  {
    arguments: Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
  };

export type Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Sum = {
  arguments: Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Aggregate_Fields = {
  __typename?: 'container_insights_bookings_expanded_aggregate_fields';
  avg?: Maybe<Container_Insights_Bookings_Expanded_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Bookings_Expanded_Max_Fields>;
  min?: Maybe<Container_Insights_Bookings_Expanded_Min_Fields>;
  stddev?: Maybe<Container_Insights_Bookings_Expanded_Stddev_Fields>;
  stddev_pop?: Maybe<Container_Insights_Bookings_Expanded_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Container_Insights_Bookings_Expanded_Stddev_Samp_Fields>;
  sum?: Maybe<Container_Insights_Bookings_Expanded_Sum_Fields>;
  var_pop?: Maybe<Container_Insights_Bookings_Expanded_Var_Pop_Fields>;
  var_samp?: Maybe<Container_Insights_Bookings_Expanded_Var_Samp_Fields>;
  variance?: Maybe<Container_Insights_Bookings_Expanded_Variance_Fields>;
};

/** aggregate fields of "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<
    Array<Container_Insights_Bookings_Expanded_Select_Column>
  >;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Aggregate_Order_By = {
  avg?: InputMaybe<Container_Insights_Bookings_Expanded_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Container_Insights_Bookings_Expanded_Max_Order_By>;
  min?: InputMaybe<Container_Insights_Bookings_Expanded_Min_Order_By>;
  stddev?: InputMaybe<Container_Insights_Bookings_Expanded_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Container_Insights_Bookings_Expanded_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Container_Insights_Bookings_Expanded_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Container_Insights_Bookings_Expanded_Sum_Order_By>;
  var_pop?: InputMaybe<Container_Insights_Bookings_Expanded_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Container_Insights_Bookings_Expanded_Var_Samp_Order_By>;
  variance?: InputMaybe<Container_Insights_Bookings_Expanded_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Arr_Rel_Insert_Input = {
  data: Array<Container_Insights_Bookings_Expanded_Insert_Input>;
};

/** aggregate avg on columns */
export type Container_Insights_Bookings_Expanded_Avg_Fields = {
  __typename?: 'container_insights_bookings_expanded_avg_fields';
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Avg_Order_By = {
  co2_kg?: InputMaybe<Order_By>;
  co2eq_kg?: InputMaybe<Order_By>;
  ets_euro?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "container_insights.bookings_expanded". All fields are combined with a logical 'AND'. */
export type Container_Insights_Bookings_Expanded_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Bookings_Expanded_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Bookings_Expanded_Bool_Exp>>;
  ca?: InputMaybe<Boolean_Comparison_Exp>;
  co2_kg?: InputMaybe<Numeric_Comparison_Exp>;
  co2eq_kg?: InputMaybe<Numeric_Comparison_Exp>;
  end_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_gps?: InputMaybe<Geometry_Comparison_Exp>;
  end_iso?: InputMaybe<String_Comparison_Exp>;
  end_location?: InputMaybe<String_Comparison_Exp>;
  end_long_location?: InputMaybe<String_Comparison_Exp>;
  ets_euro?: InputMaybe<Numeric_Comparison_Exp>;
  external_booking_id?: InputMaybe<String_Comparison_Exp>;
  internal_booking_id?: InputMaybe<Uuid_Comparison_Exp>;
  legs?: InputMaybe<Container_Insights_Booking_Legs_Bool_Exp>;
  legs_aggregate?: InputMaybe<Container_Insights_Booking_Legs_Aggregate_Bool_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  reefer?: InputMaybe<Container_Insights_Reefers_Expanded_Bool_Exp>;
  reefer_id?: InputMaybe<String_Comparison_Exp>;
  refrigeration_unit_model?: InputMaybe<String_Comparison_Exp>;
  shipping_line?: InputMaybe<String_Comparison_Exp>;
  start_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  start_gps?: InputMaybe<Geometry_Comparison_Exp>;
  start_iso?: InputMaybe<String_Comparison_Exp>;
  start_location?: InputMaybe<String_Comparison_Exp>;
  start_long_location?: InputMaybe<String_Comparison_Exp>;
  telematic_device_id?: InputMaybe<Uuid_Comparison_Exp>;
  temperature_setpoint?: InputMaybe<Float8_Comparison_Exp>;
  temperature_setpoint_id?: InputMaybe<Uuid_Comparison_Exp>;
  tradelane?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Insert_Input = {
  ca?: InputMaybe<Scalars['Boolean']['input']>;
  co2_kg?: InputMaybe<Scalars['numeric']['input']>;
  co2eq_kg?: InputMaybe<Scalars['numeric']['input']>;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  end_gps?: InputMaybe<Scalars['geometry']['input']>;
  end_iso?: InputMaybe<Scalars['String']['input']>;
  end_location?: InputMaybe<Scalars['String']['input']>;
  end_long_location?: InputMaybe<Scalars['String']['input']>;
  ets_euro?: InputMaybe<Scalars['numeric']['input']>;
  external_booking_id?: InputMaybe<Scalars['String']['input']>;
  internal_booking_id?: InputMaybe<Scalars['uuid']['input']>;
  legs?: InputMaybe<Container_Insights_Booking_Legs_Arr_Rel_Insert_Input>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  reefer?: InputMaybe<Container_Insights_Reefers_Expanded_Obj_Rel_Insert_Input>;
  reefer_id?: InputMaybe<Scalars['String']['input']>;
  refrigeration_unit_model?: InputMaybe<Scalars['String']['input']>;
  shipping_line?: InputMaybe<Scalars['String']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  start_gps?: InputMaybe<Scalars['geometry']['input']>;
  start_iso?: InputMaybe<Scalars['String']['input']>;
  start_location?: InputMaybe<Scalars['String']['input']>;
  start_long_location?: InputMaybe<Scalars['String']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  temperature_setpoint?: InputMaybe<Scalars['float8']['input']>;
  temperature_setpoint_id?: InputMaybe<Scalars['uuid']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Container_Insights_Bookings_Expanded_Max_Fields = {
  __typename?: 'container_insights_bookings_expanded_max_fields';
  co2_kg?: Maybe<Scalars['numeric']['output']>;
  co2eq_kg?: Maybe<Scalars['numeric']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  end_iso?: Maybe<Scalars['String']['output']>;
  end_location?: Maybe<Scalars['String']['output']>;
  end_long_location?: Maybe<Scalars['String']['output']>;
  ets_euro?: Maybe<Scalars['numeric']['output']>;
  external_booking_id?: Maybe<Scalars['String']['output']>;
  internal_booking_id?: Maybe<Scalars['uuid']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  start_iso?: Maybe<Scalars['String']['output']>;
  start_location?: Maybe<Scalars['String']['output']>;
  start_long_location?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
  temperature_setpoint_id?: Maybe<Scalars['uuid']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Max_Order_By = {
  co2_kg?: InputMaybe<Order_By>;
  co2eq_kg?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  end_iso?: InputMaybe<Order_By>;
  end_location?: InputMaybe<Order_By>;
  end_long_location?: InputMaybe<Order_By>;
  ets_euro?: InputMaybe<Order_By>;
  external_booking_id?: InputMaybe<Order_By>;
  internal_booking_id?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  reefer_id?: InputMaybe<Order_By>;
  refrigeration_unit_model?: InputMaybe<Order_By>;
  shipping_line?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  start_iso?: InputMaybe<Order_By>;
  start_location?: InputMaybe<Order_By>;
  start_long_location?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
  temperature_setpoint_id?: InputMaybe<Order_By>;
  tradelane?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Container_Insights_Bookings_Expanded_Min_Fields = {
  __typename?: 'container_insights_bookings_expanded_min_fields';
  co2_kg?: Maybe<Scalars['numeric']['output']>;
  co2eq_kg?: Maybe<Scalars['numeric']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  end_iso?: Maybe<Scalars['String']['output']>;
  end_location?: Maybe<Scalars['String']['output']>;
  end_long_location?: Maybe<Scalars['String']['output']>;
  ets_euro?: Maybe<Scalars['numeric']['output']>;
  external_booking_id?: Maybe<Scalars['String']['output']>;
  internal_booking_id?: Maybe<Scalars['uuid']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  start_iso?: Maybe<Scalars['String']['output']>;
  start_location?: Maybe<Scalars['String']['output']>;
  start_long_location?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
  temperature_setpoint_id?: Maybe<Scalars['uuid']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Min_Order_By = {
  co2_kg?: InputMaybe<Order_By>;
  co2eq_kg?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  end_iso?: InputMaybe<Order_By>;
  end_location?: InputMaybe<Order_By>;
  end_long_location?: InputMaybe<Order_By>;
  ets_euro?: InputMaybe<Order_By>;
  external_booking_id?: InputMaybe<Order_By>;
  internal_booking_id?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  reefer_id?: InputMaybe<Order_By>;
  refrigeration_unit_model?: InputMaybe<Order_By>;
  shipping_line?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  start_iso?: InputMaybe<Order_By>;
  start_location?: InputMaybe<Order_By>;
  start_long_location?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
  temperature_setpoint_id?: InputMaybe<Order_By>;
  tradelane?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Obj_Rel_Insert_Input = {
  data: Container_Insights_Bookings_Expanded_Insert_Input;
};

/** Ordering options when selecting data from "container_insights.bookings_expanded". */
export type Container_Insights_Bookings_Expanded_Order_By = {
  ca?: InputMaybe<Order_By>;
  co2_kg?: InputMaybe<Order_By>;
  co2eq_kg?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  end_gps?: InputMaybe<Order_By>;
  end_iso?: InputMaybe<Order_By>;
  end_location?: InputMaybe<Order_By>;
  end_long_location?: InputMaybe<Order_By>;
  ets_euro?: InputMaybe<Order_By>;
  external_booking_id?: InputMaybe<Order_By>;
  internal_booking_id?: InputMaybe<Order_By>;
  legs_aggregate?: InputMaybe<Container_Insights_Booking_Legs_Aggregate_Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  reefer?: InputMaybe<Container_Insights_Reefers_Expanded_Order_By>;
  reefer_id?: InputMaybe<Order_By>;
  refrigeration_unit_model?: InputMaybe<Order_By>;
  shipping_line?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  start_gps?: InputMaybe<Order_By>;
  start_iso?: InputMaybe<Order_By>;
  start_location?: InputMaybe<Order_By>;
  start_long_location?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
  temperature_setpoint_id?: InputMaybe<Order_By>;
  tradelane?: InputMaybe<Order_By>;
};

/** select columns of table "container_insights.bookings_expanded" */
export enum Container_Insights_Bookings_Expanded_Select_Column {
  /** column name */
  Ca = 'ca',
  /** column name */
  Co2Kg = 'co2_kg',
  /** column name */
  Co2eqKg = 'co2eq_kg',
  /** column name */
  EndDatetime = 'end_datetime',
  /** column name */
  EndGps = 'end_gps',
  /** column name */
  EndIso = 'end_iso',
  /** column name */
  EndLocation = 'end_location',
  /** column name */
  EndLongLocation = 'end_long_location',
  /** column name */
  EtsEuro = 'ets_euro',
  /** column name */
  ExternalBookingId = 'external_booking_id',
  /** column name */
  InternalBookingId = 'internal_booking_id',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  ReeferId = 'reefer_id',
  /** column name */
  RefrigerationUnitModel = 'refrigeration_unit_model',
  /** column name */
  ShippingLine = 'shipping_line',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  StartGps = 'start_gps',
  /** column name */
  StartIso = 'start_iso',
  /** column name */
  StartLocation = 'start_location',
  /** column name */
  StartLongLocation = 'start_long_location',
  /** column name */
  TelematicDeviceId = 'telematic_device_id',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
  /** column name */
  TemperatureSetpointId = 'temperature_setpoint_id',
  /** column name */
  Tradelane = 'tradelane',
}

/** select "container_insights_bookings_expanded_aggregate_bool_exp_avg_arguments_columns" columns of table "container_insights.bookings_expanded" */
export enum Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_bookings_expanded_aggregate_bool_exp_bool_and_arguments_columns" columns of table "container_insights.bookings_expanded" */
export enum Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Ca = 'ca',
}

/** select "container_insights_bookings_expanded_aggregate_bool_exp_bool_or_arguments_columns" columns of table "container_insights.bookings_expanded" */
export enum Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Ca = 'ca',
}

/** select "container_insights_bookings_expanded_aggregate_bool_exp_corr_arguments_columns" columns of table "container_insights.bookings_expanded" */
export enum Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_bookings_expanded_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "container_insights.bookings_expanded" */
export enum Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_bookings_expanded_aggregate_bool_exp_max_arguments_columns" columns of table "container_insights.bookings_expanded" */
export enum Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_bookings_expanded_aggregate_bool_exp_min_arguments_columns" columns of table "container_insights.bookings_expanded" */
export enum Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_bookings_expanded_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "container_insights.bookings_expanded" */
export enum Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_bookings_expanded_aggregate_bool_exp_sum_arguments_columns" columns of table "container_insights.bookings_expanded" */
export enum Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_bookings_expanded_aggregate_bool_exp_var_samp_arguments_columns" columns of table "container_insights.bookings_expanded" */
export enum Container_Insights_Bookings_Expanded_Select_Column_Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** aggregate stddev on columns */
export type Container_Insights_Bookings_Expanded_Stddev_Fields = {
  __typename?: 'container_insights_bookings_expanded_stddev_fields';
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Stddev_Order_By = {
  co2_kg?: InputMaybe<Order_By>;
  co2eq_kg?: InputMaybe<Order_By>;
  ets_euro?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Container_Insights_Bookings_Expanded_Stddev_Pop_Fields = {
  __typename?: 'container_insights_bookings_expanded_stddev_pop_fields';
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Stddev_Pop_Order_By = {
  co2_kg?: InputMaybe<Order_By>;
  co2eq_kg?: InputMaybe<Order_By>;
  ets_euro?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Container_Insights_Bookings_Expanded_Stddev_Samp_Fields = {
  __typename?: 'container_insights_bookings_expanded_stddev_samp_fields';
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Stddev_Samp_Order_By = {
  co2_kg?: InputMaybe<Order_By>;
  co2eq_kg?: InputMaybe<Order_By>;
  ets_euro?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "container_insights_bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Bookings_Expanded_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Bookings_Expanded_Stream_Cursor_Value_Input = {
  ca?: InputMaybe<Scalars['Boolean']['input']>;
  co2_kg?: InputMaybe<Scalars['numeric']['input']>;
  co2eq_kg?: InputMaybe<Scalars['numeric']['input']>;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  end_gps?: InputMaybe<Scalars['geometry']['input']>;
  end_iso?: InputMaybe<Scalars['String']['input']>;
  end_location?: InputMaybe<Scalars['String']['input']>;
  end_long_location?: InputMaybe<Scalars['String']['input']>;
  ets_euro?: InputMaybe<Scalars['numeric']['input']>;
  external_booking_id?: InputMaybe<Scalars['String']['input']>;
  internal_booking_id?: InputMaybe<Scalars['uuid']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  reefer_id?: InputMaybe<Scalars['String']['input']>;
  refrigeration_unit_model?: InputMaybe<Scalars['String']['input']>;
  shipping_line?: InputMaybe<Scalars['String']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  start_gps?: InputMaybe<Scalars['geometry']['input']>;
  start_iso?: InputMaybe<Scalars['String']['input']>;
  start_location?: InputMaybe<Scalars['String']['input']>;
  start_long_location?: InputMaybe<Scalars['String']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  temperature_setpoint?: InputMaybe<Scalars['float8']['input']>;
  temperature_setpoint_id?: InputMaybe<Scalars['uuid']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Container_Insights_Bookings_Expanded_Sum_Fields = {
  __typename?: 'container_insights_bookings_expanded_sum_fields';
  co2_kg?: Maybe<Scalars['numeric']['output']>;
  co2eq_kg?: Maybe<Scalars['numeric']['output']>;
  ets_euro?: Maybe<Scalars['numeric']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Sum_Order_By = {
  co2_kg?: InputMaybe<Order_By>;
  co2eq_kg?: InputMaybe<Order_By>;
  ets_euro?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Container_Insights_Bookings_Expanded_Var_Pop_Fields = {
  __typename?: 'container_insights_bookings_expanded_var_pop_fields';
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Var_Pop_Order_By = {
  co2_kg?: InputMaybe<Order_By>;
  co2eq_kg?: InputMaybe<Order_By>;
  ets_euro?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Container_Insights_Bookings_Expanded_Var_Samp_Fields = {
  __typename?: 'container_insights_bookings_expanded_var_samp_fields';
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Var_Samp_Order_By = {
  co2_kg?: InputMaybe<Order_By>;
  co2eq_kg?: InputMaybe<Order_By>;
  ets_euro?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Container_Insights_Bookings_Expanded_Variance_Fields = {
  __typename?: 'container_insights_bookings_expanded_variance_fields';
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "container_insights.bookings_expanded" */
export type Container_Insights_Bookings_Expanded_Variance_Order_By = {
  co2_kg?: InputMaybe<Order_By>;
  co2eq_kg?: InputMaybe<Order_By>;
  ets_euro?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "container_insights.bookings" */
export type Container_Insights_Bookings_Inc_Input = {
  co2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  o2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  temperature_setpoint?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "container_insights.bookings" */
export type Container_Insights_Bookings_Insert_Input = {
  co2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  end_gps?: InputMaybe<Scalars['geometry']['input']>;
  end_iso?: InputMaybe<Scalars['String']['input']>;
  end_location?: InputMaybe<Scalars['String']['input']>;
  end_long_location?: InputMaybe<Scalars['String']['input']>;
  /** Booking reference from the shipping line */
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  o2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  start_gps?: InputMaybe<Scalars['geometry']['input']>;
  start_iso?: InputMaybe<Scalars['String']['input']>;
  start_location?: InputMaybe<Scalars['String']['input']>;
  start_long_location?: InputMaybe<Scalars['String']['input']>;
  telematic_device?: InputMaybe<Container_Insights_Telematic_Devices_Obj_Rel_Insert_Input>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  temperature_setpoint?: InputMaybe<Scalars['float8']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Container_Insights_Bookings_Max_Fields = {
  __typename?: 'container_insights_bookings_max_fields';
  co2_setpoint?: Maybe<Scalars['float8']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  end_iso?: Maybe<Scalars['String']['output']>;
  end_location?: Maybe<Scalars['String']['output']>;
  end_long_location?: Maybe<Scalars['String']['output']>;
  /** Booking reference from the shipping line */
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  o2_setpoint?: Maybe<Scalars['float8']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  start_iso?: Maybe<Scalars['String']['output']>;
  start_location?: Maybe<Scalars['String']['output']>;
  start_long_location?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "container_insights.bookings" */
export type Container_Insights_Bookings_Max_Order_By = {
  co2_setpoint?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  end_iso?: InputMaybe<Order_By>;
  end_location?: InputMaybe<Order_By>;
  end_long_location?: InputMaybe<Order_By>;
  /** Booking reference from the shipping line */
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  start_iso?: InputMaybe<Order_By>;
  start_location?: InputMaybe<Order_By>;
  start_long_location?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
  tradelane?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Container_Insights_Bookings_Min_Fields = {
  __typename?: 'container_insights_bookings_min_fields';
  co2_setpoint?: Maybe<Scalars['float8']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  end_iso?: Maybe<Scalars['String']['output']>;
  end_location?: Maybe<Scalars['String']['output']>;
  end_long_location?: Maybe<Scalars['String']['output']>;
  /** Booking reference from the shipping line */
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  o2_setpoint?: Maybe<Scalars['float8']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  start_iso?: Maybe<Scalars['String']['output']>;
  start_location?: Maybe<Scalars['String']['output']>;
  start_long_location?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "container_insights.bookings" */
export type Container_Insights_Bookings_Min_Order_By = {
  co2_setpoint?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  end_iso?: InputMaybe<Order_By>;
  end_location?: InputMaybe<Order_By>;
  end_long_location?: InputMaybe<Order_By>;
  /** Booking reference from the shipping line */
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  start_iso?: InputMaybe<Order_By>;
  start_location?: InputMaybe<Order_By>;
  start_long_location?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
  tradelane?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "container_insights.bookings" */
export type Container_Insights_Bookings_Mutation_Response = {
  __typename?: 'container_insights_bookings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Container_Insights_Bookings>;
};

/** on_conflict condition type for table "container_insights.bookings" */
export type Container_Insights_Bookings_On_Conflict = {
  constraint: Container_Insights_Bookings_Constraint;
  update_columns?: Array<Container_Insights_Bookings_Update_Column>;
  where?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
};

/** Ordering options when selecting data from "container_insights.bookings". */
export type Container_Insights_Bookings_Order_By = {
  co2_setpoint?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  end_gps?: InputMaybe<Order_By>;
  end_iso?: InputMaybe<Order_By>;
  end_location?: InputMaybe<Order_By>;
  end_long_location?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  start_gps?: InputMaybe<Order_By>;
  start_iso?: InputMaybe<Order_By>;
  start_location?: InputMaybe<Order_By>;
  start_long_location?: InputMaybe<Order_By>;
  telematic_device?: InputMaybe<Container_Insights_Telematic_Devices_Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
  tradelane?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: container_insights.bookings */
export type Container_Insights_Bookings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "container_insights.bookings" */
export enum Container_Insights_Bookings_Select_Column {
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDatetime = 'end_datetime',
  /** column name */
  EndGps = 'end_gps',
  /** column name */
  EndIso = 'end_iso',
  /** column name */
  EndLocation = 'end_location',
  /** column name */
  EndLongLocation = 'end_long_location',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  StartGps = 'start_gps',
  /** column name */
  StartIso = 'start_iso',
  /** column name */
  StartLocation = 'start_location',
  /** column name */
  StartLongLocation = 'start_long_location',
  /** column name */
  TelematicDeviceId = 'telematic_device_id',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
  /** column name */
  Tradelane = 'tradelane',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "container_insights_bookings_aggregate_bool_exp_avg_arguments_columns" columns of table "container_insights.bookings" */
export enum Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_bookings_aggregate_bool_exp_corr_arguments_columns" columns of table "container_insights.bookings" */
export enum Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_bookings_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "container_insights.bookings" */
export enum Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_bookings_aggregate_bool_exp_max_arguments_columns" columns of table "container_insights.bookings" */
export enum Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_bookings_aggregate_bool_exp_min_arguments_columns" columns of table "container_insights.bookings" */
export enum Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_bookings_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "container_insights.bookings" */
export enum Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_bookings_aggregate_bool_exp_sum_arguments_columns" columns of table "container_insights.bookings" */
export enum Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_bookings_aggregate_bool_exp_var_samp_arguments_columns" columns of table "container_insights.bookings" */
export enum Container_Insights_Bookings_Select_Column_Container_Insights_Bookings_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** input type for updating data in table "container_insights.bookings" */
export type Container_Insights_Bookings_Set_Input = {
  co2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  end_gps?: InputMaybe<Scalars['geometry']['input']>;
  end_iso?: InputMaybe<Scalars['String']['input']>;
  end_location?: InputMaybe<Scalars['String']['input']>;
  end_long_location?: InputMaybe<Scalars['String']['input']>;
  /** Booking reference from the shipping line */
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  o2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  start_gps?: InputMaybe<Scalars['geometry']['input']>;
  start_iso?: InputMaybe<Scalars['String']['input']>;
  start_location?: InputMaybe<Scalars['String']['input']>;
  start_long_location?: InputMaybe<Scalars['String']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  temperature_setpoint?: InputMaybe<Scalars['float8']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Container_Insights_Bookings_Stddev_Fields = {
  __typename?: 'container_insights_bookings_stddev_fields';
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "container_insights.bookings" */
export type Container_Insights_Bookings_Stddev_Order_By = {
  co2_setpoint?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Container_Insights_Bookings_Stddev_Pop_Fields = {
  __typename?: 'container_insights_bookings_stddev_pop_fields';
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "container_insights.bookings" */
export type Container_Insights_Bookings_Stddev_Pop_Order_By = {
  co2_setpoint?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Container_Insights_Bookings_Stddev_Samp_Fields = {
  __typename?: 'container_insights_bookings_stddev_samp_fields';
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "container_insights.bookings" */
export type Container_Insights_Bookings_Stddev_Samp_Order_By = {
  co2_setpoint?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "container_insights_bookings" */
export type Container_Insights_Bookings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Bookings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Bookings_Stream_Cursor_Value_Input = {
  co2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  end_gps?: InputMaybe<Scalars['geometry']['input']>;
  end_iso?: InputMaybe<Scalars['String']['input']>;
  end_location?: InputMaybe<Scalars['String']['input']>;
  end_long_location?: InputMaybe<Scalars['String']['input']>;
  /** Booking reference from the shipping line */
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  o2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  start_gps?: InputMaybe<Scalars['geometry']['input']>;
  start_iso?: InputMaybe<Scalars['String']['input']>;
  start_location?: InputMaybe<Scalars['String']['input']>;
  start_long_location?: InputMaybe<Scalars['String']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  temperature_setpoint?: InputMaybe<Scalars['float8']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Container_Insights_Bookings_Sum_Fields = {
  __typename?: 'container_insights_bookings_sum_fields';
  co2_setpoint?: Maybe<Scalars['float8']['output']>;
  o2_setpoint?: Maybe<Scalars['float8']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "container_insights.bookings" */
export type Container_Insights_Bookings_Sum_Order_By = {
  co2_setpoint?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** update columns of table "container_insights.bookings" */
export enum Container_Insights_Bookings_Update_Column {
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDatetime = 'end_datetime',
  /** column name */
  EndGps = 'end_gps',
  /** column name */
  EndIso = 'end_iso',
  /** column name */
  EndLocation = 'end_location',
  /** column name */
  EndLongLocation = 'end_long_location',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  StartGps = 'start_gps',
  /** column name */
  StartIso = 'start_iso',
  /** column name */
  StartLocation = 'start_location',
  /** column name */
  StartLongLocation = 'start_long_location',
  /** column name */
  TelematicDeviceId = 'telematic_device_id',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
  /** column name */
  Tradelane = 'tradelane',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Container_Insights_Bookings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Container_Insights_Bookings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Container_Insights_Bookings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Container_Insights_Bookings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Container_Insights_Bookings_Var_Pop_Fields = {
  __typename?: 'container_insights_bookings_var_pop_fields';
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "container_insights.bookings" */
export type Container_Insights_Bookings_Var_Pop_Order_By = {
  co2_setpoint?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Container_Insights_Bookings_Var_Samp_Fields = {
  __typename?: 'container_insights_bookings_var_samp_fields';
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "container_insights.bookings" */
export type Container_Insights_Bookings_Var_Samp_Order_By = {
  co2_setpoint?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Container_Insights_Bookings_Variance_Fields = {
  __typename?: 'container_insights_bookings_variance_fields';
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "container_insights.bookings" */
export type Container_Insights_Bookings_Variance_Order_By = {
  co2_setpoint?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** columns and relationships of "container_insights.controller_models" */
export type Container_Insights_Controller_Models = {
  __typename?: 'container_insights_controller_models';
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  /** An object relationship */
  manufacturer?: Maybe<Container_Insights_Manufacturers>;
  manufacturer_id?: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  refrigeration_unit_models: Array<Container_Insights_Refrigeration_Unit_Models>;
  /** An aggregate relationship */
  refrigeration_unit_models_aggregate: Container_Insights_Refrigeration_Unit_Models_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "container_insights.controller_models" */
export type Container_Insights_Controller_ModelsRefrigeration_Unit_ModelsArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Refrigeration_Unit_Models_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Refrigeration_Unit_Models_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
  };

/** columns and relationships of "container_insights.controller_models" */
export type Container_Insights_Controller_ModelsRefrigeration_Unit_Models_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Refrigeration_Unit_Models_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Refrigeration_Unit_Models_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
  };

/** aggregated selection of "container_insights.controller_models" */
export type Container_Insights_Controller_Models_Aggregate = {
  __typename?: 'container_insights_controller_models_aggregate';
  aggregate?: Maybe<Container_Insights_Controller_Models_Aggregate_Fields>;
  nodes: Array<Container_Insights_Controller_Models>;
};

export type Container_Insights_Controller_Models_Aggregate_Bool_Exp = {
  count?: InputMaybe<Container_Insights_Controller_Models_Aggregate_Bool_Exp_Count>;
};

export type Container_Insights_Controller_Models_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<
    Array<Container_Insights_Controller_Models_Select_Column>
  >;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Controller_Models_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "container_insights.controller_models" */
export type Container_Insights_Controller_Models_Aggregate_Fields = {
  __typename?: 'container_insights_controller_models_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Controller_Models_Max_Fields>;
  min?: Maybe<Container_Insights_Controller_Models_Min_Fields>;
};

/** aggregate fields of "container_insights.controller_models" */
export type Container_Insights_Controller_Models_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<
    Array<Container_Insights_Controller_Models_Select_Column>
  >;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "container_insights.controller_models" */
export type Container_Insights_Controller_Models_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Container_Insights_Controller_Models_Max_Order_By>;
  min?: InputMaybe<Container_Insights_Controller_Models_Min_Order_By>;
};

/** input type for inserting array relation for remote table "container_insights.controller_models" */
export type Container_Insights_Controller_Models_Arr_Rel_Insert_Input = {
  data: Array<Container_Insights_Controller_Models_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Container_Insights_Controller_Models_On_Conflict>;
};

/** Boolean expression to filter rows from the table "container_insights.controller_models". All fields are combined with a logical 'AND'. */
export type Container_Insights_Controller_Models_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Controller_Models_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Controller_Models_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Controller_Models_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  manufacturer?: InputMaybe<Container_Insights_Manufacturers_Bool_Exp>;
  manufacturer_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  refrigeration_unit_models?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
  refrigeration_unit_models_aggregate?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "container_insights.controller_models" */
export enum Container_Insights_Controller_Models_Constraint {
  /** unique or primary key constraint on columns "name" */
  ControllerModelsNameKey = 'controller_models_name_key',
  /** unique or primary key constraint on columns "id" */
  ControllerModelsPkey = 'controller_models_pkey',
}

/** input type for inserting data into table "container_insights.controller_models" */
export type Container_Insights_Controller_Models_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Container_Insights_Manufacturers_Obj_Rel_Insert_Input>;
  manufacturer_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  refrigeration_unit_models?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Container_Insights_Controller_Models_Max_Fields = {
  __typename?: 'container_insights_controller_models_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  manufacturer_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "container_insights.controller_models" */
export type Container_Insights_Controller_Models_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  manufacturer_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Container_Insights_Controller_Models_Min_Fields = {
  __typename?: 'container_insights_controller_models_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  manufacturer_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "container_insights.controller_models" */
export type Container_Insights_Controller_Models_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  manufacturer_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "container_insights.controller_models" */
export type Container_Insights_Controller_Models_Mutation_Response = {
  __typename?: 'container_insights_controller_models_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Container_Insights_Controller_Models>;
};

/** input type for inserting object relation for remote table "container_insights.controller_models" */
export type Container_Insights_Controller_Models_Obj_Rel_Insert_Input = {
  data: Container_Insights_Controller_Models_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Container_Insights_Controller_Models_On_Conflict>;
};

/** on_conflict condition type for table "container_insights.controller_models" */
export type Container_Insights_Controller_Models_On_Conflict = {
  constraint: Container_Insights_Controller_Models_Constraint;
  update_columns?: Array<Container_Insights_Controller_Models_Update_Column>;
  where?: InputMaybe<Container_Insights_Controller_Models_Bool_Exp>;
};

/** Ordering options when selecting data from "container_insights.controller_models". */
export type Container_Insights_Controller_Models_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Container_Insights_Manufacturers_Order_By>;
  manufacturer_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  refrigeration_unit_models_aggregate?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: container_insights.controller_models */
export type Container_Insights_Controller_Models_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "container_insights.controller_models" */
export enum Container_Insights_Controller_Models_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  ManufacturerId = 'manufacturer_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "container_insights.controller_models" */
export type Container_Insights_Controller_Models_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  manufacturer_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "container_insights_controller_models" */
export type Container_Insights_Controller_Models_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Controller_Models_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Controller_Models_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  manufacturer_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "container_insights.controller_models" */
export enum Container_Insights_Controller_Models_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  ManufacturerId = 'manufacturer_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Container_Insights_Controller_Models_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Container_Insights_Controller_Models_Set_Input>;
  /** filter the rows which have to be updated */
  where: Container_Insights_Controller_Models_Bool_Exp;
};

/** columns and relationships of "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage = {
  __typename?: 'container_insights_energy_usage';
  active_energy_kWh: Scalars['float8']['output'];
  active_power_kW: Scalars['float8']['output'];
  apparent_energy_kVAh: Scalars['float8']['output'];
  apparent_power_kVA: Scalars['float8']['output'];
  co2_return?: Maybe<Scalars['float8']['output']>;
  co2_setpoint?: Maybe<Scalars['float8']['output']>;
  created_at: Scalars['timestamptz']['output'];
  datetime: Scalars['timestamptz']['output'];
  gps?: Maybe<Scalars['geometry']['output']>;
  local_datetime: Scalars['timestamp']['output'];
  mode: Scalars['reefer_mode']['output'];
  o2_return?: Maybe<Scalars['float8']['output']>;
  o2_setpoint?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  telematic_device: Container_Insights_Telematic_Devices;
  telematic_device_id: Scalars['uuid']['output'];
  temperature_return?: Maybe<Scalars['float8']['output']>;
  temperature_setpoint: Scalars['float8']['output'];
};

/** aggregated selection of "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Aggregate = {
  __typename?: 'container_insights_energy_usage_aggregate';
  aggregate?: Maybe<Container_Insights_Energy_Usage_Aggregate_Fields>;
  nodes: Array<Container_Insights_Energy_Usage>;
};

export type Container_Insights_Energy_Usage_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Var_Samp>;
};

export type Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Avg = {
  arguments: Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Corr = {
  arguments: Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Corr_Arguments =
  {
    X: Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Corr_Arguments_Columns;
    Y: Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  };

export type Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Container_Insights_Energy_Usage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Covar_Samp_Arguments =
  {
    X: Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
    Y: Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  };

export type Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Max = {
  arguments: Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Min = {
  arguments: Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Sum = {
  arguments: Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Aggregate_Fields = {
  __typename?: 'container_insights_energy_usage_aggregate_fields';
  avg?: Maybe<Container_Insights_Energy_Usage_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Energy_Usage_Max_Fields>;
  min?: Maybe<Container_Insights_Energy_Usage_Min_Fields>;
  stddev?: Maybe<Container_Insights_Energy_Usage_Stddev_Fields>;
  stddev_pop?: Maybe<Container_Insights_Energy_Usage_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Container_Insights_Energy_Usage_Stddev_Samp_Fields>;
  sum?: Maybe<Container_Insights_Energy_Usage_Sum_Fields>;
  var_pop?: Maybe<Container_Insights_Energy_Usage_Var_Pop_Fields>;
  var_samp?: Maybe<Container_Insights_Energy_Usage_Var_Samp_Fields>;
  variance?: Maybe<Container_Insights_Energy_Usage_Variance_Fields>;
};

/** aggregate fields of "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Container_Insights_Energy_Usage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Aggregate_Order_By = {
  avg?: InputMaybe<Container_Insights_Energy_Usage_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Container_Insights_Energy_Usage_Max_Order_By>;
  min?: InputMaybe<Container_Insights_Energy_Usage_Min_Order_By>;
  stddev?: InputMaybe<Container_Insights_Energy_Usage_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Container_Insights_Energy_Usage_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Container_Insights_Energy_Usage_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Container_Insights_Energy_Usage_Sum_Order_By>;
  var_pop?: InputMaybe<Container_Insights_Energy_Usage_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Container_Insights_Energy_Usage_Var_Samp_Order_By>;
  variance?: InputMaybe<Container_Insights_Energy_Usage_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Arr_Rel_Insert_Input = {
  data: Array<Container_Insights_Energy_Usage_Insert_Input>;
};

/** aggregate avg on columns */
export type Container_Insights_Energy_Usage_Avg_Fields = {
  __typename?: 'container_insights_energy_usage_avg_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_return?: Maybe<Scalars['Float']['output']>;
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  o2_return?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  temperature_return?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Avg_Order_By = {
  active_energy_kWh?: InputMaybe<Order_By>;
  active_power_kW?: InputMaybe<Order_By>;
  apparent_energy_kVAh?: InputMaybe<Order_By>;
  apparent_power_kVA?: InputMaybe<Order_By>;
  co2_return?: InputMaybe<Order_By>;
  co2_setpoint?: InputMaybe<Order_By>;
  o2_return?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  temperature_return?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "container_insights.energy_usage". All fields are combined with a logical 'AND'. */
export type Container_Insights_Energy_Usage_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Energy_Usage_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Energy_Usage_Bool_Exp>>;
  active_energy_kWh?: InputMaybe<Float8_Comparison_Exp>;
  active_power_kW?: InputMaybe<Float8_Comparison_Exp>;
  apparent_energy_kVAh?: InputMaybe<Float8_Comparison_Exp>;
  apparent_power_kVA?: InputMaybe<Float8_Comparison_Exp>;
  co2_return?: InputMaybe<Float8_Comparison_Exp>;
  co2_setpoint?: InputMaybe<Float8_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  gps?: InputMaybe<Geometry_Comparison_Exp>;
  local_datetime?: InputMaybe<Timestamp_Comparison_Exp>;
  mode?: InputMaybe<Reefer_Mode_Comparison_Exp>;
  o2_return?: InputMaybe<Float8_Comparison_Exp>;
  o2_setpoint?: InputMaybe<Float8_Comparison_Exp>;
  telematic_device?: InputMaybe<Container_Insights_Telematic_Devices_Bool_Exp>;
  telematic_device_id?: InputMaybe<Uuid_Comparison_Exp>;
  temperature_return?: InputMaybe<Float8_Comparison_Exp>;
  temperature_setpoint?: InputMaybe<Float8_Comparison_Exp>;
};

/** columns and relationships of "container_insights.energy_usage_expanded" */
export type Container_Insights_Energy_Usage_Expanded = {
  __typename?: 'container_insights_energy_usage_expanded';
  active_energy_kWh?: Maybe<Scalars['float8']['output']>;
  active_power_kW?: Maybe<Scalars['float8']['output']>;
  age?: Maybe<Scalars['numeric']['output']>;
  age_id?: Maybe<Scalars['uuid']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['float8']['output']>;
  apparent_power_kVA?: Maybe<Scalars['float8']['output']>;
  ca?: Maybe<Scalars['Boolean']['output']>;
  co2_kg?: Maybe<Scalars['numeric']['output']>;
  co2eq_kg?: Maybe<Scalars['numeric']['output']>;
  co2eq_kg_per_hour?: Maybe<Scalars['numeric']['output']>;
  datetime?: Maybe<Scalars['timestamptz']['output']>;
  detailed_transport_mode?: Maybe<Scalars['detailed_transport_mode']['output']>;
  ets_euro?: Maybe<Scalars['numeric']['output']>;
  genset_apparent_energy_to_co2?: Maybe<Scalars['numeric']['output']>;
  genset_apparent_energy_to_co2eq?: Maybe<Scalars['numeric']['output']>;
  grid_active_energy_to_co2eq?: Maybe<Scalars['float8']['output']>;
  local_datetime?: Maybe<Scalars['timestamp']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['reefer_mode']['output']>;
  /** An object relationship */
  reefer?: Maybe<Container_Insights_Reefers>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  start_iso?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
  temperature_setpoint_id?: Maybe<Scalars['uuid']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
  transport_mode?: Maybe<Scalars['transport_mode']['output']>;
};

/** aggregated selection of "container_insights.energy_usage_expanded" */
export type Container_Insights_Energy_Usage_Expanded_Aggregate = {
  __typename?: 'container_insights_energy_usage_expanded_aggregate';
  aggregate?: Maybe<Container_Insights_Energy_Usage_Expanded_Aggregate_Fields>;
  nodes: Array<Container_Insights_Energy_Usage_Expanded>;
};

/** aggregate fields of "container_insights.energy_usage_expanded" */
export type Container_Insights_Energy_Usage_Expanded_Aggregate_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_aggregate_fields';
  avg?: Maybe<Container_Insights_Energy_Usage_Expanded_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Energy_Usage_Expanded_Max_Fields>;
  min?: Maybe<Container_Insights_Energy_Usage_Expanded_Min_Fields>;
  stddev?: Maybe<Container_Insights_Energy_Usage_Expanded_Stddev_Fields>;
  stddev_pop?: Maybe<Container_Insights_Energy_Usage_Expanded_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Container_Insights_Energy_Usage_Expanded_Stddev_Samp_Fields>;
  sum?: Maybe<Container_Insights_Energy_Usage_Expanded_Sum_Fields>;
  var_pop?: Maybe<Container_Insights_Energy_Usage_Expanded_Var_Pop_Fields>;
  var_samp?: Maybe<Container_Insights_Energy_Usage_Expanded_Var_Samp_Fields>;
  variance?: Maybe<Container_Insights_Energy_Usage_Expanded_Variance_Fields>;
};

/** aggregate fields of "container_insights.energy_usage_expanded" */
export type Container_Insights_Energy_Usage_Expanded_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Container_Insights_Energy_Usage_Expanded_Select_Column>
    >;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
  };

/** aggregate avg on columns */
export type Container_Insights_Energy_Usage_Expanded_Avg_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_avg_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  age?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg_per_hour?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  genset_apparent_energy_to_co2?: Maybe<Scalars['Float']['output']>;
  genset_apparent_energy_to_co2eq?: Maybe<Scalars['Float']['output']>;
  grid_active_energy_to_co2eq?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "container_insights.energy_usage_expanded". All fields are combined with a logical 'AND'. */
export type Container_Insights_Energy_Usage_Expanded_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Energy_Usage_Expanded_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_Bool_Exp>>;
  active_energy_kWh?: InputMaybe<Float8_Comparison_Exp>;
  active_power_kW?: InputMaybe<Float8_Comparison_Exp>;
  age?: InputMaybe<Numeric_Comparison_Exp>;
  age_id?: InputMaybe<Uuid_Comparison_Exp>;
  apparent_energy_kVAh?: InputMaybe<Float8_Comparison_Exp>;
  apparent_power_kVA?: InputMaybe<Float8_Comparison_Exp>;
  ca?: InputMaybe<Boolean_Comparison_Exp>;
  co2_kg?: InputMaybe<Numeric_Comparison_Exp>;
  co2eq_kg?: InputMaybe<Numeric_Comparison_Exp>;
  co2eq_kg_per_hour?: InputMaybe<Numeric_Comparison_Exp>;
  datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  detailed_transport_mode?: InputMaybe<Detailed_Transport_Mode_Comparison_Exp>;
  ets_euro?: InputMaybe<Numeric_Comparison_Exp>;
  genset_apparent_energy_to_co2?: InputMaybe<Numeric_Comparison_Exp>;
  genset_apparent_energy_to_co2eq?: InputMaybe<Numeric_Comparison_Exp>;
  grid_active_energy_to_co2eq?: InputMaybe<Float8_Comparison_Exp>;
  local_datetime?: InputMaybe<Timestamp_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  mode?: InputMaybe<Reefer_Mode_Comparison_Exp>;
  reefer?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
  reefer_id?: InputMaybe<String_Comparison_Exp>;
  refrigeration_unit_model?: InputMaybe<String_Comparison_Exp>;
  shipping_line?: InputMaybe<String_Comparison_Exp>;
  start_iso?: InputMaybe<String_Comparison_Exp>;
  telematic_device_id?: InputMaybe<Uuid_Comparison_Exp>;
  temperature_setpoint?: InputMaybe<Float8_Comparison_Exp>;
  temperature_setpoint_id?: InputMaybe<Uuid_Comparison_Exp>;
  tradelane?: InputMaybe<String_Comparison_Exp>;
  transport_mode?: InputMaybe<Transport_Mode_Comparison_Exp>;
};

/** aggregate max on columns */
export type Container_Insights_Energy_Usage_Expanded_Max_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_max_fields';
  active_energy_kWh?: Maybe<Scalars['float8']['output']>;
  active_power_kW?: Maybe<Scalars['float8']['output']>;
  age?: Maybe<Scalars['numeric']['output']>;
  age_id?: Maybe<Scalars['uuid']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['float8']['output']>;
  apparent_power_kVA?: Maybe<Scalars['float8']['output']>;
  co2_kg?: Maybe<Scalars['numeric']['output']>;
  co2eq_kg?: Maybe<Scalars['numeric']['output']>;
  co2eq_kg_per_hour?: Maybe<Scalars['numeric']['output']>;
  datetime?: Maybe<Scalars['timestamptz']['output']>;
  detailed_transport_mode?: Maybe<Scalars['detailed_transport_mode']['output']>;
  ets_euro?: Maybe<Scalars['numeric']['output']>;
  genset_apparent_energy_to_co2?: Maybe<Scalars['numeric']['output']>;
  genset_apparent_energy_to_co2eq?: Maybe<Scalars['numeric']['output']>;
  grid_active_energy_to_co2eq?: Maybe<Scalars['float8']['output']>;
  local_datetime?: Maybe<Scalars['timestamp']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['reefer_mode']['output']>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  start_iso?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
  temperature_setpoint_id?: Maybe<Scalars['uuid']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
  transport_mode?: Maybe<Scalars['transport_mode']['output']>;
};

/** aggregate min on columns */
export type Container_Insights_Energy_Usage_Expanded_Min_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_min_fields';
  active_energy_kWh?: Maybe<Scalars['float8']['output']>;
  active_power_kW?: Maybe<Scalars['float8']['output']>;
  age?: Maybe<Scalars['numeric']['output']>;
  age_id?: Maybe<Scalars['uuid']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['float8']['output']>;
  apparent_power_kVA?: Maybe<Scalars['float8']['output']>;
  co2_kg?: Maybe<Scalars['numeric']['output']>;
  co2eq_kg?: Maybe<Scalars['numeric']['output']>;
  co2eq_kg_per_hour?: Maybe<Scalars['numeric']['output']>;
  datetime?: Maybe<Scalars['timestamptz']['output']>;
  detailed_transport_mode?: Maybe<Scalars['detailed_transport_mode']['output']>;
  ets_euro?: Maybe<Scalars['numeric']['output']>;
  genset_apparent_energy_to_co2?: Maybe<Scalars['numeric']['output']>;
  genset_apparent_energy_to_co2eq?: Maybe<Scalars['numeric']['output']>;
  grid_active_energy_to_co2eq?: Maybe<Scalars['float8']['output']>;
  local_datetime?: Maybe<Scalars['timestamp']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['reefer_mode']['output']>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  start_iso?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
  temperature_setpoint_id?: Maybe<Scalars['uuid']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
  transport_mode?: Maybe<Scalars['transport_mode']['output']>;
};

/** Ordering options when selecting data from "container_insights.energy_usage_expanded". */
export type Container_Insights_Energy_Usage_Expanded_Order_By = {
  active_energy_kWh?: InputMaybe<Order_By>;
  active_power_kW?: InputMaybe<Order_By>;
  age?: InputMaybe<Order_By>;
  age_id?: InputMaybe<Order_By>;
  apparent_energy_kVAh?: InputMaybe<Order_By>;
  apparent_power_kVA?: InputMaybe<Order_By>;
  ca?: InputMaybe<Order_By>;
  co2_kg?: InputMaybe<Order_By>;
  co2eq_kg?: InputMaybe<Order_By>;
  co2eq_kg_per_hour?: InputMaybe<Order_By>;
  datetime?: InputMaybe<Order_By>;
  detailed_transport_mode?: InputMaybe<Order_By>;
  ets_euro?: InputMaybe<Order_By>;
  genset_apparent_energy_to_co2?: InputMaybe<Order_By>;
  genset_apparent_energy_to_co2eq?: InputMaybe<Order_By>;
  grid_active_energy_to_co2eq?: InputMaybe<Order_By>;
  local_datetime?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  reefer?: InputMaybe<Container_Insights_Reefers_Order_By>;
  reefer_id?: InputMaybe<Order_By>;
  refrigeration_unit_model?: InputMaybe<Order_By>;
  shipping_line?: InputMaybe<Order_By>;
  start_iso?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
  temperature_setpoint_id?: InputMaybe<Order_By>;
  tradelane?: InputMaybe<Order_By>;
  transport_mode?: InputMaybe<Order_By>;
};

/** select columns of table "container_insights.energy_usage_expanded" */
export enum Container_Insights_Energy_Usage_Expanded_Select_Column {
  /** column name */
  ActiveEnergyKWh = 'active_energy_kWh',
  /** column name */
  ActivePowerKW = 'active_power_kW',
  /** column name */
  Age = 'age',
  /** column name */
  AgeId = 'age_id',
  /** column name */
  ApparentEnergyKVAh = 'apparent_energy_kVAh',
  /** column name */
  ApparentPowerKVa = 'apparent_power_kVA',
  /** column name */
  Ca = 'ca',
  /** column name */
  Co2Kg = 'co2_kg',
  /** column name */
  Co2eqKg = 'co2eq_kg',
  /** column name */
  Co2eqKgPerHour = 'co2eq_kg_per_hour',
  /** column name */
  Datetime = 'datetime',
  /** column name */
  DetailedTransportMode = 'detailed_transport_mode',
  /** column name */
  EtsEuro = 'ets_euro',
  /** column name */
  GensetApparentEnergyToCo2 = 'genset_apparent_energy_to_co2',
  /** column name */
  GensetApparentEnergyToCo2eq = 'genset_apparent_energy_to_co2eq',
  /** column name */
  GridActiveEnergyToCo2eq = 'grid_active_energy_to_co2eq',
  /** column name */
  LocalDatetime = 'local_datetime',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  Mode = 'mode',
  /** column name */
  ReeferId = 'reefer_id',
  /** column name */
  RefrigerationUnitModel = 'refrigeration_unit_model',
  /** column name */
  ShippingLine = 'shipping_line',
  /** column name */
  StartIso = 'start_iso',
  /** column name */
  TelematicDeviceId = 'telematic_device_id',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
  /** column name */
  TemperatureSetpointId = 'temperature_setpoint_id',
  /** column name */
  Tradelane = 'tradelane',
  /** column name */
  TransportMode = 'transport_mode',
}

/** aggregate stddev on columns */
export type Container_Insights_Energy_Usage_Expanded_Stddev_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_stddev_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  age?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg_per_hour?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  genset_apparent_energy_to_co2?: Maybe<Scalars['Float']['output']>;
  genset_apparent_energy_to_co2eq?: Maybe<Scalars['Float']['output']>;
  grid_active_energy_to_co2eq?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Container_Insights_Energy_Usage_Expanded_Stddev_Pop_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_stddev_pop_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  age?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg_per_hour?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  genset_apparent_energy_to_co2?: Maybe<Scalars['Float']['output']>;
  genset_apparent_energy_to_co2eq?: Maybe<Scalars['Float']['output']>;
  grid_active_energy_to_co2eq?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Container_Insights_Energy_Usage_Expanded_Stddev_Samp_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_stddev_samp_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  age?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg_per_hour?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  genset_apparent_energy_to_co2?: Maybe<Scalars['Float']['output']>;
  genset_apparent_energy_to_co2eq?: Maybe<Scalars['Float']['output']>;
  grid_active_energy_to_co2eq?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "container_insights_energy_usage_expanded" */
export type Container_Insights_Energy_Usage_Expanded_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Energy_Usage_Expanded_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Energy_Usage_Expanded_Stream_Cursor_Value_Input =
  {
    active_energy_kWh?: InputMaybe<Scalars['float8']['input']>;
    active_power_kW?: InputMaybe<Scalars['float8']['input']>;
    age?: InputMaybe<Scalars['numeric']['input']>;
    age_id?: InputMaybe<Scalars['uuid']['input']>;
    apparent_energy_kVAh?: InputMaybe<Scalars['float8']['input']>;
    apparent_power_kVA?: InputMaybe<Scalars['float8']['input']>;
    ca?: InputMaybe<Scalars['Boolean']['input']>;
    co2_kg?: InputMaybe<Scalars['numeric']['input']>;
    co2eq_kg?: InputMaybe<Scalars['numeric']['input']>;
    co2eq_kg_per_hour?: InputMaybe<Scalars['numeric']['input']>;
    datetime?: InputMaybe<Scalars['timestamptz']['input']>;
    detailed_transport_mode?: InputMaybe<
      Scalars['detailed_transport_mode']['input']
    >;
    ets_euro?: InputMaybe<Scalars['numeric']['input']>;
    genset_apparent_energy_to_co2?: InputMaybe<Scalars['numeric']['input']>;
    genset_apparent_energy_to_co2eq?: InputMaybe<Scalars['numeric']['input']>;
    grid_active_energy_to_co2eq?: InputMaybe<Scalars['float8']['input']>;
    local_datetime?: InputMaybe<Scalars['timestamp']['input']>;
    manufacturer?: InputMaybe<Scalars['String']['input']>;
    mode?: InputMaybe<Scalars['reefer_mode']['input']>;
    reefer_id?: InputMaybe<Scalars['String']['input']>;
    refrigeration_unit_model?: InputMaybe<Scalars['String']['input']>;
    shipping_line?: InputMaybe<Scalars['String']['input']>;
    start_iso?: InputMaybe<Scalars['String']['input']>;
    telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
    temperature_setpoint?: InputMaybe<Scalars['float8']['input']>;
    temperature_setpoint_id?: InputMaybe<Scalars['uuid']['input']>;
    tradelane?: InputMaybe<Scalars['String']['input']>;
    transport_mode?: InputMaybe<Scalars['transport_mode']['input']>;
  };

/** aggregate sum on columns */
export type Container_Insights_Energy_Usage_Expanded_Sum_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_sum_fields';
  active_energy_kWh?: Maybe<Scalars['float8']['output']>;
  active_power_kW?: Maybe<Scalars['float8']['output']>;
  age?: Maybe<Scalars['numeric']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['float8']['output']>;
  apparent_power_kVA?: Maybe<Scalars['float8']['output']>;
  co2_kg?: Maybe<Scalars['numeric']['output']>;
  co2eq_kg?: Maybe<Scalars['numeric']['output']>;
  co2eq_kg_per_hour?: Maybe<Scalars['numeric']['output']>;
  ets_euro?: Maybe<Scalars['numeric']['output']>;
  genset_apparent_energy_to_co2?: Maybe<Scalars['numeric']['output']>;
  genset_apparent_energy_to_co2eq?: Maybe<Scalars['numeric']['output']>;
  grid_active_energy_to_co2eq?: Maybe<Scalars['float8']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
};

/** columns and relationships of "container_insights.energy_usage_expanded_v2" */
export type Container_Insights_Energy_Usage_Expanded_V2 = {
  __typename?: 'container_insights_energy_usage_expanded_v2';
  active_energy_kWh?: Maybe<Scalars['numeric']['output']>;
  active_power_kW?: Maybe<Scalars['float8']['output']>;
  age?: Maybe<Scalars['numeric']['output']>;
  age_id?: Maybe<Scalars['uuid']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['numeric']['output']>;
  apparent_power_kVA?: Maybe<Scalars['float8']['output']>;
  ca?: Maybe<Scalars['Boolean']['output']>;
  co2_kg?: Maybe<Scalars['numeric']['output']>;
  co2_return?: Maybe<Scalars['float8']['output']>;
  co2_setpoint?: Maybe<Scalars['float8']['output']>;
  co2eq_kg?: Maybe<Scalars['numeric']['output']>;
  datetime?: Maybe<Scalars['timestamptz']['output']>;
  ets_euro?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  o2_return?: Maybe<Scalars['float8']['output']>;
  o2_setpoint?: Maybe<Scalars['float8']['output']>;
  on_time_hours?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  reefer?: Maybe<Container_Insights_Reefers>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  telematic_company?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  temperature_return?: Maybe<Scalars['float8']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
  transport_mode?: Maybe<Scalars['transport_mode']['output']>;
};

/** aggregated selection of "container_insights.energy_usage_expanded_v2" */
export type Container_Insights_Energy_Usage_Expanded_V2_Aggregate = {
  __typename?: 'container_insights_energy_usage_expanded_v2_aggregate';
  aggregate?: Maybe<Container_Insights_Energy_Usage_Expanded_V2_Aggregate_Fields>;
  nodes: Array<Container_Insights_Energy_Usage_Expanded_V2>;
};

/** aggregate fields of "container_insights.energy_usage_expanded_v2" */
export type Container_Insights_Energy_Usage_Expanded_V2_Aggregate_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_v2_aggregate_fields';
  avg?: Maybe<Container_Insights_Energy_Usage_Expanded_V2_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Energy_Usage_Expanded_V2_Max_Fields>;
  min?: Maybe<Container_Insights_Energy_Usage_Expanded_V2_Min_Fields>;
  stddev?: Maybe<Container_Insights_Energy_Usage_Expanded_V2_Stddev_Fields>;
  stddev_pop?: Maybe<Container_Insights_Energy_Usage_Expanded_V2_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Container_Insights_Energy_Usage_Expanded_V2_Stddev_Samp_Fields>;
  sum?: Maybe<Container_Insights_Energy_Usage_Expanded_V2_Sum_Fields>;
  var_pop?: Maybe<Container_Insights_Energy_Usage_Expanded_V2_Var_Pop_Fields>;
  var_samp?: Maybe<Container_Insights_Energy_Usage_Expanded_V2_Var_Samp_Fields>;
  variance?: Maybe<Container_Insights_Energy_Usage_Expanded_V2_Variance_Fields>;
};


/** aggregate fields of "container_insights.energy_usage_expanded_v2" */
export type Container_Insights_Energy_Usage_Expanded_V2_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_V2_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Container_Insights_Energy_Usage_Expanded_V2_Avg_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_v2_avg_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  age?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2_return?: Maybe<Scalars['Float']['output']>;
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  o2_return?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  on_time_hours?: Maybe<Scalars['Float']['output']>;
  temperature_return?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "container_insights.energy_usage_expanded_v2". All fields are combined with a logical 'AND'. */
export type Container_Insights_Energy_Usage_Expanded_V2_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_V2_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Energy_Usage_Expanded_V2_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_V2_Bool_Exp>>;
  active_energy_kWh?: InputMaybe<Numeric_Comparison_Exp>;
  active_power_kW?: InputMaybe<Float8_Comparison_Exp>;
  age?: InputMaybe<Numeric_Comparison_Exp>;
  age_id?: InputMaybe<Uuid_Comparison_Exp>;
  apparent_energy_kVAh?: InputMaybe<Numeric_Comparison_Exp>;
  apparent_power_kVA?: InputMaybe<Float8_Comparison_Exp>;
  ca?: InputMaybe<Boolean_Comparison_Exp>;
  co2_kg?: InputMaybe<Numeric_Comparison_Exp>;
  co2_return?: InputMaybe<Float8_Comparison_Exp>;
  co2_setpoint?: InputMaybe<Float8_Comparison_Exp>;
  co2eq_kg?: InputMaybe<Numeric_Comparison_Exp>;
  datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  ets_euro?: InputMaybe<Numeric_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  mode?: InputMaybe<String_Comparison_Exp>;
  o2_return?: InputMaybe<Float8_Comparison_Exp>;
  o2_setpoint?: InputMaybe<Float8_Comparison_Exp>;
  on_time_hours?: InputMaybe<Numeric_Comparison_Exp>;
  reefer?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
  reefer_id?: InputMaybe<String_Comparison_Exp>;
  refrigeration_unit_model?: InputMaybe<String_Comparison_Exp>;
  shipping_line?: InputMaybe<String_Comparison_Exp>;
  telematic_company?: InputMaybe<String_Comparison_Exp>;
  telematic_device_id?: InputMaybe<Uuid_Comparison_Exp>;
  temperature_return?: InputMaybe<Float8_Comparison_Exp>;
  temperature_setpoint?: InputMaybe<Float8_Comparison_Exp>;
  tradelane?: InputMaybe<String_Comparison_Exp>;
  transport_mode?: InputMaybe<Transport_Mode_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "container_insights.energy_usage_expanded_v2" */
export type Container_Insights_Energy_Usage_Expanded_V2_Inc_Input = {
  active_energy_kWh?: InputMaybe<Scalars['numeric']['input']>;
  active_power_kW?: InputMaybe<Scalars['float8']['input']>;
  age?: InputMaybe<Scalars['numeric']['input']>;
  apparent_energy_kVAh?: InputMaybe<Scalars['numeric']['input']>;
  apparent_power_kVA?: InputMaybe<Scalars['float8']['input']>;
  co2_kg?: InputMaybe<Scalars['numeric']['input']>;
  co2_return?: InputMaybe<Scalars['float8']['input']>;
  co2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  co2eq_kg?: InputMaybe<Scalars['numeric']['input']>;
  ets_euro?: InputMaybe<Scalars['numeric']['input']>;
  o2_return?: InputMaybe<Scalars['float8']['input']>;
  o2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  on_time_hours?: InputMaybe<Scalars['numeric']['input']>;
  temperature_return?: InputMaybe<Scalars['float8']['input']>;
  temperature_setpoint?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "container_insights.energy_usage_expanded_v2" */
export type Container_Insights_Energy_Usage_Expanded_V2_Insert_Input = {
  active_energy_kWh?: InputMaybe<Scalars['numeric']['input']>;
  active_power_kW?: InputMaybe<Scalars['float8']['input']>;
  age?: InputMaybe<Scalars['numeric']['input']>;
  age_id?: InputMaybe<Scalars['uuid']['input']>;
  apparent_energy_kVAh?: InputMaybe<Scalars['numeric']['input']>;
  apparent_power_kVA?: InputMaybe<Scalars['float8']['input']>;
  ca?: InputMaybe<Scalars['Boolean']['input']>;
  co2_kg?: InputMaybe<Scalars['numeric']['input']>;
  co2_return?: InputMaybe<Scalars['float8']['input']>;
  co2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  co2eq_kg?: InputMaybe<Scalars['numeric']['input']>;
  datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  ets_euro?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  o2_return?: InputMaybe<Scalars['float8']['input']>;
  o2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  on_time_hours?: InputMaybe<Scalars['numeric']['input']>;
  reefer?: InputMaybe<Container_Insights_Reefers_Obj_Rel_Insert_Input>;
  reefer_id?: InputMaybe<Scalars['String']['input']>;
  refrigeration_unit_model?: InputMaybe<Scalars['String']['input']>;
  shipping_line?: InputMaybe<Scalars['String']['input']>;
  telematic_company?: InputMaybe<Scalars['String']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  temperature_return?: InputMaybe<Scalars['float8']['input']>;
  temperature_setpoint?: InputMaybe<Scalars['float8']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
  transport_mode?: InputMaybe<Scalars['transport_mode']['input']>;
};

/** aggregate max on columns */
export type Container_Insights_Energy_Usage_Expanded_V2_Max_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_v2_max_fields';
  active_energy_kWh?: Maybe<Scalars['numeric']['output']>;
  active_power_kW?: Maybe<Scalars['float8']['output']>;
  age?: Maybe<Scalars['numeric']['output']>;
  age_id?: Maybe<Scalars['uuid']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['numeric']['output']>;
  apparent_power_kVA?: Maybe<Scalars['float8']['output']>;
  co2_kg?: Maybe<Scalars['numeric']['output']>;
  co2_return?: Maybe<Scalars['float8']['output']>;
  co2_setpoint?: Maybe<Scalars['float8']['output']>;
  co2eq_kg?: Maybe<Scalars['numeric']['output']>;
  datetime?: Maybe<Scalars['timestamptz']['output']>;
  ets_euro?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  o2_return?: Maybe<Scalars['float8']['output']>;
  o2_setpoint?: Maybe<Scalars['float8']['output']>;
  on_time_hours?: Maybe<Scalars['numeric']['output']>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  telematic_company?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  temperature_return?: Maybe<Scalars['float8']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
  transport_mode?: Maybe<Scalars['transport_mode']['output']>;
};

/** aggregate min on columns */
export type Container_Insights_Energy_Usage_Expanded_V2_Min_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_v2_min_fields';
  active_energy_kWh?: Maybe<Scalars['numeric']['output']>;
  active_power_kW?: Maybe<Scalars['float8']['output']>;
  age?: Maybe<Scalars['numeric']['output']>;
  age_id?: Maybe<Scalars['uuid']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['numeric']['output']>;
  apparent_power_kVA?: Maybe<Scalars['float8']['output']>;
  co2_kg?: Maybe<Scalars['numeric']['output']>;
  co2_return?: Maybe<Scalars['float8']['output']>;
  co2_setpoint?: Maybe<Scalars['float8']['output']>;
  co2eq_kg?: Maybe<Scalars['numeric']['output']>;
  datetime?: Maybe<Scalars['timestamptz']['output']>;
  ets_euro?: Maybe<Scalars['numeric']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  o2_return?: Maybe<Scalars['float8']['output']>;
  o2_setpoint?: Maybe<Scalars['float8']['output']>;
  on_time_hours?: Maybe<Scalars['numeric']['output']>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  telematic_company?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  temperature_return?: Maybe<Scalars['float8']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
  transport_mode?: Maybe<Scalars['transport_mode']['output']>;
};

/** response of any mutation on the table "container_insights.energy_usage_expanded_v2" */
export type Container_Insights_Energy_Usage_Expanded_V2_Mutation_Response = {
  __typename?: 'container_insights_energy_usage_expanded_v2_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Container_Insights_Energy_Usage_Expanded_V2>;
};

/** Ordering options when selecting data from "container_insights.energy_usage_expanded_v2". */
export type Container_Insights_Energy_Usage_Expanded_V2_Order_By = {
  active_energy_kWh?: InputMaybe<Order_By>;
  active_power_kW?: InputMaybe<Order_By>;
  age?: InputMaybe<Order_By>;
  age_id?: InputMaybe<Order_By>;
  apparent_energy_kVAh?: InputMaybe<Order_By>;
  apparent_power_kVA?: InputMaybe<Order_By>;
  ca?: InputMaybe<Order_By>;
  co2_kg?: InputMaybe<Order_By>;
  co2_return?: InputMaybe<Order_By>;
  co2_setpoint?: InputMaybe<Order_By>;
  co2eq_kg?: InputMaybe<Order_By>;
  datetime?: InputMaybe<Order_By>;
  ets_euro?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  o2_return?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  on_time_hours?: InputMaybe<Order_By>;
  reefer?: InputMaybe<Container_Insights_Reefers_Order_By>;
  reefer_id?: InputMaybe<Order_By>;
  refrigeration_unit_model?: InputMaybe<Order_By>;
  shipping_line?: InputMaybe<Order_By>;
  telematic_company?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  temperature_return?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
  tradelane?: InputMaybe<Order_By>;
  transport_mode?: InputMaybe<Order_By>;
};

/** select columns of table "container_insights.energy_usage_expanded_v2" */
export enum Container_Insights_Energy_Usage_Expanded_V2_Select_Column {
  /** column name */
  ActiveEnergyKWh = 'active_energy_kWh',
  /** column name */
  ActivePowerKW = 'active_power_kW',
  /** column name */
  Age = 'age',
  /** column name */
  AgeId = 'age_id',
  /** column name */
  ApparentEnergyKVAh = 'apparent_energy_kVAh',
  /** column name */
  ApparentPowerKVa = 'apparent_power_kVA',
  /** column name */
  Ca = 'ca',
  /** column name */
  Co2Kg = 'co2_kg',
  /** column name */
  Co2Return = 'co2_return',
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  Co2eqKg = 'co2eq_kg',
  /** column name */
  Datetime = 'datetime',
  /** column name */
  EtsEuro = 'ets_euro',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  Mode = 'mode',
  /** column name */
  O2Return = 'o2_return',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  OnTimeHours = 'on_time_hours',
  /** column name */
  ReeferId = 'reefer_id',
  /** column name */
  RefrigerationUnitModel = 'refrigeration_unit_model',
  /** column name */
  ShippingLine = 'shipping_line',
  /** column name */
  TelematicCompany = 'telematic_company',
  /** column name */
  TelematicDeviceId = 'telematic_device_id',
  /** column name */
  TemperatureReturn = 'temperature_return',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
  /** column name */
  Tradelane = 'tradelane',
  /** column name */
  TransportMode = 'transport_mode'
}

/** input type for updating data in table "container_insights.energy_usage_expanded_v2" */
export type Container_Insights_Energy_Usage_Expanded_V2_Set_Input = {
  active_energy_kWh?: InputMaybe<Scalars['numeric']['input']>;
  active_power_kW?: InputMaybe<Scalars['float8']['input']>;
  age?: InputMaybe<Scalars['numeric']['input']>;
  age_id?: InputMaybe<Scalars['uuid']['input']>;
  apparent_energy_kVAh?: InputMaybe<Scalars['numeric']['input']>;
  apparent_power_kVA?: InputMaybe<Scalars['float8']['input']>;
  ca?: InputMaybe<Scalars['Boolean']['input']>;
  co2_kg?: InputMaybe<Scalars['numeric']['input']>;
  co2_return?: InputMaybe<Scalars['float8']['input']>;
  co2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  co2eq_kg?: InputMaybe<Scalars['numeric']['input']>;
  datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  ets_euro?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  o2_return?: InputMaybe<Scalars['float8']['input']>;
  o2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  on_time_hours?: InputMaybe<Scalars['numeric']['input']>;
  reefer_id?: InputMaybe<Scalars['String']['input']>;
  refrigeration_unit_model?: InputMaybe<Scalars['String']['input']>;
  shipping_line?: InputMaybe<Scalars['String']['input']>;
  telematic_company?: InputMaybe<Scalars['String']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  temperature_return?: InputMaybe<Scalars['float8']['input']>;
  temperature_setpoint?: InputMaybe<Scalars['float8']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
  transport_mode?: InputMaybe<Scalars['transport_mode']['input']>;
};

/** aggregate stddev on columns */
export type Container_Insights_Energy_Usage_Expanded_V2_Stddev_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_v2_stddev_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  age?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2_return?: Maybe<Scalars['Float']['output']>;
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  o2_return?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  on_time_hours?: Maybe<Scalars['Float']['output']>;
  temperature_return?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Container_Insights_Energy_Usage_Expanded_V2_Stddev_Pop_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_v2_stddev_pop_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  age?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2_return?: Maybe<Scalars['Float']['output']>;
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  o2_return?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  on_time_hours?: Maybe<Scalars['Float']['output']>;
  temperature_return?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Container_Insights_Energy_Usage_Expanded_V2_Stddev_Samp_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_v2_stddev_samp_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  age?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2_return?: Maybe<Scalars['Float']['output']>;
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  o2_return?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  on_time_hours?: Maybe<Scalars['Float']['output']>;
  temperature_return?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "container_insights_energy_usage_expanded_v2" */
export type Container_Insights_Energy_Usage_Expanded_V2_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Energy_Usage_Expanded_V2_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Energy_Usage_Expanded_V2_Stream_Cursor_Value_Input = {
  active_energy_kWh?: InputMaybe<Scalars['numeric']['input']>;
  active_power_kW?: InputMaybe<Scalars['float8']['input']>;
  age?: InputMaybe<Scalars['numeric']['input']>;
  age_id?: InputMaybe<Scalars['uuid']['input']>;
  apparent_energy_kVAh?: InputMaybe<Scalars['numeric']['input']>;
  apparent_power_kVA?: InputMaybe<Scalars['float8']['input']>;
  ca?: InputMaybe<Scalars['Boolean']['input']>;
  co2_kg?: InputMaybe<Scalars['numeric']['input']>;
  co2_return?: InputMaybe<Scalars['float8']['input']>;
  co2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  co2eq_kg?: InputMaybe<Scalars['numeric']['input']>;
  datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  ets_euro?: InputMaybe<Scalars['numeric']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  o2_return?: InputMaybe<Scalars['float8']['input']>;
  o2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  on_time_hours?: InputMaybe<Scalars['numeric']['input']>;
  reefer_id?: InputMaybe<Scalars['String']['input']>;
  refrigeration_unit_model?: InputMaybe<Scalars['String']['input']>;
  shipping_line?: InputMaybe<Scalars['String']['input']>;
  telematic_company?: InputMaybe<Scalars['String']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  temperature_return?: InputMaybe<Scalars['float8']['input']>;
  temperature_setpoint?: InputMaybe<Scalars['float8']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
  transport_mode?: InputMaybe<Scalars['transport_mode']['input']>;
};

/** aggregate sum on columns */
export type Container_Insights_Energy_Usage_Expanded_V2_Sum_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_v2_sum_fields';
  active_energy_kWh?: Maybe<Scalars['numeric']['output']>;
  active_power_kW?: Maybe<Scalars['float8']['output']>;
  age?: Maybe<Scalars['numeric']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['numeric']['output']>;
  apparent_power_kVA?: Maybe<Scalars['float8']['output']>;
  co2_kg?: Maybe<Scalars['numeric']['output']>;
  co2_return?: Maybe<Scalars['float8']['output']>;
  co2_setpoint?: Maybe<Scalars['float8']['output']>;
  co2eq_kg?: Maybe<Scalars['numeric']['output']>;
  ets_euro?: Maybe<Scalars['numeric']['output']>;
  o2_return?: Maybe<Scalars['float8']['output']>;
  o2_setpoint?: Maybe<Scalars['float8']['output']>;
  on_time_hours?: Maybe<Scalars['numeric']['output']>;
  temperature_return?: Maybe<Scalars['float8']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
};

export type Container_Insights_Energy_Usage_Expanded_V2_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Container_Insights_Energy_Usage_Expanded_V2_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Container_Insights_Energy_Usage_Expanded_V2_Set_Input>;
  /** filter the rows which have to be updated */
  where: Container_Insights_Energy_Usage_Expanded_V2_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Container_Insights_Energy_Usage_Expanded_V2_Var_Pop_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_v2_var_pop_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  age?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2_return?: Maybe<Scalars['Float']['output']>;
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  o2_return?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  on_time_hours?: Maybe<Scalars['Float']['output']>;
  temperature_return?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Container_Insights_Energy_Usage_Expanded_V2_Var_Samp_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_v2_var_samp_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  age?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2_return?: Maybe<Scalars['Float']['output']>;
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  o2_return?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  on_time_hours?: Maybe<Scalars['Float']['output']>;
  temperature_return?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Container_Insights_Energy_Usage_Expanded_V2_Variance_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_v2_variance_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  age?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2_return?: Maybe<Scalars['Float']['output']>;
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  o2_return?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  on_time_hours?: Maybe<Scalars['Float']['output']>;
  temperature_return?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Container_Insights_Energy_Usage_Expanded_Var_Pop_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_var_pop_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  age?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg_per_hour?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  genset_apparent_energy_to_co2?: Maybe<Scalars['Float']['output']>;
  genset_apparent_energy_to_co2eq?: Maybe<Scalars['Float']['output']>;
  grid_active_energy_to_co2eq?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Container_Insights_Energy_Usage_Expanded_Var_Samp_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_var_samp_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  age?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg_per_hour?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  genset_apparent_energy_to_co2?: Maybe<Scalars['Float']['output']>;
  genset_apparent_energy_to_co2eq?: Maybe<Scalars['Float']['output']>;
  grid_active_energy_to_co2eq?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Container_Insights_Energy_Usage_Expanded_Variance_Fields = {
  __typename?: 'container_insights_energy_usage_expanded_variance_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  age?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg_per_hour?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
  genset_apparent_energy_to_co2?: Maybe<Scalars['Float']['output']>;
  genset_apparent_energy_to_co2eq?: Maybe<Scalars['Float']['output']>;
  grid_active_energy_to_co2eq?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** input type for incrementing numeric columns in table "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Inc_Input = {
  active_energy_kWh?: InputMaybe<Scalars['float8']['input']>;
  active_power_kW?: InputMaybe<Scalars['float8']['input']>;
  apparent_energy_kVAh?: InputMaybe<Scalars['float8']['input']>;
  apparent_power_kVA?: InputMaybe<Scalars['float8']['input']>;
  co2_return?: InputMaybe<Scalars['float8']['input']>;
  co2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  o2_return?: InputMaybe<Scalars['float8']['input']>;
  o2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  temperature_return?: InputMaybe<Scalars['float8']['input']>;
  temperature_setpoint?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Insert_Input = {
  active_energy_kWh?: InputMaybe<Scalars['float8']['input']>;
  active_power_kW?: InputMaybe<Scalars['float8']['input']>;
  apparent_energy_kVAh?: InputMaybe<Scalars['float8']['input']>;
  apparent_power_kVA?: InputMaybe<Scalars['float8']['input']>;
  co2_return?: InputMaybe<Scalars['float8']['input']>;
  co2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  gps?: InputMaybe<Scalars['geometry']['input']>;
  local_datetime?: InputMaybe<Scalars['timestamp']['input']>;
  mode?: InputMaybe<Scalars['reefer_mode']['input']>;
  o2_return?: InputMaybe<Scalars['float8']['input']>;
  o2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  telematic_device?: InputMaybe<Container_Insights_Telematic_Devices_Obj_Rel_Insert_Input>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  temperature_return?: InputMaybe<Scalars['float8']['input']>;
  temperature_setpoint?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate max on columns */
export type Container_Insights_Energy_Usage_Max_Fields = {
  __typename?: 'container_insights_energy_usage_max_fields';
  active_energy_kWh?: Maybe<Scalars['float8']['output']>;
  active_power_kW?: Maybe<Scalars['float8']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['float8']['output']>;
  apparent_power_kVA?: Maybe<Scalars['float8']['output']>;
  co2_return?: Maybe<Scalars['float8']['output']>;
  co2_setpoint?: Maybe<Scalars['float8']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  datetime?: Maybe<Scalars['timestamptz']['output']>;
  local_datetime?: Maybe<Scalars['timestamp']['output']>;
  mode?: Maybe<Scalars['reefer_mode']['output']>;
  o2_return?: Maybe<Scalars['float8']['output']>;
  o2_setpoint?: Maybe<Scalars['float8']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  temperature_return?: Maybe<Scalars['float8']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Max_Order_By = {
  active_energy_kWh?: InputMaybe<Order_By>;
  active_power_kW?: InputMaybe<Order_By>;
  apparent_energy_kVAh?: InputMaybe<Order_By>;
  apparent_power_kVA?: InputMaybe<Order_By>;
  co2_return?: InputMaybe<Order_By>;
  co2_setpoint?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  datetime?: InputMaybe<Order_By>;
  local_datetime?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  o2_return?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  temperature_return?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Container_Insights_Energy_Usage_Min_Fields = {
  __typename?: 'container_insights_energy_usage_min_fields';
  active_energy_kWh?: Maybe<Scalars['float8']['output']>;
  active_power_kW?: Maybe<Scalars['float8']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['float8']['output']>;
  apparent_power_kVA?: Maybe<Scalars['float8']['output']>;
  co2_return?: Maybe<Scalars['float8']['output']>;
  co2_setpoint?: Maybe<Scalars['float8']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  datetime?: Maybe<Scalars['timestamptz']['output']>;
  local_datetime?: Maybe<Scalars['timestamp']['output']>;
  mode?: Maybe<Scalars['reefer_mode']['output']>;
  o2_return?: Maybe<Scalars['float8']['output']>;
  o2_setpoint?: Maybe<Scalars['float8']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  temperature_return?: Maybe<Scalars['float8']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Min_Order_By = {
  active_energy_kWh?: InputMaybe<Order_By>;
  active_power_kW?: InputMaybe<Order_By>;
  apparent_energy_kVAh?: InputMaybe<Order_By>;
  apparent_power_kVA?: InputMaybe<Order_By>;
  co2_return?: InputMaybe<Order_By>;
  co2_setpoint?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  datetime?: InputMaybe<Order_By>;
  local_datetime?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  o2_return?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  temperature_return?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Mutation_Response = {
  __typename?: 'container_insights_energy_usage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Container_Insights_Energy_Usage>;
};

/** Ordering options when selecting data from "container_insights.energy_usage". */
export type Container_Insights_Energy_Usage_Order_By = {
  active_energy_kWh?: InputMaybe<Order_By>;
  active_power_kW?: InputMaybe<Order_By>;
  apparent_energy_kVAh?: InputMaybe<Order_By>;
  apparent_power_kVA?: InputMaybe<Order_By>;
  co2_return?: InputMaybe<Order_By>;
  co2_setpoint?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  datetime?: InputMaybe<Order_By>;
  gps?: InputMaybe<Order_By>;
  local_datetime?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  o2_return?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  telematic_device?: InputMaybe<Container_Insights_Telematic_Devices_Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  temperature_return?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** select columns of table "container_insights.energy_usage" */
export enum Container_Insights_Energy_Usage_Select_Column {
  /** column name */
  ActiveEnergyKWh = 'active_energy_kWh',
  /** column name */
  ActivePowerKW = 'active_power_kW',
  /** column name */
  ApparentEnergyKVAh = 'apparent_energy_kVAh',
  /** column name */
  ApparentPowerKVa = 'apparent_power_kVA',
  /** column name */
  Co2Return = 'co2_return',
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Datetime = 'datetime',
  /** column name */
  Gps = 'gps',
  /** column name */
  LocalDatetime = 'local_datetime',
  /** column name */
  Mode = 'mode',
  /** column name */
  O2Return = 'o2_return',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  TelematicDeviceId = 'telematic_device_id',
  /** column name */
  TemperatureReturn = 'temperature_return',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_energy_usage_aggregate_bool_exp_avg_arguments_columns" columns of table "container_insights.energy_usage" */
export enum Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  ActiveEnergyKWh = 'active_energy_kWh',
  /** column name */
  ActivePowerKW = 'active_power_kW',
  /** column name */
  ApparentEnergyKVAh = 'apparent_energy_kVAh',
  /** column name */
  ApparentPowerKVa = 'apparent_power_kVA',
  /** column name */
  Co2Return = 'co2_return',
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  O2Return = 'o2_return',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  TemperatureReturn = 'temperature_return',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_energy_usage_aggregate_bool_exp_corr_arguments_columns" columns of table "container_insights.energy_usage" */
export enum Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  ActiveEnergyKWh = 'active_energy_kWh',
  /** column name */
  ActivePowerKW = 'active_power_kW',
  /** column name */
  ApparentEnergyKVAh = 'apparent_energy_kVAh',
  /** column name */
  ApparentPowerKVa = 'apparent_power_kVA',
  /** column name */
  Co2Return = 'co2_return',
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  O2Return = 'o2_return',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  TemperatureReturn = 'temperature_return',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_energy_usage_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "container_insights.energy_usage" */
export enum Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  ActiveEnergyKWh = 'active_energy_kWh',
  /** column name */
  ActivePowerKW = 'active_power_kW',
  /** column name */
  ApparentEnergyKVAh = 'apparent_energy_kVAh',
  /** column name */
  ApparentPowerKVa = 'apparent_power_kVA',
  /** column name */
  Co2Return = 'co2_return',
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  O2Return = 'o2_return',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  TemperatureReturn = 'temperature_return',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_energy_usage_aggregate_bool_exp_max_arguments_columns" columns of table "container_insights.energy_usage" */
export enum Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  ActiveEnergyKWh = 'active_energy_kWh',
  /** column name */
  ActivePowerKW = 'active_power_kW',
  /** column name */
  ApparentEnergyKVAh = 'apparent_energy_kVAh',
  /** column name */
  ApparentPowerKVa = 'apparent_power_kVA',
  /** column name */
  Co2Return = 'co2_return',
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  O2Return = 'o2_return',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  TemperatureReturn = 'temperature_return',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_energy_usage_aggregate_bool_exp_min_arguments_columns" columns of table "container_insights.energy_usage" */
export enum Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  ActiveEnergyKWh = 'active_energy_kWh',
  /** column name */
  ActivePowerKW = 'active_power_kW',
  /** column name */
  ApparentEnergyKVAh = 'apparent_energy_kVAh',
  /** column name */
  ApparentPowerKVa = 'apparent_power_kVA',
  /** column name */
  Co2Return = 'co2_return',
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  O2Return = 'o2_return',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  TemperatureReturn = 'temperature_return',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_energy_usage_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "container_insights.energy_usage" */
export enum Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  ActiveEnergyKWh = 'active_energy_kWh',
  /** column name */
  ActivePowerKW = 'active_power_kW',
  /** column name */
  ApparentEnergyKVAh = 'apparent_energy_kVAh',
  /** column name */
  ApparentPowerKVa = 'apparent_power_kVA',
  /** column name */
  Co2Return = 'co2_return',
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  O2Return = 'o2_return',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  TemperatureReturn = 'temperature_return',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_energy_usage_aggregate_bool_exp_sum_arguments_columns" columns of table "container_insights.energy_usage" */
export enum Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  ActiveEnergyKWh = 'active_energy_kWh',
  /** column name */
  ActivePowerKW = 'active_power_kW',
  /** column name */
  ApparentEnergyKVAh = 'apparent_energy_kVAh',
  /** column name */
  ApparentPowerKVa = 'apparent_power_kVA',
  /** column name */
  Co2Return = 'co2_return',
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  O2Return = 'o2_return',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  TemperatureReturn = 'temperature_return',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** select "container_insights_energy_usage_aggregate_bool_exp_var_samp_arguments_columns" columns of table "container_insights.energy_usage" */
export enum Container_Insights_Energy_Usage_Select_Column_Container_Insights_Energy_Usage_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  ActiveEnergyKWh = 'active_energy_kWh',
  /** column name */
  ActivePowerKW = 'active_power_kW',
  /** column name */
  ApparentEnergyKVAh = 'apparent_energy_kVAh',
  /** column name */
  ApparentPowerKVa = 'apparent_power_kVA',
  /** column name */
  Co2Return = 'co2_return',
  /** column name */
  Co2Setpoint = 'co2_setpoint',
  /** column name */
  O2Return = 'o2_return',
  /** column name */
  O2Setpoint = 'o2_setpoint',
  /** column name */
  TemperatureReturn = 'temperature_return',
  /** column name */
  TemperatureSetpoint = 'temperature_setpoint',
}

/** input type for updating data in table "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Set_Input = {
  active_energy_kWh?: InputMaybe<Scalars['float8']['input']>;
  active_power_kW?: InputMaybe<Scalars['float8']['input']>;
  apparent_energy_kVAh?: InputMaybe<Scalars['float8']['input']>;
  apparent_power_kVA?: InputMaybe<Scalars['float8']['input']>;
  co2_return?: InputMaybe<Scalars['float8']['input']>;
  co2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  gps?: InputMaybe<Scalars['geometry']['input']>;
  local_datetime?: InputMaybe<Scalars['timestamp']['input']>;
  mode?: InputMaybe<Scalars['reefer_mode']['input']>;
  o2_return?: InputMaybe<Scalars['float8']['input']>;
  o2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  temperature_return?: InputMaybe<Scalars['float8']['input']>;
  temperature_setpoint?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate stddev on columns */
export type Container_Insights_Energy_Usage_Stddev_Fields = {
  __typename?: 'container_insights_energy_usage_stddev_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_return?: Maybe<Scalars['Float']['output']>;
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  o2_return?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  temperature_return?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Stddev_Order_By = {
  active_energy_kWh?: InputMaybe<Order_By>;
  active_power_kW?: InputMaybe<Order_By>;
  apparent_energy_kVAh?: InputMaybe<Order_By>;
  apparent_power_kVA?: InputMaybe<Order_By>;
  co2_return?: InputMaybe<Order_By>;
  co2_setpoint?: InputMaybe<Order_By>;
  o2_return?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  temperature_return?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Container_Insights_Energy_Usage_Stddev_Pop_Fields = {
  __typename?: 'container_insights_energy_usage_stddev_pop_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_return?: Maybe<Scalars['Float']['output']>;
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  o2_return?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  temperature_return?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Stddev_Pop_Order_By = {
  active_energy_kWh?: InputMaybe<Order_By>;
  active_power_kW?: InputMaybe<Order_By>;
  apparent_energy_kVAh?: InputMaybe<Order_By>;
  apparent_power_kVA?: InputMaybe<Order_By>;
  co2_return?: InputMaybe<Order_By>;
  co2_setpoint?: InputMaybe<Order_By>;
  o2_return?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  temperature_return?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Container_Insights_Energy_Usage_Stddev_Samp_Fields = {
  __typename?: 'container_insights_energy_usage_stddev_samp_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_return?: Maybe<Scalars['Float']['output']>;
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  o2_return?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  temperature_return?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Stddev_Samp_Order_By = {
  active_energy_kWh?: InputMaybe<Order_By>;
  active_power_kW?: InputMaybe<Order_By>;
  apparent_energy_kVAh?: InputMaybe<Order_By>;
  apparent_power_kVA?: InputMaybe<Order_By>;
  co2_return?: InputMaybe<Order_By>;
  co2_setpoint?: InputMaybe<Order_By>;
  o2_return?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  temperature_return?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "container_insights_energy_usage" */
export type Container_Insights_Energy_Usage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Energy_Usage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Energy_Usage_Stream_Cursor_Value_Input = {
  active_energy_kWh?: InputMaybe<Scalars['float8']['input']>;
  active_power_kW?: InputMaybe<Scalars['float8']['input']>;
  apparent_energy_kVAh?: InputMaybe<Scalars['float8']['input']>;
  apparent_power_kVA?: InputMaybe<Scalars['float8']['input']>;
  co2_return?: InputMaybe<Scalars['float8']['input']>;
  co2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  gps?: InputMaybe<Scalars['geometry']['input']>;
  local_datetime?: InputMaybe<Scalars['timestamp']['input']>;
  mode?: InputMaybe<Scalars['reefer_mode']['input']>;
  o2_return?: InputMaybe<Scalars['float8']['input']>;
  o2_setpoint?: InputMaybe<Scalars['float8']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  temperature_return?: InputMaybe<Scalars['float8']['input']>;
  temperature_setpoint?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Container_Insights_Energy_Usage_Sum_Fields = {
  __typename?: 'container_insights_energy_usage_sum_fields';
  active_energy_kWh?: Maybe<Scalars['float8']['output']>;
  active_power_kW?: Maybe<Scalars['float8']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['float8']['output']>;
  apparent_power_kVA?: Maybe<Scalars['float8']['output']>;
  co2_return?: Maybe<Scalars['float8']['output']>;
  co2_setpoint?: Maybe<Scalars['float8']['output']>;
  o2_return?: Maybe<Scalars['float8']['output']>;
  o2_setpoint?: Maybe<Scalars['float8']['output']>;
  temperature_return?: Maybe<Scalars['float8']['output']>;
  temperature_setpoint?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Sum_Order_By = {
  active_energy_kWh?: InputMaybe<Order_By>;
  active_power_kW?: InputMaybe<Order_By>;
  apparent_energy_kVAh?: InputMaybe<Order_By>;
  apparent_power_kVA?: InputMaybe<Order_By>;
  co2_return?: InputMaybe<Order_By>;
  co2_setpoint?: InputMaybe<Order_By>;
  o2_return?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  temperature_return?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

export type Container_Insights_Energy_Usage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Container_Insights_Energy_Usage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Container_Insights_Energy_Usage_Set_Input>;
  /** filter the rows which have to be updated */
  where: Container_Insights_Energy_Usage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Container_Insights_Energy_Usage_Var_Pop_Fields = {
  __typename?: 'container_insights_energy_usage_var_pop_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_return?: Maybe<Scalars['Float']['output']>;
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  o2_return?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  temperature_return?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Var_Pop_Order_By = {
  active_energy_kWh?: InputMaybe<Order_By>;
  active_power_kW?: InputMaybe<Order_By>;
  apparent_energy_kVAh?: InputMaybe<Order_By>;
  apparent_power_kVA?: InputMaybe<Order_By>;
  co2_return?: InputMaybe<Order_By>;
  co2_setpoint?: InputMaybe<Order_By>;
  o2_return?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  temperature_return?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Container_Insights_Energy_Usage_Var_Samp_Fields = {
  __typename?: 'container_insights_energy_usage_var_samp_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_return?: Maybe<Scalars['Float']['output']>;
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  o2_return?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  temperature_return?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Var_Samp_Order_By = {
  active_energy_kWh?: InputMaybe<Order_By>;
  active_power_kW?: InputMaybe<Order_By>;
  apparent_energy_kVAh?: InputMaybe<Order_By>;
  apparent_power_kVA?: InputMaybe<Order_By>;
  co2_return?: InputMaybe<Order_By>;
  co2_setpoint?: InputMaybe<Order_By>;
  o2_return?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  temperature_return?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Container_Insights_Energy_Usage_Variance_Fields = {
  __typename?: 'container_insights_energy_usage_variance_fields';
  active_energy_kWh?: Maybe<Scalars['Float']['output']>;
  active_power_kW?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kVAh?: Maybe<Scalars['Float']['output']>;
  apparent_power_kVA?: Maybe<Scalars['Float']['output']>;
  co2_return?: Maybe<Scalars['Float']['output']>;
  co2_setpoint?: Maybe<Scalars['Float']['output']>;
  o2_return?: Maybe<Scalars['Float']['output']>;
  o2_setpoint?: Maybe<Scalars['Float']['output']>;
  temperature_return?: Maybe<Scalars['Float']['output']>;
  temperature_setpoint?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "container_insights.energy_usage" */
export type Container_Insights_Energy_Usage_Variance_Order_By = {
  active_energy_kWh?: InputMaybe<Order_By>;
  active_power_kW?: InputMaybe<Order_By>;
  apparent_energy_kVAh?: InputMaybe<Order_By>;
  apparent_power_kVA?: InputMaybe<Order_By>;
  co2_return?: InputMaybe<Order_By>;
  co2_setpoint?: InputMaybe<Order_By>;
  o2_return?: InputMaybe<Order_By>;
  o2_setpoint?: InputMaybe<Order_By>;
  temperature_return?: InputMaybe<Order_By>;
  temperature_setpoint?: InputMaybe<Order_By>;
};

/** columns and relationships of "container_insights.legs" */
export type Container_Insights_Legs = {
  __typename?: 'container_insights_legs';
  created_at: Scalars['timestamptz']['output'];
  detailed_transport_mode: Scalars['detailed_transport_mode']['output'];
  end_datetime: Scalars['timestamptz']['output'];
  end_gps: Scalars['geometry']['output'];
  end_iso: Scalars['String']['output'];
  end_location: Scalars['String']['output'];
  end_long_location: Scalars['String']['output'];
  end_unlocode: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  linestring: Scalars['geometry']['output'];
  start_datetime: Scalars['timestamptz']['output'];
  start_gps: Scalars['geometry']['output'];
  start_iso: Scalars['String']['output'];
  start_location: Scalars['String']['output'];
  start_long_location: Scalars['String']['output'];
  start_unlocode: Scalars['String']['output'];
  /** An object relationship */
  telematic_device?: Maybe<Container_Insights_Telematic_Devices>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  tradelane: Scalars['String']['output'];
  transport_mode: Scalars['transport_mode']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "container_insights.legs" */
export type Container_Insights_Legs_Aggregate = {
  __typename?: 'container_insights_legs_aggregate';
  aggregate?: Maybe<Container_Insights_Legs_Aggregate_Fields>;
  nodes: Array<Container_Insights_Legs>;
};

export type Container_Insights_Legs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Container_Insights_Legs_Aggregate_Bool_Exp_Count>;
};

export type Container_Insights_Legs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Container_Insights_Legs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Legs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "container_insights.legs" */
export type Container_Insights_Legs_Aggregate_Fields = {
  __typename?: 'container_insights_legs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Legs_Max_Fields>;
  min?: Maybe<Container_Insights_Legs_Min_Fields>;
};

/** aggregate fields of "container_insights.legs" */
export type Container_Insights_Legs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Container_Insights_Legs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "container_insights.legs" */
export type Container_Insights_Legs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Container_Insights_Legs_Max_Order_By>;
  min?: InputMaybe<Container_Insights_Legs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "container_insights.legs" */
export type Container_Insights_Legs_Arr_Rel_Insert_Input = {
  data: Array<Container_Insights_Legs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Container_Insights_Legs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "container_insights.legs". All fields are combined with a logical 'AND'. */
export type Container_Insights_Legs_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Legs_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Legs_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Legs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  detailed_transport_mode?: InputMaybe<Detailed_Transport_Mode_Comparison_Exp>;
  end_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_gps?: InputMaybe<Geometry_Comparison_Exp>;
  end_iso?: InputMaybe<String_Comparison_Exp>;
  end_location?: InputMaybe<String_Comparison_Exp>;
  end_long_location?: InputMaybe<String_Comparison_Exp>;
  end_unlocode?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  linestring?: InputMaybe<Geometry_Comparison_Exp>;
  start_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  start_gps?: InputMaybe<Geometry_Comparison_Exp>;
  start_iso?: InputMaybe<String_Comparison_Exp>;
  start_location?: InputMaybe<String_Comparison_Exp>;
  start_long_location?: InputMaybe<String_Comparison_Exp>;
  start_unlocode?: InputMaybe<String_Comparison_Exp>;
  telematic_device?: InputMaybe<Container_Insights_Telematic_Devices_Bool_Exp>;
  telematic_device_id?: InputMaybe<Uuid_Comparison_Exp>;
  tradelane?: InputMaybe<String_Comparison_Exp>;
  transport_mode?: InputMaybe<Transport_Mode_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "container_insights.legs" */
export enum Container_Insights_Legs_Constraint {
  /** unique or primary key constraint on columns "id" */
  LegsPkey = 'legs_pkey',
}

/** columns and relationships of "container_insights.legs_expanded" */
export type Container_Insights_Legs_Expanded = {
  __typename?: 'container_insights_legs_expanded';
  active_energy_kwh?: Maybe<Scalars['numeric']['output']>;
  apparent_energy_kvah?: Maybe<Scalars['numeric']['output']>;
  co2_kg?: Maybe<Scalars['numeric']['output']>;
  co2eq_kg?: Maybe<Scalars['numeric']['output']>;
  detailed_transport_mode?: Maybe<Scalars['detailed_transport_mode']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  end_gps?: Maybe<Scalars['geometry']['output']>;
  end_iso?: Maybe<Scalars['String']['output']>;
  end_location?: Maybe<Scalars['String']['output']>;
  end_long_location?: Maybe<Scalars['String']['output']>;
  end_unlocode?: Maybe<Scalars['String']['output']>;
  ets_euro?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  linestring?: Maybe<Scalars['geometry']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  reefer?: Maybe<Container_Insights_Reefers>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  start_gps?: Maybe<Scalars['geometry']['output']>;
  start_iso?: Maybe<Scalars['String']['output']>;
  start_location?: Maybe<Scalars['String']['output']>;
  start_long_location?: Maybe<Scalars['String']['output']>;
  start_unlocode?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
  transport_mode?: Maybe<Scalars['transport_mode']['output']>;
};

/** aggregated selection of "container_insights.legs_expanded" */
export type Container_Insights_Legs_Expanded_Aggregate = {
  __typename?: 'container_insights_legs_expanded_aggregate';
  aggregate?: Maybe<Container_Insights_Legs_Expanded_Aggregate_Fields>;
  nodes: Array<Container_Insights_Legs_Expanded>;
};

/** aggregate fields of "container_insights.legs_expanded" */
export type Container_Insights_Legs_Expanded_Aggregate_Fields = {
  __typename?: 'container_insights_legs_expanded_aggregate_fields';
  avg?: Maybe<Container_Insights_Legs_Expanded_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Legs_Expanded_Max_Fields>;
  min?: Maybe<Container_Insights_Legs_Expanded_Min_Fields>;
  stddev?: Maybe<Container_Insights_Legs_Expanded_Stddev_Fields>;
  stddev_pop?: Maybe<Container_Insights_Legs_Expanded_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Container_Insights_Legs_Expanded_Stddev_Samp_Fields>;
  sum?: Maybe<Container_Insights_Legs_Expanded_Sum_Fields>;
  var_pop?: Maybe<Container_Insights_Legs_Expanded_Var_Pop_Fields>;
  var_samp?: Maybe<Container_Insights_Legs_Expanded_Var_Samp_Fields>;
  variance?: Maybe<Container_Insights_Legs_Expanded_Variance_Fields>;
};

/** aggregate fields of "container_insights.legs_expanded" */
export type Container_Insights_Legs_Expanded_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Container_Insights_Legs_Expanded_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Container_Insights_Legs_Expanded_Avg_Fields = {
  __typename?: 'container_insights_legs_expanded_avg_fields';
  active_energy_kwh?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kvah?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "container_insights.legs_expanded". All fields are combined with a logical 'AND'. */
export type Container_Insights_Legs_Expanded_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Legs_Expanded_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Legs_Expanded_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Legs_Expanded_Bool_Exp>>;
  active_energy_kwh?: InputMaybe<Numeric_Comparison_Exp>;
  apparent_energy_kvah?: InputMaybe<Numeric_Comparison_Exp>;
  co2_kg?: InputMaybe<Numeric_Comparison_Exp>;
  co2eq_kg?: InputMaybe<Numeric_Comparison_Exp>;
  detailed_transport_mode?: InputMaybe<Detailed_Transport_Mode_Comparison_Exp>;
  end_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_gps?: InputMaybe<Geometry_Comparison_Exp>;
  end_iso?: InputMaybe<String_Comparison_Exp>;
  end_location?: InputMaybe<String_Comparison_Exp>;
  end_long_location?: InputMaybe<String_Comparison_Exp>;
  end_unlocode?: InputMaybe<String_Comparison_Exp>;
  ets_euro?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  linestring?: InputMaybe<Geometry_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  reefer?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
  reefer_id?: InputMaybe<String_Comparison_Exp>;
  refrigeration_unit_model?: InputMaybe<String_Comparison_Exp>;
  shipping_line?: InputMaybe<String_Comparison_Exp>;
  start_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  start_gps?: InputMaybe<Geometry_Comparison_Exp>;
  start_iso?: InputMaybe<String_Comparison_Exp>;
  start_location?: InputMaybe<String_Comparison_Exp>;
  start_long_location?: InputMaybe<String_Comparison_Exp>;
  start_unlocode?: InputMaybe<String_Comparison_Exp>;
  telematic_device_id?: InputMaybe<Uuid_Comparison_Exp>;
  tradelane?: InputMaybe<String_Comparison_Exp>;
  transport_mode?: InputMaybe<Transport_Mode_Comparison_Exp>;
};

/** input type for inserting data into table "container_insights.legs_expanded" */
export type Container_Insights_Legs_Expanded_Insert_Input = {
  active_energy_kwh?: InputMaybe<Scalars['numeric']['input']>;
  apparent_energy_kvah?: InputMaybe<Scalars['numeric']['input']>;
  co2_kg?: InputMaybe<Scalars['numeric']['input']>;
  co2eq_kg?: InputMaybe<Scalars['numeric']['input']>;
  detailed_transport_mode?: InputMaybe<
    Scalars['detailed_transport_mode']['input']
  >;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  end_gps?: InputMaybe<Scalars['geometry']['input']>;
  end_iso?: InputMaybe<Scalars['String']['input']>;
  end_location?: InputMaybe<Scalars['String']['input']>;
  end_long_location?: InputMaybe<Scalars['String']['input']>;
  end_unlocode?: InputMaybe<Scalars['String']['input']>;
  ets_euro?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  linestring?: InputMaybe<Scalars['geometry']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  reefer?: InputMaybe<Container_Insights_Reefers_Obj_Rel_Insert_Input>;
  reefer_id?: InputMaybe<Scalars['String']['input']>;
  refrigeration_unit_model?: InputMaybe<Scalars['String']['input']>;
  shipping_line?: InputMaybe<Scalars['String']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  start_gps?: InputMaybe<Scalars['geometry']['input']>;
  start_iso?: InputMaybe<Scalars['String']['input']>;
  start_location?: InputMaybe<Scalars['String']['input']>;
  start_long_location?: InputMaybe<Scalars['String']['input']>;
  start_unlocode?: InputMaybe<Scalars['String']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
  transport_mode?: InputMaybe<Scalars['transport_mode']['input']>;
};

/** aggregate max on columns */
export type Container_Insights_Legs_Expanded_Max_Fields = {
  __typename?: 'container_insights_legs_expanded_max_fields';
  active_energy_kwh?: Maybe<Scalars['numeric']['output']>;
  apparent_energy_kvah?: Maybe<Scalars['numeric']['output']>;
  co2_kg?: Maybe<Scalars['numeric']['output']>;
  co2eq_kg?: Maybe<Scalars['numeric']['output']>;
  detailed_transport_mode?: Maybe<Scalars['detailed_transport_mode']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  end_iso?: Maybe<Scalars['String']['output']>;
  end_location?: Maybe<Scalars['String']['output']>;
  end_long_location?: Maybe<Scalars['String']['output']>;
  end_unlocode?: Maybe<Scalars['String']['output']>;
  ets_euro?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  start_iso?: Maybe<Scalars['String']['output']>;
  start_location?: Maybe<Scalars['String']['output']>;
  start_long_location?: Maybe<Scalars['String']['output']>;
  start_unlocode?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
  transport_mode?: Maybe<Scalars['transport_mode']['output']>;
};

/** aggregate min on columns */
export type Container_Insights_Legs_Expanded_Min_Fields = {
  __typename?: 'container_insights_legs_expanded_min_fields';
  active_energy_kwh?: Maybe<Scalars['numeric']['output']>;
  apparent_energy_kvah?: Maybe<Scalars['numeric']['output']>;
  co2_kg?: Maybe<Scalars['numeric']['output']>;
  co2eq_kg?: Maybe<Scalars['numeric']['output']>;
  detailed_transport_mode?: Maybe<Scalars['detailed_transport_mode']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  end_iso?: Maybe<Scalars['String']['output']>;
  end_location?: Maybe<Scalars['String']['output']>;
  end_long_location?: Maybe<Scalars['String']['output']>;
  end_unlocode?: Maybe<Scalars['String']['output']>;
  ets_euro?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  start_iso?: Maybe<Scalars['String']['output']>;
  start_location?: Maybe<Scalars['String']['output']>;
  start_long_location?: Maybe<Scalars['String']['output']>;
  start_unlocode?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
  transport_mode?: Maybe<Scalars['transport_mode']['output']>;
};

/** input type for inserting object relation for remote table "container_insights.legs_expanded" */
export type Container_Insights_Legs_Expanded_Obj_Rel_Insert_Input = {
  data: Container_Insights_Legs_Expanded_Insert_Input;
};

/** Ordering options when selecting data from "container_insights.legs_expanded". */
export type Container_Insights_Legs_Expanded_Order_By = {
  active_energy_kwh?: InputMaybe<Order_By>;
  apparent_energy_kvah?: InputMaybe<Order_By>;
  co2_kg?: InputMaybe<Order_By>;
  co2eq_kg?: InputMaybe<Order_By>;
  detailed_transport_mode?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  end_gps?: InputMaybe<Order_By>;
  end_iso?: InputMaybe<Order_By>;
  end_location?: InputMaybe<Order_By>;
  end_long_location?: InputMaybe<Order_By>;
  end_unlocode?: InputMaybe<Order_By>;
  ets_euro?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  linestring?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  reefer?: InputMaybe<Container_Insights_Reefers_Order_By>;
  reefer_id?: InputMaybe<Order_By>;
  refrigeration_unit_model?: InputMaybe<Order_By>;
  shipping_line?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  start_gps?: InputMaybe<Order_By>;
  start_iso?: InputMaybe<Order_By>;
  start_location?: InputMaybe<Order_By>;
  start_long_location?: InputMaybe<Order_By>;
  start_unlocode?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  tradelane?: InputMaybe<Order_By>;
  transport_mode?: InputMaybe<Order_By>;
};

/** select columns of table "container_insights.legs_expanded" */
export enum Container_Insights_Legs_Expanded_Select_Column {
  /** column name */
  ActiveEnergyKwh = 'active_energy_kwh',
  /** column name */
  ApparentEnergyKvah = 'apparent_energy_kvah',
  /** column name */
  Co2Kg = 'co2_kg',
  /** column name */
  Co2eqKg = 'co2eq_kg',
  /** column name */
  DetailedTransportMode = 'detailed_transport_mode',
  /** column name */
  EndDatetime = 'end_datetime',
  /** column name */
  EndGps = 'end_gps',
  /** column name */
  EndIso = 'end_iso',
  /** column name */
  EndLocation = 'end_location',
  /** column name */
  EndLongLocation = 'end_long_location',
  /** column name */
  EndUnlocode = 'end_unlocode',
  /** column name */
  EtsEuro = 'ets_euro',
  /** column name */
  Id = 'id',
  /** column name */
  Linestring = 'linestring',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  ReeferId = 'reefer_id',
  /** column name */
  RefrigerationUnitModel = 'refrigeration_unit_model',
  /** column name */
  ShippingLine = 'shipping_line',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  StartGps = 'start_gps',
  /** column name */
  StartIso = 'start_iso',
  /** column name */
  StartLocation = 'start_location',
  /** column name */
  StartLongLocation = 'start_long_location',
  /** column name */
  StartUnlocode = 'start_unlocode',
  /** column name */
  TelematicDeviceId = 'telematic_device_id',
  /** column name */
  Tradelane = 'tradelane',
  /** column name */
  TransportMode = 'transport_mode',
}

/** aggregate stddev on columns */
export type Container_Insights_Legs_Expanded_Stddev_Fields = {
  __typename?: 'container_insights_legs_expanded_stddev_fields';
  active_energy_kwh?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kvah?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Container_Insights_Legs_Expanded_Stddev_Pop_Fields = {
  __typename?: 'container_insights_legs_expanded_stddev_pop_fields';
  active_energy_kwh?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kvah?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Container_Insights_Legs_Expanded_Stddev_Samp_Fields = {
  __typename?: 'container_insights_legs_expanded_stddev_samp_fields';
  active_energy_kwh?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kvah?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "container_insights_legs_expanded" */
export type Container_Insights_Legs_Expanded_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Legs_Expanded_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Legs_Expanded_Stream_Cursor_Value_Input = {
  active_energy_kwh?: InputMaybe<Scalars['numeric']['input']>;
  apparent_energy_kvah?: InputMaybe<Scalars['numeric']['input']>;
  co2_kg?: InputMaybe<Scalars['numeric']['input']>;
  co2eq_kg?: InputMaybe<Scalars['numeric']['input']>;
  detailed_transport_mode?: InputMaybe<
    Scalars['detailed_transport_mode']['input']
  >;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  end_gps?: InputMaybe<Scalars['geometry']['input']>;
  end_iso?: InputMaybe<Scalars['String']['input']>;
  end_location?: InputMaybe<Scalars['String']['input']>;
  end_long_location?: InputMaybe<Scalars['String']['input']>;
  end_unlocode?: InputMaybe<Scalars['String']['input']>;
  ets_euro?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  linestring?: InputMaybe<Scalars['geometry']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  reefer_id?: InputMaybe<Scalars['String']['input']>;
  refrigeration_unit_model?: InputMaybe<Scalars['String']['input']>;
  shipping_line?: InputMaybe<Scalars['String']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  start_gps?: InputMaybe<Scalars['geometry']['input']>;
  start_iso?: InputMaybe<Scalars['String']['input']>;
  start_location?: InputMaybe<Scalars['String']['input']>;
  start_long_location?: InputMaybe<Scalars['String']['input']>;
  start_unlocode?: InputMaybe<Scalars['String']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
  transport_mode?: InputMaybe<Scalars['transport_mode']['input']>;
};

/** aggregate sum on columns */
export type Container_Insights_Legs_Expanded_Sum_Fields = {
  __typename?: 'container_insights_legs_expanded_sum_fields';
  active_energy_kwh?: Maybe<Scalars['numeric']['output']>;
  apparent_energy_kvah?: Maybe<Scalars['numeric']['output']>;
  co2_kg?: Maybe<Scalars['numeric']['output']>;
  co2eq_kg?: Maybe<Scalars['numeric']['output']>;
  ets_euro?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type Container_Insights_Legs_Expanded_Var_Pop_Fields = {
  __typename?: 'container_insights_legs_expanded_var_pop_fields';
  active_energy_kwh?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kvah?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Container_Insights_Legs_Expanded_Var_Samp_Fields = {
  __typename?: 'container_insights_legs_expanded_var_samp_fields';
  active_energy_kwh?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kvah?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Container_Insights_Legs_Expanded_Variance_Fields = {
  __typename?: 'container_insights_legs_expanded_variance_fields';
  active_energy_kwh?: Maybe<Scalars['Float']['output']>;
  apparent_energy_kvah?: Maybe<Scalars['Float']['output']>;
  co2_kg?: Maybe<Scalars['Float']['output']>;
  co2eq_kg?: Maybe<Scalars['Float']['output']>;
  ets_euro?: Maybe<Scalars['Float']['output']>;
};

/** input type for inserting data into table "container_insights.legs" */
export type Container_Insights_Legs_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  detailed_transport_mode?: InputMaybe<Scalars['detailed_transport_mode']['input']>;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  end_gps?: InputMaybe<Scalars['geometry']['input']>;
  end_iso?: InputMaybe<Scalars['String']['input']>;
  end_location?: InputMaybe<Scalars['String']['input']>;
  end_long_location?: InputMaybe<Scalars['String']['input']>;
  end_unlocode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  linestring?: InputMaybe<Scalars['geometry']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  start_gps?: InputMaybe<Scalars['geometry']['input']>;
  start_iso?: InputMaybe<Scalars['String']['input']>;
  start_location?: InputMaybe<Scalars['String']['input']>;
  start_long_location?: InputMaybe<Scalars['String']['input']>;
  start_unlocode?: InputMaybe<Scalars['String']['input']>;
  telematic_device?: InputMaybe<Container_Insights_Telematic_Devices_Obj_Rel_Insert_Input>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
  transport_mode?: InputMaybe<Scalars['transport_mode']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Container_Insights_Legs_Max_Fields = {
  __typename?: 'container_insights_legs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  detailed_transport_mode?: Maybe<Scalars['detailed_transport_mode']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  end_iso?: Maybe<Scalars['String']['output']>;
  end_location?: Maybe<Scalars['String']['output']>;
  end_long_location?: Maybe<Scalars['String']['output']>;
  end_unlocode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  start_iso?: Maybe<Scalars['String']['output']>;
  start_location?: Maybe<Scalars['String']['output']>;
  start_long_location?: Maybe<Scalars['String']['output']>;
  start_unlocode?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
  transport_mode?: Maybe<Scalars['transport_mode']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "container_insights.legs" */
export type Container_Insights_Legs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  detailed_transport_mode?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  end_iso?: InputMaybe<Order_By>;
  end_location?: InputMaybe<Order_By>;
  end_long_location?: InputMaybe<Order_By>;
  end_unlocode?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  start_iso?: InputMaybe<Order_By>;
  start_location?: InputMaybe<Order_By>;
  start_long_location?: InputMaybe<Order_By>;
  start_unlocode?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  tradelane?: InputMaybe<Order_By>;
  transport_mode?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Container_Insights_Legs_Min_Fields = {
  __typename?: 'container_insights_legs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  detailed_transport_mode?: Maybe<Scalars['detailed_transport_mode']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  end_iso?: Maybe<Scalars['String']['output']>;
  end_location?: Maybe<Scalars['String']['output']>;
  end_long_location?: Maybe<Scalars['String']['output']>;
  end_unlocode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  start_iso?: Maybe<Scalars['String']['output']>;
  start_location?: Maybe<Scalars['String']['output']>;
  start_long_location?: Maybe<Scalars['String']['output']>;
  start_unlocode?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
  transport_mode?: Maybe<Scalars['transport_mode']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "container_insights.legs" */
export type Container_Insights_Legs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  detailed_transport_mode?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  end_iso?: InputMaybe<Order_By>;
  end_location?: InputMaybe<Order_By>;
  end_long_location?: InputMaybe<Order_By>;
  end_unlocode?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  start_iso?: InputMaybe<Order_By>;
  start_location?: InputMaybe<Order_By>;
  start_long_location?: InputMaybe<Order_By>;
  start_unlocode?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  tradelane?: InputMaybe<Order_By>;
  transport_mode?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "container_insights.legs" */
export type Container_Insights_Legs_Mutation_Response = {
  __typename?: 'container_insights_legs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Container_Insights_Legs>;
};

/** on_conflict condition type for table "container_insights.legs" */
export type Container_Insights_Legs_On_Conflict = {
  constraint: Container_Insights_Legs_Constraint;
  update_columns?: Array<Container_Insights_Legs_Update_Column>;
  where?: InputMaybe<Container_Insights_Legs_Bool_Exp>;
};

/** Ordering options when selecting data from "container_insights.legs". */
export type Container_Insights_Legs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  detailed_transport_mode?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  end_gps?: InputMaybe<Order_By>;
  end_iso?: InputMaybe<Order_By>;
  end_location?: InputMaybe<Order_By>;
  end_long_location?: InputMaybe<Order_By>;
  end_unlocode?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  linestring?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  start_gps?: InputMaybe<Order_By>;
  start_iso?: InputMaybe<Order_By>;
  start_location?: InputMaybe<Order_By>;
  start_long_location?: InputMaybe<Order_By>;
  start_unlocode?: InputMaybe<Order_By>;
  telematic_device?: InputMaybe<Container_Insights_Telematic_Devices_Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  tradelane?: InputMaybe<Order_By>;
  transport_mode?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: container_insights.legs */
export type Container_Insights_Legs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "container_insights.legs" */
export enum Container_Insights_Legs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DetailedTransportMode = 'detailed_transport_mode',
  /** column name */
  EndDatetime = 'end_datetime',
  /** column name */
  EndGps = 'end_gps',
  /** column name */
  EndIso = 'end_iso',
  /** column name */
  EndLocation = 'end_location',
  /** column name */
  EndLongLocation = 'end_long_location',
  /** column name */
  EndUnlocode = 'end_unlocode',
  /** column name */
  Id = 'id',
  /** column name */
  Linestring = 'linestring',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  StartGps = 'start_gps',
  /** column name */
  StartIso = 'start_iso',
  /** column name */
  StartLocation = 'start_location',
  /** column name */
  StartLongLocation = 'start_long_location',
  /** column name */
  StartUnlocode = 'start_unlocode',
  /** column name */
  TelematicDeviceId = 'telematic_device_id',
  /** column name */
  Tradelane = 'tradelane',
  /** column name */
  TransportMode = 'transport_mode',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "container_insights.legs" */
export type Container_Insights_Legs_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  detailed_transport_mode?: InputMaybe<Scalars['detailed_transport_mode']['input']>;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  end_gps?: InputMaybe<Scalars['geometry']['input']>;
  end_iso?: InputMaybe<Scalars['String']['input']>;
  end_location?: InputMaybe<Scalars['String']['input']>;
  end_long_location?: InputMaybe<Scalars['String']['input']>;
  end_unlocode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  linestring?: InputMaybe<Scalars['geometry']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  start_gps?: InputMaybe<Scalars['geometry']['input']>;
  start_iso?: InputMaybe<Scalars['String']['input']>;
  start_location?: InputMaybe<Scalars['String']['input']>;
  start_long_location?: InputMaybe<Scalars['String']['input']>;
  start_unlocode?: InputMaybe<Scalars['String']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
  transport_mode?: InputMaybe<Scalars['transport_mode']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "container_insights_legs" */
export type Container_Insights_Legs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Legs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Legs_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  detailed_transport_mode?: InputMaybe<Scalars['detailed_transport_mode']['input']>;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  end_gps?: InputMaybe<Scalars['geometry']['input']>;
  end_iso?: InputMaybe<Scalars['String']['input']>;
  end_location?: InputMaybe<Scalars['String']['input']>;
  end_long_location?: InputMaybe<Scalars['String']['input']>;
  end_unlocode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  linestring?: InputMaybe<Scalars['geometry']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  start_gps?: InputMaybe<Scalars['geometry']['input']>;
  start_iso?: InputMaybe<Scalars['String']['input']>;
  start_location?: InputMaybe<Scalars['String']['input']>;
  start_long_location?: InputMaybe<Scalars['String']['input']>;
  start_unlocode?: InputMaybe<Scalars['String']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
  transport_mode?: InputMaybe<Scalars['transport_mode']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "container_insights.legs" */
export enum Container_Insights_Legs_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DetailedTransportMode = 'detailed_transport_mode',
  /** column name */
  EndDatetime = 'end_datetime',
  /** column name */
  EndGps = 'end_gps',
  /** column name */
  EndIso = 'end_iso',
  /** column name */
  EndLocation = 'end_location',
  /** column name */
  EndLongLocation = 'end_long_location',
  /** column name */
  EndUnlocode = 'end_unlocode',
  /** column name */
  Id = 'id',
  /** column name */
  Linestring = 'linestring',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  StartGps = 'start_gps',
  /** column name */
  StartIso = 'start_iso',
  /** column name */
  StartLocation = 'start_location',
  /** column name */
  StartLongLocation = 'start_long_location',
  /** column name */
  StartUnlocode = 'start_unlocode',
  /** column name */
  TelematicDeviceId = 'telematic_device_id',
  /** column name */
  Tradelane = 'tradelane',
  /** column name */
  TransportMode = 'transport_mode',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Container_Insights_Legs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Container_Insights_Legs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Container_Insights_Legs_Bool_Exp;
};

/** columns and relationships of "container_insights.manufacturers" */
export type Container_Insights_Manufacturers = {
  __typename?: 'container_insights_manufacturers';
  /** An array relationship */
  controller_models: Array<Container_Insights_Controller_Models>;
  /** An aggregate relationship */
  controller_models_aggregate: Container_Insights_Controller_Models_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  refrigeration_unit_models: Array<Container_Insights_Refrigeration_Unit_Models>;
  /** An aggregate relationship */
  refrigeration_unit_models_aggregate: Container_Insights_Refrigeration_Unit_Models_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "container_insights.manufacturers" */
export type Container_Insights_ManufacturersController_ModelsArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Controller_Models_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Controller_Models_Order_By>>;
  where?: InputMaybe<Container_Insights_Controller_Models_Bool_Exp>;
};

/** columns and relationships of "container_insights.manufacturers" */
export type Container_Insights_ManufacturersController_Models_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Controller_Models_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Controller_Models_Order_By>>;
  where?: InputMaybe<Container_Insights_Controller_Models_Bool_Exp>;
};

/** columns and relationships of "container_insights.manufacturers" */
export type Container_Insights_ManufacturersRefrigeration_Unit_ModelsArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Refrigeration_Unit_Models_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<
    Array<Container_Insights_Refrigeration_Unit_Models_Order_By>
  >;
  where?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
};

/** columns and relationships of "container_insights.manufacturers" */
export type Container_Insights_ManufacturersRefrigeration_Unit_Models_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Refrigeration_Unit_Models_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Refrigeration_Unit_Models_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
  };

/** aggregated selection of "container_insights.manufacturers" */
export type Container_Insights_Manufacturers_Aggregate = {
  __typename?: 'container_insights_manufacturers_aggregate';
  aggregate?: Maybe<Container_Insights_Manufacturers_Aggregate_Fields>;
  nodes: Array<Container_Insights_Manufacturers>;
};

/** aggregate fields of "container_insights.manufacturers" */
export type Container_Insights_Manufacturers_Aggregate_Fields = {
  __typename?: 'container_insights_manufacturers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Manufacturers_Max_Fields>;
  min?: Maybe<Container_Insights_Manufacturers_Min_Fields>;
};

/** aggregate fields of "container_insights.manufacturers" */
export type Container_Insights_Manufacturers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Container_Insights_Manufacturers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "container_insights.manufacturers". All fields are combined with a logical 'AND'. */
export type Container_Insights_Manufacturers_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Manufacturers_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Manufacturers_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Manufacturers_Bool_Exp>>;
  controller_models?: InputMaybe<Container_Insights_Controller_Models_Bool_Exp>;
  controller_models_aggregate?: InputMaybe<Container_Insights_Controller_Models_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  refrigeration_unit_models?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
  refrigeration_unit_models_aggregate?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "container_insights.manufacturers" */
export enum Container_Insights_Manufacturers_Constraint {
  /** unique or primary key constraint on columns "name" */
  ManufacturersNameKey = 'manufacturers_name_key',
  /** unique or primary key constraint on columns "id" */
  ManufacturersPkey = 'manufacturers_pkey',
}

/** input type for inserting data into table "container_insights.manufacturers" */
export type Container_Insights_Manufacturers_Insert_Input = {
  controller_models?: InputMaybe<Container_Insights_Controller_Models_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  refrigeration_unit_models?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Container_Insights_Manufacturers_Max_Fields = {
  __typename?: 'container_insights_manufacturers_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Container_Insights_Manufacturers_Min_Fields = {
  __typename?: 'container_insights_manufacturers_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "container_insights.manufacturers" */
export type Container_Insights_Manufacturers_Mutation_Response = {
  __typename?: 'container_insights_manufacturers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Container_Insights_Manufacturers>;
};

/** input type for inserting object relation for remote table "container_insights.manufacturers" */
export type Container_Insights_Manufacturers_Obj_Rel_Insert_Input = {
  data: Container_Insights_Manufacturers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Container_Insights_Manufacturers_On_Conflict>;
};

/** on_conflict condition type for table "container_insights.manufacturers" */
export type Container_Insights_Manufacturers_On_Conflict = {
  constraint: Container_Insights_Manufacturers_Constraint;
  update_columns?: Array<Container_Insights_Manufacturers_Update_Column>;
  where?: InputMaybe<Container_Insights_Manufacturers_Bool_Exp>;
};

/** Ordering options when selecting data from "container_insights.manufacturers". */
export type Container_Insights_Manufacturers_Order_By = {
  controller_models_aggregate?: InputMaybe<Container_Insights_Controller_Models_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  refrigeration_unit_models_aggregate?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: container_insights.manufacturers */
export type Container_Insights_Manufacturers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "container_insights.manufacturers" */
export enum Container_Insights_Manufacturers_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "container_insights.manufacturers" */
export type Container_Insights_Manufacturers_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "container_insights_manufacturers" */
export type Container_Insights_Manufacturers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Manufacturers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Manufacturers_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "container_insights.manufacturers" */
export enum Container_Insights_Manufacturers_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Container_Insights_Manufacturers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Container_Insights_Manufacturers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Container_Insights_Manufacturers_Bool_Exp;
};

/** columns and relationships of "container_insights.reefers" */
export type Container_Insights_Reefers = {
  __typename?: 'container_insights_reefers';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['String']['output'];
  manufacture_date?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  refrigeration_unit_model: Container_Insights_Refrigeration_Unit_Models;
  refrigeration_unit_model_id: Scalars['uuid']['output'];
  /** An object relationship */
  shipping_line: Container_Insights_Shipping_Lines;
  shipping_line_id: Scalars['uuid']['output'];
  /** An array relationship */
  telematic_device_assignments: Array<Container_Insights_Telematic_Device_Assignment>;
  /** An aggregate relationship */
  telematic_device_assignments_aggregate: Container_Insights_Telematic_Device_Assignment_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "container_insights.reefers" */
export type Container_Insights_ReefersTelematic_Device_AssignmentsArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Telematic_Device_Assignment_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<
    Array<Container_Insights_Telematic_Device_Assignment_Order_By>
  >;
  where?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Bool_Exp>;
};

/** columns and relationships of "container_insights.reefers" */
export type Container_Insights_ReefersTelematic_Device_Assignments_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Bool_Exp>;
  };

/** aggregated selection of "container_insights.reefers" */
export type Container_Insights_Reefers_Aggregate = {
  __typename?: 'container_insights_reefers_aggregate';
  aggregate?: Maybe<Container_Insights_Reefers_Aggregate_Fields>;
  nodes: Array<Container_Insights_Reefers>;
};

export type Container_Insights_Reefers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Container_Insights_Reefers_Aggregate_Bool_Exp_Count>;
};

export type Container_Insights_Reefers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Container_Insights_Reefers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "container_insights.reefers" */
export type Container_Insights_Reefers_Aggregate_Fields = {
  __typename?: 'container_insights_reefers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Reefers_Max_Fields>;
  min?: Maybe<Container_Insights_Reefers_Min_Fields>;
};

/** aggregate fields of "container_insights.reefers" */
export type Container_Insights_Reefers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Container_Insights_Reefers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "container_insights.reefers" */
export type Container_Insights_Reefers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Container_Insights_Reefers_Max_Order_By>;
  min?: InputMaybe<Container_Insights_Reefers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "container_insights.reefers" */
export type Container_Insights_Reefers_Arr_Rel_Insert_Input = {
  data: Array<Container_Insights_Reefers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Container_Insights_Reefers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "container_insights.reefers". All fields are combined with a logical 'AND'. */
export type Container_Insights_Reefers_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Reefers_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Reefers_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  manufacture_date?: InputMaybe<Date_Comparison_Exp>;
  refrigeration_unit_model?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
  refrigeration_unit_model_id?: InputMaybe<Uuid_Comparison_Exp>;
  shipping_line?: InputMaybe<Container_Insights_Shipping_Lines_Bool_Exp>;
  shipping_line_id?: InputMaybe<Uuid_Comparison_Exp>;
  telematic_device_assignments?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Bool_Exp>;
  telematic_device_assignments_aggregate?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "container_insights.reefers" */
export enum Container_Insights_Reefers_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReefersPkey = 'reefers_pkey',
}

/** columns and relationships of "container_insights.reefers_expanded" */
export type Container_Insights_Reefers_Expanded = {
  __typename?: 'container_insights_reefers_expanded';
  age?: Maybe<Scalars['numeric']['output']>;
  age_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  shipping_line_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  shipping_line_object?: Maybe<Container_Insights_Shipping_Lines>;
};

/** aggregated selection of "container_insights.reefers_expanded" */
export type Container_Insights_Reefers_Expanded_Aggregate = {
  __typename?: 'container_insights_reefers_expanded_aggregate';
  aggregate?: Maybe<Container_Insights_Reefers_Expanded_Aggregate_Fields>;
  nodes: Array<Container_Insights_Reefers_Expanded>;
};

/** aggregate fields of "container_insights.reefers_expanded" */
export type Container_Insights_Reefers_Expanded_Aggregate_Fields = {
  __typename?: 'container_insights_reefers_expanded_aggregate_fields';
  avg?: Maybe<Container_Insights_Reefers_Expanded_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Reefers_Expanded_Max_Fields>;
  min?: Maybe<Container_Insights_Reefers_Expanded_Min_Fields>;
  stddev?: Maybe<Container_Insights_Reefers_Expanded_Stddev_Fields>;
  stddev_pop?: Maybe<Container_Insights_Reefers_Expanded_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Container_Insights_Reefers_Expanded_Stddev_Samp_Fields>;
  sum?: Maybe<Container_Insights_Reefers_Expanded_Sum_Fields>;
  var_pop?: Maybe<Container_Insights_Reefers_Expanded_Var_Pop_Fields>;
  var_samp?: Maybe<Container_Insights_Reefers_Expanded_Var_Samp_Fields>;
  variance?: Maybe<Container_Insights_Reefers_Expanded_Variance_Fields>;
};

/** aggregate fields of "container_insights.reefers_expanded" */
export type Container_Insights_Reefers_Expanded_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<
    Array<Container_Insights_Reefers_Expanded_Select_Column>
  >;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Container_Insights_Reefers_Expanded_Avg_Fields = {
  __typename?: 'container_insights_reefers_expanded_avg_fields';
  age?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "container_insights.reefers_expanded". All fields are combined with a logical 'AND'. */
export type Container_Insights_Reefers_Expanded_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Reefers_Expanded_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Reefers_Expanded_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Reefers_Expanded_Bool_Exp>>;
  age?: InputMaybe<Numeric_Comparison_Exp>;
  age_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  refrigeration_unit_model?: InputMaybe<String_Comparison_Exp>;
  shipping_line?: InputMaybe<String_Comparison_Exp>;
  shipping_line_id?: InputMaybe<Uuid_Comparison_Exp>;
  shipping_line_object?: InputMaybe<Container_Insights_Shipping_Lines_Bool_Exp>;
};

/** input type for inserting data into table "container_insights.reefers_expanded" */
export type Container_Insights_Reefers_Expanded_Insert_Input = {
  age?: InputMaybe<Scalars['numeric']['input']>;
  age_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  refrigeration_unit_model?: InputMaybe<Scalars['String']['input']>;
  shipping_line?: InputMaybe<Scalars['String']['input']>;
  shipping_line_id?: InputMaybe<Scalars['uuid']['input']>;
  shipping_line_object?: InputMaybe<Container_Insights_Shipping_Lines_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Container_Insights_Reefers_Expanded_Max_Fields = {
  __typename?: 'container_insights_reefers_expanded_max_fields';
  age?: Maybe<Scalars['numeric']['output']>;
  age_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  shipping_line_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Container_Insights_Reefers_Expanded_Min_Fields = {
  __typename?: 'container_insights_reefers_expanded_min_fields';
  age?: Maybe<Scalars['numeric']['output']>;
  age_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  shipping_line_id?: Maybe<Scalars['uuid']['output']>;
};

/** input type for inserting object relation for remote table "container_insights.reefers_expanded" */
export type Container_Insights_Reefers_Expanded_Obj_Rel_Insert_Input = {
  data: Container_Insights_Reefers_Expanded_Insert_Input;
};

/** Ordering options when selecting data from "container_insights.reefers_expanded". */
export type Container_Insights_Reefers_Expanded_Order_By = {
  age?: InputMaybe<Order_By>;
  age_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  refrigeration_unit_model?: InputMaybe<Order_By>;
  shipping_line?: InputMaybe<Order_By>;
  shipping_line_id?: InputMaybe<Order_By>;
  shipping_line_object?: InputMaybe<Container_Insights_Shipping_Lines_Order_By>;
};

/** select columns of table "container_insights.reefers_expanded" */
export enum Container_Insights_Reefers_Expanded_Select_Column {
  /** column name */
  Age = 'age',
  /** column name */
  AgeId = 'age_id',
  /** column name */
  Id = 'id',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  RefrigerationUnitModel = 'refrigeration_unit_model',
  /** column name */
  ShippingLine = 'shipping_line',
  /** column name */
  ShippingLineId = 'shipping_line_id',
}

/** aggregate stddev on columns */
export type Container_Insights_Reefers_Expanded_Stddev_Fields = {
  __typename?: 'container_insights_reefers_expanded_stddev_fields';
  age?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Container_Insights_Reefers_Expanded_Stddev_Pop_Fields = {
  __typename?: 'container_insights_reefers_expanded_stddev_pop_fields';
  age?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Container_Insights_Reefers_Expanded_Stddev_Samp_Fields = {
  __typename?: 'container_insights_reefers_expanded_stddev_samp_fields';
  age?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "container_insights_reefers_expanded" */
export type Container_Insights_Reefers_Expanded_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Reefers_Expanded_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Reefers_Expanded_Stream_Cursor_Value_Input = {
  age?: InputMaybe<Scalars['numeric']['input']>;
  age_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  refrigeration_unit_model?: InputMaybe<Scalars['String']['input']>;
  shipping_line?: InputMaybe<Scalars['String']['input']>;
  shipping_line_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Container_Insights_Reefers_Expanded_Sum_Fields = {
  __typename?: 'container_insights_reefers_expanded_sum_fields';
  age?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type Container_Insights_Reefers_Expanded_Var_Pop_Fields = {
  __typename?: 'container_insights_reefers_expanded_var_pop_fields';
  age?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Container_Insights_Reefers_Expanded_Var_Samp_Fields = {
  __typename?: 'container_insights_reefers_expanded_var_samp_fields';
  age?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Container_Insights_Reefers_Expanded_Variance_Fields = {
  __typename?: 'container_insights_reefers_expanded_variance_fields';
  age?: Maybe<Scalars['Float']['output']>;
};

/** input type for inserting data into table "container_insights.reefers" */
export type Container_Insights_Reefers_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  manufacture_date?: InputMaybe<Scalars['date']['input']>;
  refrigeration_unit_model?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Obj_Rel_Insert_Input>;
  refrigeration_unit_model_id?: InputMaybe<Scalars['uuid']['input']>;
  shipping_line?: InputMaybe<Container_Insights_Shipping_Lines_Obj_Rel_Insert_Input>;
  shipping_line_id?: InputMaybe<Scalars['uuid']['input']>;
  telematic_device_assignments?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Container_Insights_Reefers_Max_Fields = {
  __typename?: 'container_insights_reefers_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  manufacture_date?: Maybe<Scalars['date']['output']>;
  refrigeration_unit_model_id?: Maybe<Scalars['uuid']['output']>;
  shipping_line_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "container_insights.reefers" */
export type Container_Insights_Reefers_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manufacture_date?: InputMaybe<Order_By>;
  refrigeration_unit_model_id?: InputMaybe<Order_By>;
  shipping_line_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Container_Insights_Reefers_Min_Fields = {
  __typename?: 'container_insights_reefers_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  manufacture_date?: Maybe<Scalars['date']['output']>;
  refrigeration_unit_model_id?: Maybe<Scalars['uuid']['output']>;
  shipping_line_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "container_insights.reefers" */
export type Container_Insights_Reefers_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manufacture_date?: InputMaybe<Order_By>;
  refrigeration_unit_model_id?: InputMaybe<Order_By>;
  shipping_line_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "container_insights.reefers" */
export type Container_Insights_Reefers_Mutation_Response = {
  __typename?: 'container_insights_reefers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Container_Insights_Reefers>;
};

/** input type for inserting object relation for remote table "container_insights.reefers" */
export type Container_Insights_Reefers_Obj_Rel_Insert_Input = {
  data: Container_Insights_Reefers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Container_Insights_Reefers_On_Conflict>;
};

/** on_conflict condition type for table "container_insights.reefers" */
export type Container_Insights_Reefers_On_Conflict = {
  constraint: Container_Insights_Reefers_Constraint;
  update_columns?: Array<Container_Insights_Reefers_Update_Column>;
  where?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
};

/** Ordering options when selecting data from "container_insights.reefers". */
export type Container_Insights_Reefers_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manufacture_date?: InputMaybe<Order_By>;
  refrigeration_unit_model?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Order_By>;
  refrigeration_unit_model_id?: InputMaybe<Order_By>;
  shipping_line?: InputMaybe<Container_Insights_Shipping_Lines_Order_By>;
  shipping_line_id?: InputMaybe<Order_By>;
  telematic_device_assignments_aggregate?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: container_insights.reefers */
export type Container_Insights_Reefers_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "container_insights.reefers" */
export enum Container_Insights_Reefers_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManufactureDate = 'manufacture_date',
  /** column name */
  RefrigerationUnitModelId = 'refrigeration_unit_model_id',
  /** column name */
  ShippingLineId = 'shipping_line_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "container_insights.reefers" */
export type Container_Insights_Reefers_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  manufacture_date?: InputMaybe<Scalars['date']['input']>;
  refrigeration_unit_model_id?: InputMaybe<Scalars['uuid']['input']>;
  shipping_line_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "container_insights_reefers" */
export type Container_Insights_Reefers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Reefers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Reefers_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  manufacture_date?: InputMaybe<Scalars['date']['input']>;
  refrigeration_unit_model_id?: InputMaybe<Scalars['uuid']['input']>;
  shipping_line_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "container_insights.reefers" */
export enum Container_Insights_Reefers_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManufactureDate = 'manufacture_date',
  /** column name */
  RefrigerationUnitModelId = 'refrigeration_unit_model_id',
  /** column name */
  ShippingLineId = 'shipping_line_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Container_Insights_Reefers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Container_Insights_Reefers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Container_Insights_Reefers_Bool_Exp;
};

/** columns and relationships of "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models = {
  __typename?: 'container_insights_refrigeration_unit_models';
  age?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  controller_model?: Maybe<Container_Insights_Controller_Models>;
  controller_model_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  /** An object relationship */
  manufacturer: Container_Insights_Manufacturers;
  manufacturer_id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  reefers: Array<Container_Insights_Reefers>;
  /** An aggregate relationship */
  reefers_aggregate: Container_Insights_Reefers_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_ModelsReefersArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Reefers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Reefers_Order_By>>;
  where?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
};

/** columns and relationships of "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_ModelsReefers_AggregateArgs =
  {
    distinct_on?: InputMaybe<Array<Container_Insights_Reefers_Select_Column>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Container_Insights_Reefers_Order_By>>;
    where?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
  };

/** aggregated selection of "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Aggregate = {
  __typename?: 'container_insights_refrigeration_unit_models_aggregate';
  aggregate?: Maybe<Container_Insights_Refrigeration_Unit_Models_Aggregate_Fields>;
  nodes: Array<Container_Insights_Refrigeration_Unit_Models>;
};

export type Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Var_Samp>;
};

export type Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Avg =
  {
    arguments: Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Avg_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
  };

export type Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Corr =
  {
    arguments: Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Corr_Arguments;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
  };

export type Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Corr_Arguments =
  {
    X: Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Corr_Arguments_Columns;
    Y: Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  };

export type Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Count =
  {
    arguments?: InputMaybe<
      Array<Container_Insights_Refrigeration_Unit_Models_Select_Column>
    >;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
    predicate: Int_Comparison_Exp;
  };

export type Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Covar_Samp =
  {
    arguments: Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Covar_Samp_Arguments;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
  };

export type Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Covar_Samp_Arguments =
  {
    X: Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
    Y: Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  };

export type Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Max =
  {
    arguments: Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Max_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
  };

export type Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Min =
  {
    arguments: Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Min_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
  };

export type Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Stddev_Samp =
  {
    arguments: Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
  };

export type Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Sum =
  {
    arguments: Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Sum_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
  };

export type Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Var_Samp =
  {
    arguments: Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
  };

/** aggregate fields of "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Aggregate_Fields = {
  __typename?: 'container_insights_refrigeration_unit_models_aggregate_fields';
  avg?: Maybe<Container_Insights_Refrigeration_Unit_Models_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Refrigeration_Unit_Models_Max_Fields>;
  min?: Maybe<Container_Insights_Refrigeration_Unit_Models_Min_Fields>;
  stddev?: Maybe<Container_Insights_Refrigeration_Unit_Models_Stddev_Fields>;
  stddev_pop?: Maybe<Container_Insights_Refrigeration_Unit_Models_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Container_Insights_Refrigeration_Unit_Models_Stddev_Samp_Fields>;
  sum?: Maybe<Container_Insights_Refrigeration_Unit_Models_Sum_Fields>;
  var_pop?: Maybe<Container_Insights_Refrigeration_Unit_Models_Var_Pop_Fields>;
  var_samp?: Maybe<Container_Insights_Refrigeration_Unit_Models_Var_Samp_Fields>;
  variance?: Maybe<Container_Insights_Refrigeration_Unit_Models_Variance_Fields>;
};

/** aggregate fields of "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Container_Insights_Refrigeration_Unit_Models_Select_Column>
    >;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
  };

/** order by aggregate values of table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Aggregate_Order_By = {
  avg?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Max_Order_By>;
  min?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Min_Order_By>;
  stddev?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Sum_Order_By>;
  var_pop?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Var_Samp_Order_By>;
  variance?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Arr_Rel_Insert_Input =
  {
    data: Array<Container_Insights_Refrigeration_Unit_Models_Insert_Input>;
    /** upsert condition */
    on_conflict?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_On_Conflict>;
  };

/** aggregate avg on columns */
export type Container_Insights_Refrigeration_Unit_Models_Avg_Fields = {
  __typename?: 'container_insights_refrigeration_unit_models_avg_fields';
  age?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Avg_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "container_insights.refrigeration_unit_models". All fields are combined with a logical 'AND'. */
export type Container_Insights_Refrigeration_Unit_Models_Bool_Exp = {
  _and?: InputMaybe<
    Array<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>
  >;
  _not?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
  _or?: InputMaybe<
    Array<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>
  >;
  age?: InputMaybe<Float8_Comparison_Exp>;
  controller_model?: InputMaybe<Container_Insights_Controller_Models_Bool_Exp>;
  controller_model_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  manufacturer?: InputMaybe<Container_Insights_Manufacturers_Bool_Exp>;
  manufacturer_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  reefers?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
  reefers_aggregate?: InputMaybe<Container_Insights_Reefers_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "container_insights.refrigeration_unit_models" */
export enum Container_Insights_Refrigeration_Unit_Models_Constraint {
  /** unique or primary key constraint on columns "name" */
  RefrigerationUnitModelsNameKey = 'refrigeration_unit_models_name_key',
  /** unique or primary key constraint on columns "id" */
  RefrigerationUnitModelsPkey = 'refrigeration_unit_models_pkey',
}

/** input type for incrementing numeric columns in table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Inc_Input = {
  age?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Insert_Input = {
  age?: InputMaybe<Scalars['float8']['input']>;
  controller_model?: InputMaybe<Container_Insights_Controller_Models_Obj_Rel_Insert_Input>;
  controller_model_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Container_Insights_Manufacturers_Obj_Rel_Insert_Input>;
  manufacturer_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reefers?: InputMaybe<Container_Insights_Reefers_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Container_Insights_Refrigeration_Unit_Models_Max_Fields = {
  __typename?: 'container_insights_refrigeration_unit_models_max_fields';
  age?: Maybe<Scalars['float8']['output']>;
  controller_model_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  manufacturer_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Max_Order_By = {
  age?: InputMaybe<Order_By>;
  controller_model_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  manufacturer_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Container_Insights_Refrigeration_Unit_Models_Min_Fields = {
  __typename?: 'container_insights_refrigeration_unit_models_min_fields';
  age?: Maybe<Scalars['float8']['output']>;
  controller_model_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  manufacturer_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Min_Order_By = {
  age?: InputMaybe<Order_By>;
  controller_model_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  manufacturer_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Mutation_Response = {
  __typename?: 'container_insights_refrigeration_unit_models_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Container_Insights_Refrigeration_Unit_Models>;
};

/** input type for inserting object relation for remote table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Obj_Rel_Insert_Input =
  {
    data: Container_Insights_Refrigeration_Unit_Models_Insert_Input;
    /** upsert condition */
    on_conflict?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_On_Conflict>;
  };

/** on_conflict condition type for table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_On_Conflict = {
  constraint: Container_Insights_Refrigeration_Unit_Models_Constraint;
  update_columns?: Array<Container_Insights_Refrigeration_Unit_Models_Update_Column>;
  where?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
};

/** Ordering options when selecting data from "container_insights.refrigeration_unit_models". */
export type Container_Insights_Refrigeration_Unit_Models_Order_By = {
  age?: InputMaybe<Order_By>;
  controller_model?: InputMaybe<Container_Insights_Controller_Models_Order_By>;
  controller_model_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Container_Insights_Manufacturers_Order_By>;
  manufacturer_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  reefers_aggregate?: InputMaybe<Container_Insights_Reefers_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: container_insights.refrigeration_unit_models */
export type Container_Insights_Refrigeration_Unit_Models_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "container_insights.refrigeration_unit_models" */
export enum Container_Insights_Refrigeration_Unit_Models_Select_Column {
  /** column name */
  Age = 'age',
  /** column name */
  ControllerModelId = 'controller_model_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  ManufacturerId = 'manufacturer_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "container_insights_refrigeration_unit_models_aggregate_bool_exp_avg_arguments_columns" columns of table "container_insights.refrigeration_unit_models" */
export enum Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Age = 'age',
}

/** select "container_insights_refrigeration_unit_models_aggregate_bool_exp_corr_arguments_columns" columns of table "container_insights.refrigeration_unit_models" */
export enum Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Age = 'age',
}

/** select "container_insights_refrigeration_unit_models_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "container_insights.refrigeration_unit_models" */
export enum Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Age = 'age',
}

/** select "container_insights_refrigeration_unit_models_aggregate_bool_exp_max_arguments_columns" columns of table "container_insights.refrigeration_unit_models" */
export enum Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Age = 'age',
}

/** select "container_insights_refrigeration_unit_models_aggregate_bool_exp_min_arguments_columns" columns of table "container_insights.refrigeration_unit_models" */
export enum Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Age = 'age',
}

/** select "container_insights_refrigeration_unit_models_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "container_insights.refrigeration_unit_models" */
export enum Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Age = 'age',
}

/** select "container_insights_refrigeration_unit_models_aggregate_bool_exp_sum_arguments_columns" columns of table "container_insights.refrigeration_unit_models" */
export enum Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Age = 'age',
}

/** select "container_insights_refrigeration_unit_models_aggregate_bool_exp_var_samp_arguments_columns" columns of table "container_insights.refrigeration_unit_models" */
export enum Container_Insights_Refrigeration_Unit_Models_Select_Column_Container_Insights_Refrigeration_Unit_Models_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Age = 'age',
}

/** input type for updating data in table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Set_Input = {
  age?: InputMaybe<Scalars['float8']['input']>;
  controller_model_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  manufacturer_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Container_Insights_Refrigeration_Unit_Models_Stddev_Fields = {
  __typename?: 'container_insights_refrigeration_unit_models_stddev_fields';
  age?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Stddev_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Container_Insights_Refrigeration_Unit_Models_Stddev_Pop_Fields = {
  __typename?: 'container_insights_refrigeration_unit_models_stddev_pop_fields';
  age?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Stddev_Pop_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Container_Insights_Refrigeration_Unit_Models_Stddev_Samp_Fields = {
  __typename?: 'container_insights_refrigeration_unit_models_stddev_samp_fields';
  age?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Stddev_Samp_Order_By =
  {
    age?: InputMaybe<Order_By>;
  };

/** Streaming cursor of the table "container_insights_refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Refrigeration_Unit_Models_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Refrigeration_Unit_Models_Stream_Cursor_Value_Input = {
  age?: InputMaybe<Scalars['float8']['input']>;
  controller_model_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  manufacturer_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Container_Insights_Refrigeration_Unit_Models_Sum_Fields = {
  __typename?: 'container_insights_refrigeration_unit_models_sum_fields';
  age?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Sum_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** update columns of table "container_insights.refrigeration_unit_models" */
export enum Container_Insights_Refrigeration_Unit_Models_Update_Column {
  /** column name */
  Age = 'age',
  /** column name */
  ControllerModelId = 'controller_model_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  ManufacturerId = 'manufacturer_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Container_Insights_Refrigeration_Unit_Models_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Set_Input>;
  /** filter the rows which have to be updated */
  where: Container_Insights_Refrigeration_Unit_Models_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Container_Insights_Refrigeration_Unit_Models_Var_Pop_Fields = {
  __typename?: 'container_insights_refrigeration_unit_models_var_pop_fields';
  age?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Var_Pop_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Container_Insights_Refrigeration_Unit_Models_Var_Samp_Fields = {
  __typename?: 'container_insights_refrigeration_unit_models_var_samp_fields';
  age?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Var_Samp_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Container_Insights_Refrigeration_Unit_Models_Variance_Fields = {
  __typename?: 'container_insights_refrigeration_unit_models_variance_fields';
  age?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "container_insights.refrigeration_unit_models" */
export type Container_Insights_Refrigeration_Unit_Models_Variance_Order_By = {
  age?: InputMaybe<Order_By>;
};

/** columns and relationships of "container_insights.shipping_lines" */
export type Container_Insights_Shipping_Lines = {
  __typename?: 'container_insights_shipping_lines';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  reefers: Array<Container_Insights_Reefers>;
  /** An aggregate relationship */
  reefers_aggregate: Container_Insights_Reefers_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  user_shipping_lines_authorizations: Array<Container_Insights_User_Shipping_Lines_Authorizations>;
  /** An aggregate relationship */
  user_shipping_lines_authorizations_aggregate: Container_Insights_User_Shipping_Lines_Authorizations_Aggregate;
};

/** columns and relationships of "container_insights.shipping_lines" */
export type Container_Insights_Shipping_LinesReefersArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Reefers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Reefers_Order_By>>;
  where?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
};

/** columns and relationships of "container_insights.shipping_lines" */
export type Container_Insights_Shipping_LinesReefers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Reefers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Reefers_Order_By>>;
  where?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
};

/** columns and relationships of "container_insights.shipping_lines" */
export type Container_Insights_Shipping_LinesUser_Shipping_Lines_AuthorizationsArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Order_By>
    >;
    where?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp>;
  };

/** columns and relationships of "container_insights.shipping_lines" */
export type Container_Insights_Shipping_LinesUser_Shipping_Lines_Authorizations_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Order_By>
    >;
    where?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp>;
  };

/** aggregated selection of "container_insights.shipping_lines" */
export type Container_Insights_Shipping_Lines_Aggregate = {
  __typename?: 'container_insights_shipping_lines_aggregate';
  aggregate?: Maybe<Container_Insights_Shipping_Lines_Aggregate_Fields>;
  nodes: Array<Container_Insights_Shipping_Lines>;
};

/** aggregate fields of "container_insights.shipping_lines" */
export type Container_Insights_Shipping_Lines_Aggregate_Fields = {
  __typename?: 'container_insights_shipping_lines_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Shipping_Lines_Max_Fields>;
  min?: Maybe<Container_Insights_Shipping_Lines_Min_Fields>;
};

/** aggregate fields of "container_insights.shipping_lines" */
export type Container_Insights_Shipping_Lines_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Container_Insights_Shipping_Lines_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "container_insights.shipping_lines". All fields are combined with a logical 'AND'. */
export type Container_Insights_Shipping_Lines_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Shipping_Lines_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Shipping_Lines_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Shipping_Lines_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  reefers?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
  reefers_aggregate?: InputMaybe<Container_Insights_Reefers_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_shipping_lines_authorizations?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp>;
  user_shipping_lines_authorizations_aggregate?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "container_insights.shipping_lines" */
export enum Container_Insights_Shipping_Lines_Constraint {
  /** unique or primary key constraint on columns "name" */
  ShippingLinesNameKey = 'shipping_lines_name_key',
  /** unique or primary key constraint on columns "id" */
  ShippingLinesPkey = 'shipping_lines_pkey',
}

/** input type for inserting data into table "container_insights.shipping_lines" */
export type Container_Insights_Shipping_Lines_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reefers?: InputMaybe<Container_Insights_Reefers_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_shipping_lines_authorizations?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Container_Insights_Shipping_Lines_Max_Fields = {
  __typename?: 'container_insights_shipping_lines_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Container_Insights_Shipping_Lines_Min_Fields = {
  __typename?: 'container_insights_shipping_lines_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "container_insights.shipping_lines" */
export type Container_Insights_Shipping_Lines_Mutation_Response = {
  __typename?: 'container_insights_shipping_lines_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Container_Insights_Shipping_Lines>;
};

/** input type for inserting object relation for remote table "container_insights.shipping_lines" */
export type Container_Insights_Shipping_Lines_Obj_Rel_Insert_Input = {
  data: Container_Insights_Shipping_Lines_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Container_Insights_Shipping_Lines_On_Conflict>;
};

/** on_conflict condition type for table "container_insights.shipping_lines" */
export type Container_Insights_Shipping_Lines_On_Conflict = {
  constraint: Container_Insights_Shipping_Lines_Constraint;
  update_columns?: Array<Container_Insights_Shipping_Lines_Update_Column>;
  where?: InputMaybe<Container_Insights_Shipping_Lines_Bool_Exp>;
};

/** Ordering options when selecting data from "container_insights.shipping_lines". */
export type Container_Insights_Shipping_Lines_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  reefers_aggregate?: InputMaybe<Container_Insights_Reefers_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_shipping_lines_authorizations_aggregate?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Aggregate_Order_By>;
};

/** primary key columns input for table: container_insights.shipping_lines */
export type Container_Insights_Shipping_Lines_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "container_insights.shipping_lines" */
export enum Container_Insights_Shipping_Lines_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "container_insights.shipping_lines" */
export type Container_Insights_Shipping_Lines_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "container_insights_shipping_lines" */
export type Container_Insights_Shipping_Lines_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Shipping_Lines_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Shipping_Lines_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "container_insights.shipping_lines" */
export enum Container_Insights_Shipping_Lines_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Container_Insights_Shipping_Lines_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Container_Insights_Shipping_Lines_Set_Input>;
  /** filter the rows which have to be updated */
  where: Container_Insights_Shipping_Lines_Bool_Exp;
};

/** columns and relationships of "container_insights.telematic_companies" */
export type Container_Insights_Telematic_Companies = {
  __typename?: 'container_insights_telematic_companies';
  created_at: Scalars['timestamptz']['output'];
  /** Nb sample per day */
  data_frequency_per_day: Scalars['float8']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  telematic_devices: Array<Container_Insights_Telematic_Devices>;
  /** An aggregate relationship */
  telematic_devices_aggregate: Container_Insights_Telematic_Devices_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "container_insights.telematic_companies" */
export type Container_Insights_Telematic_CompaniesTelematic_DevicesArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Telematic_Devices_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Telematic_Devices_Order_By>>;
  where?: InputMaybe<Container_Insights_Telematic_Devices_Bool_Exp>;
};

/** columns and relationships of "container_insights.telematic_companies" */
export type Container_Insights_Telematic_CompaniesTelematic_Devices_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Telematic_Devices_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Container_Insights_Telematic_Devices_Order_By>>;
    where?: InputMaybe<Container_Insights_Telematic_Devices_Bool_Exp>;
  };

/** aggregated selection of "container_insights.telematic_companies" */
export type Container_Insights_Telematic_Companies_Aggregate = {
  __typename?: 'container_insights_telematic_companies_aggregate';
  aggregate?: Maybe<Container_Insights_Telematic_Companies_Aggregate_Fields>;
  nodes: Array<Container_Insights_Telematic_Companies>;
};

/** aggregate fields of "container_insights.telematic_companies" */
export type Container_Insights_Telematic_Companies_Aggregate_Fields = {
  __typename?: 'container_insights_telematic_companies_aggregate_fields';
  avg?: Maybe<Container_Insights_Telematic_Companies_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Telematic_Companies_Max_Fields>;
  min?: Maybe<Container_Insights_Telematic_Companies_Min_Fields>;
  stddev?: Maybe<Container_Insights_Telematic_Companies_Stddev_Fields>;
  stddev_pop?: Maybe<Container_Insights_Telematic_Companies_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Container_Insights_Telematic_Companies_Stddev_Samp_Fields>;
  sum?: Maybe<Container_Insights_Telematic_Companies_Sum_Fields>;
  var_pop?: Maybe<Container_Insights_Telematic_Companies_Var_Pop_Fields>;
  var_samp?: Maybe<Container_Insights_Telematic_Companies_Var_Samp_Fields>;
  variance?: Maybe<Container_Insights_Telematic_Companies_Variance_Fields>;
};


/** aggregate fields of "container_insights.telematic_companies" */
export type Container_Insights_Telematic_Companies_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<
    Array<Container_Insights_Telematic_Companies_Select_Column>
  >;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Container_Insights_Telematic_Companies_Avg_Fields = {
  __typename?: 'container_insights_telematic_companies_avg_fields';
  /** Nb sample per day */
  data_frequency_per_day?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "container_insights.telematic_companies". All fields are combined with a logical 'AND'. */
export type Container_Insights_Telematic_Companies_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Telematic_Companies_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Telematic_Companies_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Telematic_Companies_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_frequency_per_day?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  telematic_devices?: InputMaybe<Container_Insights_Telematic_Devices_Bool_Exp>;
  telematic_devices_aggregate?: InputMaybe<Container_Insights_Telematic_Devices_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "container_insights.telematic_companies" */
export enum Container_Insights_Telematic_Companies_Constraint {
  /** unique or primary key constraint on columns "name" */
  TelematicCompaniesNameKey = 'telematic_companies_name_key',
  /** unique or primary key constraint on columns "id" */
  TelematicCompaniesPkey = 'telematic_companies_pkey',
}

/** input type for incrementing numeric columns in table "container_insights.telematic_companies" */
export type Container_Insights_Telematic_Companies_Inc_Input = {
  /** Nb sample per day */
  data_frequency_per_day?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "container_insights.telematic_companies" */
export type Container_Insights_Telematic_Companies_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Nb sample per day */
  data_frequency_per_day?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  telematic_devices?: InputMaybe<Container_Insights_Telematic_Devices_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Container_Insights_Telematic_Companies_Max_Fields = {
  __typename?: 'container_insights_telematic_companies_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Nb sample per day */
  data_frequency_per_day?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Container_Insights_Telematic_Companies_Min_Fields = {
  __typename?: 'container_insights_telematic_companies_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Nb sample per day */
  data_frequency_per_day?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "container_insights.telematic_companies" */
export type Container_Insights_Telematic_Companies_Mutation_Response = {
  __typename?: 'container_insights_telematic_companies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Container_Insights_Telematic_Companies>;
};

/** input type for inserting object relation for remote table "container_insights.telematic_companies" */
export type Container_Insights_Telematic_Companies_Obj_Rel_Insert_Input = {
  data: Container_Insights_Telematic_Companies_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Container_Insights_Telematic_Companies_On_Conflict>;
};

/** on_conflict condition type for table "container_insights.telematic_companies" */
export type Container_Insights_Telematic_Companies_On_Conflict = {
  constraint: Container_Insights_Telematic_Companies_Constraint;
  update_columns?: Array<Container_Insights_Telematic_Companies_Update_Column>;
  where?: InputMaybe<Container_Insights_Telematic_Companies_Bool_Exp>;
};

/** Ordering options when selecting data from "container_insights.telematic_companies". */
export type Container_Insights_Telematic_Companies_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data_frequency_per_day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  telematic_devices_aggregate?: InputMaybe<Container_Insights_Telematic_Devices_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: container_insights.telematic_companies */
export type Container_Insights_Telematic_Companies_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "container_insights.telematic_companies" */
export enum Container_Insights_Telematic_Companies_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataFrequencyPerDay = 'data_frequency_per_day',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "container_insights.telematic_companies" */
export type Container_Insights_Telematic_Companies_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Nb sample per day */
  data_frequency_per_day?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Container_Insights_Telematic_Companies_Stddev_Fields = {
  __typename?: 'container_insights_telematic_companies_stddev_fields';
  /** Nb sample per day */
  data_frequency_per_day?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Container_Insights_Telematic_Companies_Stddev_Pop_Fields = {
  __typename?: 'container_insights_telematic_companies_stddev_pop_fields';
  /** Nb sample per day */
  data_frequency_per_day?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Container_Insights_Telematic_Companies_Stddev_Samp_Fields = {
  __typename?: 'container_insights_telematic_companies_stddev_samp_fields';
  /** Nb sample per day */
  data_frequency_per_day?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "container_insights_telematic_companies" */
export type Container_Insights_Telematic_Companies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Telematic_Companies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Telematic_Companies_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Nb sample per day */
  data_frequency_per_day?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Container_Insights_Telematic_Companies_Sum_Fields = {
  __typename?: 'container_insights_telematic_companies_sum_fields';
  /** Nb sample per day */
  data_frequency_per_day?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "container_insights.telematic_companies" */
export enum Container_Insights_Telematic_Companies_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataFrequencyPerDay = 'data_frequency_per_day',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Container_Insights_Telematic_Companies_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Container_Insights_Telematic_Companies_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Container_Insights_Telematic_Companies_Set_Input>;
  /** filter the rows which have to be updated */
  where: Container_Insights_Telematic_Companies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Container_Insights_Telematic_Companies_Var_Pop_Fields = {
  __typename?: 'container_insights_telematic_companies_var_pop_fields';
  /** Nb sample per day */
  data_frequency_per_day?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Container_Insights_Telematic_Companies_Var_Samp_Fields = {
  __typename?: 'container_insights_telematic_companies_var_samp_fields';
  /** Nb sample per day */
  data_frequency_per_day?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Container_Insights_Telematic_Companies_Variance_Fields = {
  __typename?: 'container_insights_telematic_companies_variance_fields';
  /** Nb sample per day */
  data_frequency_per_day?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "container_insights.telematic_device_assignment" */
export type Container_Insights_Telematic_Device_Assignment = {
  __typename?: 'container_insights_telematic_device_assignment';
  created_at: Scalars['timestamptz']['output'];
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  reefer: Container_Insights_Reefers;
  reefer_id: Scalars['String']['output'];
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  telematic_device: Container_Insights_Telematic_Devices;
  telematic_device_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "container_insights.telematic_device_assignment" */
export type Container_Insights_Telematic_Device_Assignment_Aggregate = {
  __typename?: 'container_insights_telematic_device_assignment_aggregate';
  aggregate?: Maybe<Container_Insights_Telematic_Device_Assignment_Aggregate_Fields>;
  nodes: Array<Container_Insights_Telematic_Device_Assignment>;
};

export type Container_Insights_Telematic_Device_Assignment_Aggregate_Bool_Exp =
  {
    count?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Aggregate_Bool_Exp_Count>;
  };

export type Container_Insights_Telematic_Device_Assignment_Aggregate_Bool_Exp_Count =
  {
    arguments?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Select_Column>
    >;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Bool_Exp>;
    predicate: Int_Comparison_Exp;
  };

/** aggregate fields of "container_insights.telematic_device_assignment" */
export type Container_Insights_Telematic_Device_Assignment_Aggregate_Fields = {
  __typename?: 'container_insights_telematic_device_assignment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Telematic_Device_Assignment_Max_Fields>;
  min?: Maybe<Container_Insights_Telematic_Device_Assignment_Min_Fields>;
};

/** aggregate fields of "container_insights.telematic_device_assignment" */
export type Container_Insights_Telematic_Device_Assignment_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Select_Column>
    >;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
  };

/** order by aggregate values of table "container_insights.telematic_device_assignment" */
export type Container_Insights_Telematic_Device_Assignment_Aggregate_Order_By =
  {
    count?: InputMaybe<Order_By>;
    max?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Max_Order_By>;
    min?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Min_Order_By>;
  };

/** input type for inserting array relation for remote table "container_insights.telematic_device_assignment" */
export type Container_Insights_Telematic_Device_Assignment_Arr_Rel_Insert_Input =
  {
    data: Array<Container_Insights_Telematic_Device_Assignment_Insert_Input>;
    /** upsert condition */
    on_conflict?: InputMaybe<Container_Insights_Telematic_Device_Assignment_On_Conflict>;
  };

/** Boolean expression to filter rows from the table "container_insights.telematic_device_assignment". All fields are combined with a logical 'AND'. */
export type Container_Insights_Telematic_Device_Assignment_Bool_Exp = {
  _and?: InputMaybe<
    Array<Container_Insights_Telematic_Device_Assignment_Bool_Exp>
  >;
  _not?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Telematic_Device_Assignment_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  reefer?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
  reefer_id?: InputMaybe<String_Comparison_Exp>;
  start_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  telematic_device?: InputMaybe<Container_Insights_Telematic_Devices_Bool_Exp>;
  telematic_device_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "container_insights.telematic_device_assignment" */
export enum Container_Insights_Telematic_Device_Assignment_Constraint {
  /** unique or primary key constraint on columns "reefer_id", "telematic_device_id" */
  TelematicDeviceAssignmentPkey = 'telematic_device_assignment_pkey',
}

/** columns and relationships of "container_insights.telematic_device_assignment_expanded" */
export type Container_Insights_Telematic_Device_Assignment_Expanded = {
  __typename?: 'container_insights_telematic_device_assignment_expanded';
  age?: Maybe<Scalars['numeric']['output']>;
  age_id?: Maybe<Scalars['uuid']['output']>;
  data_frequency_per_hour?: Maybe<Scalars['float8']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  telematic_company?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "container_insights.telematic_device_assignment_expanded" */
export type Container_Insights_Telematic_Device_Assignment_Expanded_Aggregate =
  {
    __typename?: 'container_insights_telematic_device_assignment_expanded_aggregate';
    aggregate?: Maybe<Container_Insights_Telematic_Device_Assignment_Expanded_Aggregate_Fields>;
    nodes: Array<Container_Insights_Telematic_Device_Assignment_Expanded>;
  };

/** aggregate fields of "container_insights.telematic_device_assignment_expanded" */
export type Container_Insights_Telematic_Device_Assignment_Expanded_Aggregate_Fields =
  {
    __typename?: 'container_insights_telematic_device_assignment_expanded_aggregate_fields';
    avg?: Maybe<Container_Insights_Telematic_Device_Assignment_Expanded_Avg_Fields>;
    count: Scalars['Int']['output'];
    max?: Maybe<Container_Insights_Telematic_Device_Assignment_Expanded_Max_Fields>;
    min?: Maybe<Container_Insights_Telematic_Device_Assignment_Expanded_Min_Fields>;
    stddev?: Maybe<Container_Insights_Telematic_Device_Assignment_Expanded_Stddev_Fields>;
    stddev_pop?: Maybe<Container_Insights_Telematic_Device_Assignment_Expanded_Stddev_Pop_Fields>;
    stddev_samp?: Maybe<Container_Insights_Telematic_Device_Assignment_Expanded_Stddev_Samp_Fields>;
    sum?: Maybe<Container_Insights_Telematic_Device_Assignment_Expanded_Sum_Fields>;
    var_pop?: Maybe<Container_Insights_Telematic_Device_Assignment_Expanded_Var_Pop_Fields>;
    var_samp?: Maybe<Container_Insights_Telematic_Device_Assignment_Expanded_Var_Samp_Fields>;
    variance?: Maybe<Container_Insights_Telematic_Device_Assignment_Expanded_Variance_Fields>;
  };

/** aggregate fields of "container_insights.telematic_device_assignment_expanded" */
export type Container_Insights_Telematic_Device_Assignment_Expanded_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Expanded_Select_Column>
    >;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
  };

/** aggregate avg on columns */
export type Container_Insights_Telematic_Device_Assignment_Expanded_Avg_Fields = {
  __typename?: 'container_insights_telematic_device_assignment_expanded_avg_fields';
  age?: Maybe<Scalars['Float']['output']>;
  data_frequency_per_hour?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "container_insights.telematic_device_assignment_expanded". All fields are combined with a logical 'AND'. */
export type Container_Insights_Telematic_Device_Assignment_Expanded_Bool_Exp = {
  _and?: InputMaybe<
    Array<Container_Insights_Telematic_Device_Assignment_Expanded_Bool_Exp>
  >;
  _not?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Expanded_Bool_Exp>;
  _or?: InputMaybe<
    Array<Container_Insights_Telematic_Device_Assignment_Expanded_Bool_Exp>
  >;
  age?: InputMaybe<Numeric_Comparison_Exp>;
  age_id?: InputMaybe<Uuid_Comparison_Exp>;
  data_frequency_per_hour?: InputMaybe<Float8_Comparison_Exp>;
  end_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  reefer_id?: InputMaybe<String_Comparison_Exp>;
  refrigeration_unit_model?: InputMaybe<String_Comparison_Exp>;
  shipping_line?: InputMaybe<String_Comparison_Exp>;
  start_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  telematic_company?: InputMaybe<String_Comparison_Exp>;
  telematic_device_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Container_Insights_Telematic_Device_Assignment_Expanded_Max_Fields = {
  __typename?: 'container_insights_telematic_device_assignment_expanded_max_fields';
  age?: Maybe<Scalars['numeric']['output']>;
  age_id?: Maybe<Scalars['uuid']['output']>;
  data_frequency_per_hour?: Maybe<Scalars['float8']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  telematic_company?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Container_Insights_Telematic_Device_Assignment_Expanded_Min_Fields = {
  __typename?: 'container_insights_telematic_device_assignment_expanded_min_fields';
  age?: Maybe<Scalars['numeric']['output']>;
  age_id?: Maybe<Scalars['uuid']['output']>;
  data_frequency_per_hour?: Maybe<Scalars['float8']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  refrigeration_unit_model?: Maybe<Scalars['String']['output']>;
  shipping_line?: Maybe<Scalars['String']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  telematic_company?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "container_insights.telematic_device_assignment_expanded". */
export type Container_Insights_Telematic_Device_Assignment_Expanded_Order_By = {
  age?: InputMaybe<Order_By>;
  age_id?: InputMaybe<Order_By>;
  data_frequency_per_hour?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  reefer_id?: InputMaybe<Order_By>;
  refrigeration_unit_model?: InputMaybe<Order_By>;
  shipping_line?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  telematic_company?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
};

/** select columns of table "container_insights.telematic_device_assignment_expanded" */
export enum Container_Insights_Telematic_Device_Assignment_Expanded_Select_Column {
  /** column name */
  Age = 'age',
  /** column name */
  AgeId = 'age_id',
  /** column name */
  DataFrequencyPerHour = 'data_frequency_per_hour',
  /** column name */
  EndDatetime = 'end_datetime',
  /** column name */
  Manufacturer = 'manufacturer',
  /** column name */
  ReeferId = 'reefer_id',
  /** column name */
  RefrigerationUnitModel = 'refrigeration_unit_model',
  /** column name */
  ShippingLine = 'shipping_line',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  TelematicCompany = 'telematic_company',
  /** column name */
  TelematicDeviceId = 'telematic_device_id',
}

/** aggregate stddev on columns */
export type Container_Insights_Telematic_Device_Assignment_Expanded_Stddev_Fields = {
  __typename?: 'container_insights_telematic_device_assignment_expanded_stddev_fields';
  age?: Maybe<Scalars['Float']['output']>;
  data_frequency_per_hour?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Container_Insights_Telematic_Device_Assignment_Expanded_Stddev_Pop_Fields = {
  __typename?: 'container_insights_telematic_device_assignment_expanded_stddev_pop_fields';
  age?: Maybe<Scalars['Float']['output']>;
  data_frequency_per_hour?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Container_Insights_Telematic_Device_Assignment_Expanded_Stddev_Samp_Fields = {
  __typename?: 'container_insights_telematic_device_assignment_expanded_stddev_samp_fields';
  age?: Maybe<Scalars['Float']['output']>;
  data_frequency_per_hour?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "container_insights_telematic_device_assignment_expanded" */
export type Container_Insights_Telematic_Device_Assignment_Expanded_Stream_Cursor_Input =
  {
    /** Stream column input with initial value */
    initial_value: Container_Insights_Telematic_Device_Assignment_Expanded_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
  };

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Telematic_Device_Assignment_Expanded_Stream_Cursor_Value_Input = {
  age?: InputMaybe<Scalars['numeric']['input']>;
  age_id?: InputMaybe<Scalars['uuid']['input']>;
  data_frequency_per_hour?: InputMaybe<Scalars['float8']['input']>;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  reefer_id?: InputMaybe<Scalars['String']['input']>;
  refrigeration_unit_model?: InputMaybe<Scalars['String']['input']>;
  shipping_line?: InputMaybe<Scalars['String']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  telematic_company?: InputMaybe<Scalars['String']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Container_Insights_Telematic_Device_Assignment_Expanded_Sum_Fields = {
  __typename?: 'container_insights_telematic_device_assignment_expanded_sum_fields';
  age?: Maybe<Scalars['numeric']['output']>;
  data_frequency_per_hour?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Container_Insights_Telematic_Device_Assignment_Expanded_Var_Pop_Fields = {
  __typename?: 'container_insights_telematic_device_assignment_expanded_var_pop_fields';
  age?: Maybe<Scalars['Float']['output']>;
  data_frequency_per_hour?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Container_Insights_Telematic_Device_Assignment_Expanded_Var_Samp_Fields = {
  __typename?: 'container_insights_telematic_device_assignment_expanded_var_samp_fields';
  age?: Maybe<Scalars['Float']['output']>;
  data_frequency_per_hour?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Container_Insights_Telematic_Device_Assignment_Expanded_Variance_Fields = {
  __typename?: 'container_insights_telematic_device_assignment_expanded_variance_fields';
  age?: Maybe<Scalars['Float']['output']>;
  data_frequency_per_hour?: Maybe<Scalars['Float']['output']>;
};

/** input type for inserting data into table "container_insights.telematic_device_assignment" */
export type Container_Insights_Telematic_Device_Assignment_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  reefer?: InputMaybe<Container_Insights_Reefers_Obj_Rel_Insert_Input>;
  reefer_id?: InputMaybe<Scalars['String']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  telematic_device?: InputMaybe<Container_Insights_Telematic_Devices_Obj_Rel_Insert_Input>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Container_Insights_Telematic_Device_Assignment_Max_Fields = {
  __typename?: 'container_insights_telematic_device_assignment_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "container_insights.telematic_device_assignment" */
export type Container_Insights_Telematic_Device_Assignment_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  reefer_id?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Container_Insights_Telematic_Device_Assignment_Min_Fields = {
  __typename?: 'container_insights_telematic_device_assignment_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "container_insights.telematic_device_assignment" */
export type Container_Insights_Telematic_Device_Assignment_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  reefer_id?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "container_insights.telematic_device_assignment" */
export type Container_Insights_Telematic_Device_Assignment_Mutation_Response = {
  __typename?: 'container_insights_telematic_device_assignment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Container_Insights_Telematic_Device_Assignment>;
};

/** on_conflict condition type for table "container_insights.telematic_device_assignment" */
export type Container_Insights_Telematic_Device_Assignment_On_Conflict = {
  constraint: Container_Insights_Telematic_Device_Assignment_Constraint;
  update_columns?: Array<Container_Insights_Telematic_Device_Assignment_Update_Column>;
  where?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Bool_Exp>;
};

/** Ordering options when selecting data from "container_insights.telematic_device_assignment". */
export type Container_Insights_Telematic_Device_Assignment_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  reefer?: InputMaybe<Container_Insights_Reefers_Order_By>;
  reefer_id?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  telematic_device?: InputMaybe<Container_Insights_Telematic_Devices_Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: container_insights.telematic_device_assignment */
export type Container_Insights_Telematic_Device_Assignment_Pk_Columns_Input = {
  reefer_id: Scalars['String']['input'];
  telematic_device_id: Scalars['uuid']['input'];
};

/** select columns of table "container_insights.telematic_device_assignment" */
export enum Container_Insights_Telematic_Device_Assignment_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDatetime = 'end_datetime',
  /** column name */
  ReeferId = 'reefer_id',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  TelematicDeviceId = 'telematic_device_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "container_insights.telematic_device_assignment" */
export type Container_Insights_Telematic_Device_Assignment_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  reefer_id?: InputMaybe<Scalars['String']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "container_insights_telematic_device_assignment" */
export type Container_Insights_Telematic_Device_Assignment_Stream_Cursor_Input =
  {
    /** Stream column input with initial value */
    initial_value: Container_Insights_Telematic_Device_Assignment_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
  };

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Telematic_Device_Assignment_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  reefer_id?: InputMaybe<Scalars['String']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "container_insights.telematic_device_assignment" */
export enum Container_Insights_Telematic_Device_Assignment_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDatetime = 'end_datetime',
  /** column name */
  ReeferId = 'reefer_id',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  TelematicDeviceId = 'telematic_device_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Container_Insights_Telematic_Device_Assignment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Container_Insights_Telematic_Device_Assignment_Bool_Exp;
};

/** columns and relationships of "container_insights.telematic_devices" */
export type Container_Insights_Telematic_Devices = {
  __typename?: 'container_insights_telematic_devices';
  /** An array relationship */
  bookings: Array<Container_Insights_Bookings>;
  /** An aggregate relationship */
  bookings_aggregate: Container_Insights_Bookings_Aggregate;
  /** An array relationship */
  bookings_expanded: Array<Container_Insights_Bookings_Expanded>;
  /** An aggregate relationship */
  bookings_expanded_aggregate: Container_Insights_Bookings_Expanded_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  energy_usages: Array<Container_Insights_Energy_Usage>;
  /** An aggregate relationship */
  energy_usages_aggregate: Container_Insights_Energy_Usage_Aggregate;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  legs: Array<Container_Insights_Legs>;
  /** An aggregate relationship */
  legs_aggregate: Container_Insights_Legs_Aggregate;
  /** An object relationship */
  telematic_company?: Maybe<Container_Insights_Telematic_Companies>;
  telematic_company_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  telematic_device_assignments: Array<Container_Insights_Telematic_Device_Assignment>;
  /** An aggregate relationship */
  telematic_device_assignments_aggregate: Container_Insights_Telematic_Device_Assignment_Aggregate;
  /** An array relationship */
  temperature_breaches: Array<Container_Insights_Temperature_Breaches>;
  /** An aggregate relationship */
  temperature_breaches_aggregate: Container_Insights_Temperature_Breaches_Aggregate;
};

/** columns and relationships of "container_insights.telematic_devices" */
export type Container_Insights_Telematic_DevicesBookingsArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Bookings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Bookings_Order_By>>;
  where?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
};

/** columns and relationships of "container_insights.telematic_devices" */
export type Container_Insights_Telematic_DevicesBookings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Bookings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Bookings_Order_By>>;
  where?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
};

/** columns and relationships of "container_insights.telematic_devices" */
export type Container_Insights_Telematic_DevicesBookings_ExpandedArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Bookings_Expanded_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Bookings_Expanded_Order_By>>;
  where?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
};

/** columns and relationships of "container_insights.telematic_devices" */
export type Container_Insights_Telematic_DevicesBookings_Expanded_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Bookings_Expanded_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Container_Insights_Bookings_Expanded_Order_By>>;
    where?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
  };

/** columns and relationships of "container_insights.telematic_devices" */
export type Container_Insights_Telematic_DevicesEnergy_UsagesArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Energy_Usage_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Energy_Usage_Order_By>>;
  where?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
};

/** columns and relationships of "container_insights.telematic_devices" */
export type Container_Insights_Telematic_DevicesEnergy_Usages_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Energy_Usage_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Energy_Usage_Order_By>>;
  where?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
};

/** columns and relationships of "container_insights.telematic_devices" */
export type Container_Insights_Telematic_DevicesLegsArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Legs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Legs_Order_By>>;
  where?: InputMaybe<Container_Insights_Legs_Bool_Exp>;
};

/** columns and relationships of "container_insights.telematic_devices" */
export type Container_Insights_Telematic_DevicesLegs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Legs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Legs_Order_By>>;
  where?: InputMaybe<Container_Insights_Legs_Bool_Exp>;
};

/** columns and relationships of "container_insights.telematic_devices" */
export type Container_Insights_Telematic_DevicesTelematic_Device_AssignmentsArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Bool_Exp>;
  };

/** columns and relationships of "container_insights.telematic_devices" */
export type Container_Insights_Telematic_DevicesTelematic_Device_Assignments_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Bool_Exp>;
  };

/** columns and relationships of "container_insights.telematic_devices" */
export type Container_Insights_Telematic_DevicesTemperature_BreachesArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Temperature_Breaches_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<
    Array<Container_Insights_Temperature_Breaches_Order_By>
  >;
  where?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
};

/** columns and relationships of "container_insights.telematic_devices" */
export type Container_Insights_Telematic_DevicesTemperature_Breaches_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Temperature_Breaches_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Temperature_Breaches_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
  };

/** aggregated selection of "container_insights.telematic_devices" */
export type Container_Insights_Telematic_Devices_Aggregate = {
  __typename?: 'container_insights_telematic_devices_aggregate';
  aggregate?: Maybe<Container_Insights_Telematic_Devices_Aggregate_Fields>;
  nodes: Array<Container_Insights_Telematic_Devices>;
};

export type Container_Insights_Telematic_Devices_Aggregate_Bool_Exp = {
  count?: InputMaybe<Container_Insights_Telematic_Devices_Aggregate_Bool_Exp_Count>;
};

export type Container_Insights_Telematic_Devices_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<
    Array<Container_Insights_Telematic_Devices_Select_Column>
  >;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Telematic_Devices_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "container_insights.telematic_devices" */
export type Container_Insights_Telematic_Devices_Aggregate_Fields = {
  __typename?: 'container_insights_telematic_devices_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Telematic_Devices_Max_Fields>;
  min?: Maybe<Container_Insights_Telematic_Devices_Min_Fields>;
};

/** aggregate fields of "container_insights.telematic_devices" */
export type Container_Insights_Telematic_Devices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<
    Array<Container_Insights_Telematic_Devices_Select_Column>
  >;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "container_insights.telematic_devices" */
export type Container_Insights_Telematic_Devices_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Container_Insights_Telematic_Devices_Max_Order_By>;
  min?: InputMaybe<Container_Insights_Telematic_Devices_Min_Order_By>;
};

/** input type for inserting array relation for remote table "container_insights.telematic_devices" */
export type Container_Insights_Telematic_Devices_Arr_Rel_Insert_Input = {
  data: Array<Container_Insights_Telematic_Devices_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Container_Insights_Telematic_Devices_On_Conflict>;
};

/** Boolean expression to filter rows from the table "container_insights.telematic_devices". All fields are combined with a logical 'AND'. */
export type Container_Insights_Telematic_Devices_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Telematic_Devices_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Telematic_Devices_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Telematic_Devices_Bool_Exp>>;
  bookings?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
  bookings_aggregate?: InputMaybe<Container_Insights_Bookings_Aggregate_Bool_Exp>;
  bookings_expanded?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
  bookings_expanded_aggregate?: InputMaybe<Container_Insights_Bookings_Expanded_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_usages?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
  energy_usages_aggregate?: InputMaybe<Container_Insights_Energy_Usage_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  legs?: InputMaybe<Container_Insights_Legs_Bool_Exp>;
  legs_aggregate?: InputMaybe<Container_Insights_Legs_Aggregate_Bool_Exp>;
  telematic_company?: InputMaybe<Container_Insights_Telematic_Companies_Bool_Exp>;
  telematic_company_id?: InputMaybe<Uuid_Comparison_Exp>;
  telematic_device_assignments?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Bool_Exp>;
  telematic_device_assignments_aggregate?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Aggregate_Bool_Exp>;
  temperature_breaches?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
  temperature_breaches_aggregate?: InputMaybe<Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "container_insights.telematic_devices" */
export enum Container_Insights_Telematic_Devices_Constraint {
  /** unique or primary key constraint on columns "id" */
  TelematicDevicesPkey = 'telematic_devices_pkey',
}

/** input type for inserting data into table "container_insights.telematic_devices" */
export type Container_Insights_Telematic_Devices_Insert_Input = {
  bookings?: InputMaybe<Container_Insights_Bookings_Arr_Rel_Insert_Input>;
  bookings_expanded?: InputMaybe<Container_Insights_Bookings_Expanded_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  energy_usages?: InputMaybe<Container_Insights_Energy_Usage_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  legs?: InputMaybe<Container_Insights_Legs_Arr_Rel_Insert_Input>;
  telematic_company?: InputMaybe<Container_Insights_Telematic_Companies_Obj_Rel_Insert_Input>;
  telematic_company_id?: InputMaybe<Scalars['uuid']['input']>;
  telematic_device_assignments?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Arr_Rel_Insert_Input>;
  temperature_breaches?: InputMaybe<Container_Insights_Temperature_Breaches_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Container_Insights_Telematic_Devices_Max_Fields = {
  __typename?: 'container_insights_telematic_devices_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  telematic_company_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "container_insights.telematic_devices" */
export type Container_Insights_Telematic_Devices_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  telematic_company_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Container_Insights_Telematic_Devices_Min_Fields = {
  __typename?: 'container_insights_telematic_devices_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  telematic_company_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "container_insights.telematic_devices" */
export type Container_Insights_Telematic_Devices_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  telematic_company_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "container_insights.telematic_devices" */
export type Container_Insights_Telematic_Devices_Mutation_Response = {
  __typename?: 'container_insights_telematic_devices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Container_Insights_Telematic_Devices>;
};

/** input type for inserting object relation for remote table "container_insights.telematic_devices" */
export type Container_Insights_Telematic_Devices_Obj_Rel_Insert_Input = {
  data: Container_Insights_Telematic_Devices_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Container_Insights_Telematic_Devices_On_Conflict>;
};

/** on_conflict condition type for table "container_insights.telematic_devices" */
export type Container_Insights_Telematic_Devices_On_Conflict = {
  constraint: Container_Insights_Telematic_Devices_Constraint;
  update_columns?: Array<Container_Insights_Telematic_Devices_Update_Column>;
  where?: InputMaybe<Container_Insights_Telematic_Devices_Bool_Exp>;
};

/** Ordering options when selecting data from "container_insights.telematic_devices". */
export type Container_Insights_Telematic_Devices_Order_By = {
  bookings_aggregate?: InputMaybe<Container_Insights_Bookings_Aggregate_Order_By>;
  bookings_expanded_aggregate?: InputMaybe<Container_Insights_Bookings_Expanded_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  energy_usages_aggregate?: InputMaybe<Container_Insights_Energy_Usage_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  legs_aggregate?: InputMaybe<Container_Insights_Legs_Aggregate_Order_By>;
  telematic_company?: InputMaybe<Container_Insights_Telematic_Companies_Order_By>;
  telematic_company_id?: InputMaybe<Order_By>;
  telematic_device_assignments_aggregate?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Aggregate_Order_By>;
  temperature_breaches_aggregate?: InputMaybe<Container_Insights_Temperature_Breaches_Aggregate_Order_By>;
};

/** primary key columns input for table: container_insights.telematic_devices */
export type Container_Insights_Telematic_Devices_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "container_insights.telematic_devices" */
export enum Container_Insights_Telematic_Devices_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TelematicCompanyId = 'telematic_company_id',
}

/** input type for updating data in table "container_insights.telematic_devices" */
export type Container_Insights_Telematic_Devices_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  telematic_company_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "container_insights_telematic_devices" */
export type Container_Insights_Telematic_Devices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Telematic_Devices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Telematic_Devices_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  telematic_company_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "container_insights.telematic_devices" */
export enum Container_Insights_Telematic_Devices_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TelematicCompanyId = 'telematic_company_id',
}

export type Container_Insights_Telematic_Devices_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Container_Insights_Telematic_Devices_Set_Input>;
  /** filter the rows which have to be updated */
  where: Container_Insights_Telematic_Devices_Bool_Exp;
};

/** columns and relationships of "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches = {
  __typename?: 'container_insights_temperature_breaches';
  created_at: Scalars['timestamptz']['output'];
  end_datetime: Scalars['timestamptz']['output'];
  end_gps?: Maybe<Scalars['geometry']['output']>;
  id: Scalars['uuid']['output'];
  max_deviation: Scalars['float8']['output'];
  start_datetime: Scalars['timestamptz']['output'];
  start_gps?: Maybe<Scalars['geometry']['output']>;
  /** An object relationship */
  telematic_device: Container_Insights_Telematic_Devices;
  telematic_device_id: Scalars['uuid']['output'];
};

/** aggregated selection of "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Aggregate = {
  __typename?: 'container_insights_temperature_breaches_aggregate';
  aggregate?: Maybe<Container_Insights_Temperature_Breaches_Aggregate_Fields>;
  nodes: Array<Container_Insights_Temperature_Breaches>;
};

export type Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Var_Samp>;
};

export type Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Avg = {
  arguments: Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Corr = {
  arguments: Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Corr_Arguments =
  {
    X: Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Corr_Arguments_Columns;
    Y: Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  };

export type Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<
    Array<Container_Insights_Temperature_Breaches_Select_Column>
  >;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Covar_Samp =
  {
    arguments: Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Covar_Samp_Arguments;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
  };

export type Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Covar_Samp_Arguments =
  {
    X: Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
    Y: Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  };

export type Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Max = {
  arguments: Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Min = {
  arguments: Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Stddev_Samp =
  {
    arguments: Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
  };

export type Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Sum = {
  arguments: Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Var_Samp =
  {
    arguments: Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
    predicate: Float8_Comparison_Exp;
  };

/** aggregate fields of "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Aggregate_Fields = {
  __typename?: 'container_insights_temperature_breaches_aggregate_fields';
  avg?: Maybe<Container_Insights_Temperature_Breaches_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Temperature_Breaches_Max_Fields>;
  min?: Maybe<Container_Insights_Temperature_Breaches_Min_Fields>;
  stddev?: Maybe<Container_Insights_Temperature_Breaches_Stddev_Fields>;
  stddev_pop?: Maybe<Container_Insights_Temperature_Breaches_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Container_Insights_Temperature_Breaches_Stddev_Samp_Fields>;
  sum?: Maybe<Container_Insights_Temperature_Breaches_Sum_Fields>;
  var_pop?: Maybe<Container_Insights_Temperature_Breaches_Var_Pop_Fields>;
  var_samp?: Maybe<Container_Insights_Temperature_Breaches_Var_Samp_Fields>;
  variance?: Maybe<Container_Insights_Temperature_Breaches_Variance_Fields>;
};

/** aggregate fields of "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Container_Insights_Temperature_Breaches_Select_Column>
    >;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
  };

/** order by aggregate values of table "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Aggregate_Order_By = {
  avg?: InputMaybe<Container_Insights_Temperature_Breaches_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Container_Insights_Temperature_Breaches_Max_Order_By>;
  min?: InputMaybe<Container_Insights_Temperature_Breaches_Min_Order_By>;
  stddev?: InputMaybe<Container_Insights_Temperature_Breaches_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Container_Insights_Temperature_Breaches_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Container_Insights_Temperature_Breaches_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Container_Insights_Temperature_Breaches_Sum_Order_By>;
  var_pop?: InputMaybe<Container_Insights_Temperature_Breaches_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Container_Insights_Temperature_Breaches_Var_Samp_Order_By>;
  variance?: InputMaybe<Container_Insights_Temperature_Breaches_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Arr_Rel_Insert_Input = {
  data: Array<Container_Insights_Temperature_Breaches_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Container_Insights_Temperature_Breaches_On_Conflict>;
};

/** aggregate avg on columns */
export type Container_Insights_Temperature_Breaches_Avg_Fields = {
  __typename?: 'container_insights_temperature_breaches_avg_fields';
  max_deviation?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Avg_Order_By = {
  max_deviation?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "container_insights.temperature_breaches". All fields are combined with a logical 'AND'. */
export type Container_Insights_Temperature_Breaches_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Temperature_Breaches_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Temperature_Breaches_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_gps?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  max_deviation?: InputMaybe<Float8_Comparison_Exp>;
  start_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  start_gps?: InputMaybe<Geometry_Comparison_Exp>;
  telematic_device?: InputMaybe<Container_Insights_Telematic_Devices_Bool_Exp>;
  telematic_device_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "container_insights.temperature_breaches" */
export enum Container_Insights_Temperature_Breaches_Constraint {
  /** unique or primary key constraint on columns "id" */
  TemperatureBreachesPkey = 'temperature_breaches_pkey',
}

/** columns and relationships of "container_insights.temperature_breaches_expanded" */
export type Container_Insights_Temperature_Breaches_Expanded = {
  __typename?: 'container_insights_temperature_breaches_expanded';
  booking_id?: Maybe<Scalars['uuid']['output']>;
  breach_end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  breach_end_gps?: Maybe<Scalars['geometry']['output']>;
  breach_id?: Maybe<Scalars['uuid']['output']>;
  breach_start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  breach_start_gps?: Maybe<Scalars['geometry']['output']>;
  max_deviation?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  reefer?: Maybe<Container_Insights_Reefers_Expanded>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  telematic_device?: Maybe<Container_Insights_Telematic_Devices>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "container_insights.temperature_breaches_expanded" */
export type Container_Insights_Temperature_Breaches_Expanded_Aggregate = {
  __typename?: 'container_insights_temperature_breaches_expanded_aggregate';
  aggregate?: Maybe<Container_Insights_Temperature_Breaches_Expanded_Aggregate_Fields>;
  nodes: Array<Container_Insights_Temperature_Breaches_Expanded>;
};

/** aggregate fields of "container_insights.temperature_breaches_expanded" */
export type Container_Insights_Temperature_Breaches_Expanded_Aggregate_Fields =
  {
    __typename?: 'container_insights_temperature_breaches_expanded_aggregate_fields';
    avg?: Maybe<Container_Insights_Temperature_Breaches_Expanded_Avg_Fields>;
    count: Scalars['Int']['output'];
    max?: Maybe<Container_Insights_Temperature_Breaches_Expanded_Max_Fields>;
    min?: Maybe<Container_Insights_Temperature_Breaches_Expanded_Min_Fields>;
    stddev?: Maybe<Container_Insights_Temperature_Breaches_Expanded_Stddev_Fields>;
    stddev_pop?: Maybe<Container_Insights_Temperature_Breaches_Expanded_Stddev_Pop_Fields>;
    stddev_samp?: Maybe<Container_Insights_Temperature_Breaches_Expanded_Stddev_Samp_Fields>;
    sum?: Maybe<Container_Insights_Temperature_Breaches_Expanded_Sum_Fields>;
    var_pop?: Maybe<Container_Insights_Temperature_Breaches_Expanded_Var_Pop_Fields>;
    var_samp?: Maybe<Container_Insights_Temperature_Breaches_Expanded_Var_Samp_Fields>;
    variance?: Maybe<Container_Insights_Temperature_Breaches_Expanded_Variance_Fields>;
  };

/** aggregate fields of "container_insights.temperature_breaches_expanded" */
export type Container_Insights_Temperature_Breaches_Expanded_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Container_Insights_Temperature_Breaches_Expanded_Select_Column>
    >;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
  };

/** aggregate avg on columns */
export type Container_Insights_Temperature_Breaches_Expanded_Avg_Fields = {
  __typename?: 'container_insights_temperature_breaches_expanded_avg_fields';
  max_deviation?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "container_insights.temperature_breaches_expanded". All fields are combined with a logical 'AND'. */
export type Container_Insights_Temperature_Breaches_Expanded_Bool_Exp = {
  _and?: InputMaybe<
    Array<Container_Insights_Temperature_Breaches_Expanded_Bool_Exp>
  >;
  _not?: InputMaybe<Container_Insights_Temperature_Breaches_Expanded_Bool_Exp>;
  _or?: InputMaybe<
    Array<Container_Insights_Temperature_Breaches_Expanded_Bool_Exp>
  >;
  booking_id?: InputMaybe<Uuid_Comparison_Exp>;
  breach_end_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  breach_end_gps?: InputMaybe<Geometry_Comparison_Exp>;
  breach_id?: InputMaybe<Uuid_Comparison_Exp>;
  breach_start_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  breach_start_gps?: InputMaybe<Geometry_Comparison_Exp>;
  max_deviation?: InputMaybe<Float8_Comparison_Exp>;
  reefer?: InputMaybe<Container_Insights_Reefers_Expanded_Bool_Exp>;
  reefer_id?: InputMaybe<String_Comparison_Exp>;
  telematic_device?: InputMaybe<Container_Insights_Telematic_Devices_Bool_Exp>;
  telematic_device_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Container_Insights_Temperature_Breaches_Expanded_Max_Fields = {
  __typename?: 'container_insights_temperature_breaches_expanded_max_fields';
  booking_id?: Maybe<Scalars['uuid']['output']>;
  breach_end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  breach_id?: Maybe<Scalars['uuid']['output']>;
  breach_start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  max_deviation?: Maybe<Scalars['float8']['output']>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Container_Insights_Temperature_Breaches_Expanded_Min_Fields = {
  __typename?: 'container_insights_temperature_breaches_expanded_min_fields';
  booking_id?: Maybe<Scalars['uuid']['output']>;
  breach_end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  breach_id?: Maybe<Scalars['uuid']['output']>;
  breach_start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  max_deviation?: Maybe<Scalars['float8']['output']>;
  reefer_id?: Maybe<Scalars['String']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "container_insights.temperature_breaches_expanded". */
export type Container_Insights_Temperature_Breaches_Expanded_Order_By = {
  booking_id?: InputMaybe<Order_By>;
  breach_end_datetime?: InputMaybe<Order_By>;
  breach_end_gps?: InputMaybe<Order_By>;
  breach_id?: InputMaybe<Order_By>;
  breach_start_datetime?: InputMaybe<Order_By>;
  breach_start_gps?: InputMaybe<Order_By>;
  max_deviation?: InputMaybe<Order_By>;
  reefer?: InputMaybe<Container_Insights_Reefers_Expanded_Order_By>;
  reefer_id?: InputMaybe<Order_By>;
  telematic_device?: InputMaybe<Container_Insights_Telematic_Devices_Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
};

/** select columns of table "container_insights.temperature_breaches_expanded" */
export enum Container_Insights_Temperature_Breaches_Expanded_Select_Column {
  /** column name */
  BookingId = 'booking_id',
  /** column name */
  BreachEndDatetime = 'breach_end_datetime',
  /** column name */
  BreachEndGps = 'breach_end_gps',
  /** column name */
  BreachId = 'breach_id',
  /** column name */
  BreachStartDatetime = 'breach_start_datetime',
  /** column name */
  BreachStartGps = 'breach_start_gps',
  /** column name */
  MaxDeviation = 'max_deviation',
  /** column name */
  ReeferId = 'reefer_id',
  /** column name */
  TelematicDeviceId = 'telematic_device_id',
}

/** aggregate stddev on columns */
export type Container_Insights_Temperature_Breaches_Expanded_Stddev_Fields = {
  __typename?: 'container_insights_temperature_breaches_expanded_stddev_fields';
  max_deviation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Container_Insights_Temperature_Breaches_Expanded_Stddev_Pop_Fields =
  {
    __typename?: 'container_insights_temperature_breaches_expanded_stddev_pop_fields';
    max_deviation?: Maybe<Scalars['Float']['output']>;
  };

/** aggregate stddev_samp on columns */
export type Container_Insights_Temperature_Breaches_Expanded_Stddev_Samp_Fields =
  {
    __typename?: 'container_insights_temperature_breaches_expanded_stddev_samp_fields';
    max_deviation?: Maybe<Scalars['Float']['output']>;
  };

/** Streaming cursor of the table "container_insights_temperature_breaches_expanded" */
export type Container_Insights_Temperature_Breaches_Expanded_Stream_Cursor_Input =
  {
    /** Stream column input with initial value */
    initial_value: Container_Insights_Temperature_Breaches_Expanded_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
  };

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Temperature_Breaches_Expanded_Stream_Cursor_Value_Input =
  {
    booking_id?: InputMaybe<Scalars['uuid']['input']>;
    breach_end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
    breach_end_gps?: InputMaybe<Scalars['geometry']['input']>;
    breach_id?: InputMaybe<Scalars['uuid']['input']>;
    breach_start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
    breach_start_gps?: InputMaybe<Scalars['geometry']['input']>;
    max_deviation?: InputMaybe<Scalars['float8']['input']>;
    reefer_id?: InputMaybe<Scalars['String']['input']>;
    telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
  };

/** aggregate sum on columns */
export type Container_Insights_Temperature_Breaches_Expanded_Sum_Fields = {
  __typename?: 'container_insights_temperature_breaches_expanded_sum_fields';
  max_deviation?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Container_Insights_Temperature_Breaches_Expanded_Var_Pop_Fields = {
  __typename?: 'container_insights_temperature_breaches_expanded_var_pop_fields';
  max_deviation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Container_Insights_Temperature_Breaches_Expanded_Var_Samp_Fields = {
  __typename?: 'container_insights_temperature_breaches_expanded_var_samp_fields';
  max_deviation?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Container_Insights_Temperature_Breaches_Expanded_Variance_Fields = {
  __typename?: 'container_insights_temperature_breaches_expanded_variance_fields';
  max_deviation?: Maybe<Scalars['Float']['output']>;
};

/** input type for incrementing numeric columns in table "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Inc_Input = {
  max_deviation?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  end_gps?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  max_deviation?: InputMaybe<Scalars['float8']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  start_gps?: InputMaybe<Scalars['geometry']['input']>;
  telematic_device?: InputMaybe<Container_Insights_Telematic_Devices_Obj_Rel_Insert_Input>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Container_Insights_Temperature_Breaches_Max_Fields = {
  __typename?: 'container_insights_temperature_breaches_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  max_deviation?: Maybe<Scalars['float8']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_deviation?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Container_Insights_Temperature_Breaches_Min_Fields = {
  __typename?: 'container_insights_temperature_breaches_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_datetime?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  max_deviation?: Maybe<Scalars['float8']['output']>;
  start_datetime?: Maybe<Scalars['timestamptz']['output']>;
  telematic_device_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_deviation?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Mutation_Response = {
  __typename?: 'container_insights_temperature_breaches_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Container_Insights_Temperature_Breaches>;
};

/** on_conflict condition type for table "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_On_Conflict = {
  constraint: Container_Insights_Temperature_Breaches_Constraint;
  update_columns?: Array<Container_Insights_Temperature_Breaches_Update_Column>;
  where?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
};

/** Ordering options when selecting data from "container_insights.temperature_breaches". */
export type Container_Insights_Temperature_Breaches_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  end_gps?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_deviation?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  start_gps?: InputMaybe<Order_By>;
  telematic_device?: InputMaybe<Container_Insights_Telematic_Devices_Order_By>;
  telematic_device_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: container_insights.temperature_breaches */
export type Container_Insights_Temperature_Breaches_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "container_insights.temperature_breaches" */
export enum Container_Insights_Temperature_Breaches_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDatetime = 'end_datetime',
  /** column name */
  EndGps = 'end_gps',
  /** column name */
  Id = 'id',
  /** column name */
  MaxDeviation = 'max_deviation',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  StartGps = 'start_gps',
  /** column name */
  TelematicDeviceId = 'telematic_device_id',
}

/** select "container_insights_temperature_breaches_aggregate_bool_exp_avg_arguments_columns" columns of table "container_insights.temperature_breaches" */
export enum Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  MaxDeviation = 'max_deviation',
}

/** select "container_insights_temperature_breaches_aggregate_bool_exp_corr_arguments_columns" columns of table "container_insights.temperature_breaches" */
export enum Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  MaxDeviation = 'max_deviation',
}

/** select "container_insights_temperature_breaches_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "container_insights.temperature_breaches" */
export enum Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  MaxDeviation = 'max_deviation',
}

/** select "container_insights_temperature_breaches_aggregate_bool_exp_max_arguments_columns" columns of table "container_insights.temperature_breaches" */
export enum Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  MaxDeviation = 'max_deviation',
}

/** select "container_insights_temperature_breaches_aggregate_bool_exp_min_arguments_columns" columns of table "container_insights.temperature_breaches" */
export enum Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  MaxDeviation = 'max_deviation',
}

/** select "container_insights_temperature_breaches_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "container_insights.temperature_breaches" */
export enum Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  MaxDeviation = 'max_deviation',
}

/** select "container_insights_temperature_breaches_aggregate_bool_exp_sum_arguments_columns" columns of table "container_insights.temperature_breaches" */
export enum Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  MaxDeviation = 'max_deviation',
}

/** select "container_insights_temperature_breaches_aggregate_bool_exp_var_samp_arguments_columns" columns of table "container_insights.temperature_breaches" */
export enum Container_Insights_Temperature_Breaches_Select_Column_Container_Insights_Temperature_Breaches_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  MaxDeviation = 'max_deviation',
}

/** input type for updating data in table "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  end_gps?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  max_deviation?: InputMaybe<Scalars['float8']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  start_gps?: InputMaybe<Scalars['geometry']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Container_Insights_Temperature_Breaches_Stddev_Fields = {
  __typename?: 'container_insights_temperature_breaches_stddev_fields';
  max_deviation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Stddev_Order_By = {
  max_deviation?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Container_Insights_Temperature_Breaches_Stddev_Pop_Fields = {
  __typename?: 'container_insights_temperature_breaches_stddev_pop_fields';
  max_deviation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Stddev_Pop_Order_By = {
  max_deviation?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Container_Insights_Temperature_Breaches_Stddev_Samp_Fields = {
  __typename?: 'container_insights_temperature_breaches_stddev_samp_fields';
  max_deviation?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Stddev_Samp_Order_By = {
  max_deviation?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "container_insights_temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Temperature_Breaches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Temperature_Breaches_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  end_gps?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  max_deviation?: InputMaybe<Scalars['float8']['input']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  start_gps?: InputMaybe<Scalars['geometry']['input']>;
  telematic_device_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Container_Insights_Temperature_Breaches_Sum_Fields = {
  __typename?: 'container_insights_temperature_breaches_sum_fields';
  max_deviation?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Sum_Order_By = {
  max_deviation?: InputMaybe<Order_By>;
};

/** update columns of table "container_insights.temperature_breaches" */
export enum Container_Insights_Temperature_Breaches_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDatetime = 'end_datetime',
  /** column name */
  EndGps = 'end_gps',
  /** column name */
  Id = 'id',
  /** column name */
  MaxDeviation = 'max_deviation',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  StartGps = 'start_gps',
  /** column name */
  TelematicDeviceId = 'telematic_device_id',
}

export type Container_Insights_Temperature_Breaches_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Container_Insights_Temperature_Breaches_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Container_Insights_Temperature_Breaches_Set_Input>;
  /** filter the rows which have to be updated */
  where: Container_Insights_Temperature_Breaches_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Container_Insights_Temperature_Breaches_Var_Pop_Fields = {
  __typename?: 'container_insights_temperature_breaches_var_pop_fields';
  max_deviation?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Var_Pop_Order_By = {
  max_deviation?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Container_Insights_Temperature_Breaches_Var_Samp_Fields = {
  __typename?: 'container_insights_temperature_breaches_var_samp_fields';
  max_deviation?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Var_Samp_Order_By = {
  max_deviation?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Container_Insights_Temperature_Breaches_Variance_Fields = {
  __typename?: 'container_insights_temperature_breaches_variance_fields';
  max_deviation?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "container_insights.temperature_breaches" */
export type Container_Insights_Temperature_Breaches_Variance_Order_By = {
  max_deviation?: InputMaybe<Order_By>;
};

/** columns and relationships of "container_insights.temperatures" */
export type Container_Insights_Temperatures = {
  __typename?: 'container_insights_temperatures';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  max?: Maybe<Scalars['float8']['output']>;
  min?: Maybe<Scalars['float8']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "container_insights.temperatures" */
export type Container_Insights_Temperatures_Aggregate = {
  __typename?: 'container_insights_temperatures_aggregate';
  aggregate?: Maybe<Container_Insights_Temperatures_Aggregate_Fields>;
  nodes: Array<Container_Insights_Temperatures>;
};

/** aggregate fields of "container_insights.temperatures" */
export type Container_Insights_Temperatures_Aggregate_Fields = {
  __typename?: 'container_insights_temperatures_aggregate_fields';
  avg?: Maybe<Container_Insights_Temperatures_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Temperatures_Max_Fields>;
  min?: Maybe<Container_Insights_Temperatures_Min_Fields>;
  stddev?: Maybe<Container_Insights_Temperatures_Stddev_Fields>;
  stddev_pop?: Maybe<Container_Insights_Temperatures_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Container_Insights_Temperatures_Stddev_Samp_Fields>;
  sum?: Maybe<Container_Insights_Temperatures_Sum_Fields>;
  var_pop?: Maybe<Container_Insights_Temperatures_Var_Pop_Fields>;
  var_samp?: Maybe<Container_Insights_Temperatures_Var_Samp_Fields>;
  variance?: Maybe<Container_Insights_Temperatures_Variance_Fields>;
};

/** aggregate fields of "container_insights.temperatures" */
export type Container_Insights_Temperatures_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Container_Insights_Temperatures_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Container_Insights_Temperatures_Avg_Fields = {
  __typename?: 'container_insights_temperatures_avg_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "container_insights.temperatures". All fields are combined with a logical 'AND'. */
export type Container_Insights_Temperatures_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Temperatures_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Temperatures_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Temperatures_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  max?: InputMaybe<Float8_Comparison_Exp>;
  min?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "container_insights.temperatures" */
export enum Container_Insights_Temperatures_Constraint {
  /** unique or primary key constraint on columns "label" */
  TemperaturesLabelKey = 'temperatures_label_key',
  /** unique or primary key constraint on columns "id" */
  TemperaturesPkey = 'temperatures_pkey',
}

/** input type for incrementing numeric columns in table "container_insights.temperatures" */
export type Container_Insights_Temperatures_Inc_Input = {
  max?: InputMaybe<Scalars['float8']['input']>;
  min?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "container_insights.temperatures" */
export type Container_Insights_Temperatures_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['float8']['input']>;
  min?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Container_Insights_Temperatures_Max_Fields = {
  __typename?: 'container_insights_temperatures_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['float8']['output']>;
  min?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Container_Insights_Temperatures_Min_Fields = {
  __typename?: 'container_insights_temperatures_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['float8']['output']>;
  min?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "container_insights.temperatures" */
export type Container_Insights_Temperatures_Mutation_Response = {
  __typename?: 'container_insights_temperatures_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Container_Insights_Temperatures>;
};

/** on_conflict condition type for table "container_insights.temperatures" */
export type Container_Insights_Temperatures_On_Conflict = {
  constraint: Container_Insights_Temperatures_Constraint;
  update_columns?: Array<Container_Insights_Temperatures_Update_Column>;
  where?: InputMaybe<Container_Insights_Temperatures_Bool_Exp>;
};

/** Ordering options when selecting data from "container_insights.temperatures". */
export type Container_Insights_Temperatures_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: container_insights.temperatures */
export type Container_Insights_Temperatures_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "container_insights.temperatures" */
export enum Container_Insights_Temperatures_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Max = 'max',
  /** column name */
  Min = 'min',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "container_insights.temperatures" */
export type Container_Insights_Temperatures_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['float8']['input']>;
  min?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Container_Insights_Temperatures_Stddev_Fields = {
  __typename?: 'container_insights_temperatures_stddev_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Container_Insights_Temperatures_Stddev_Pop_Fields = {
  __typename?: 'container_insights_temperatures_stddev_pop_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Container_Insights_Temperatures_Stddev_Samp_Fields = {
  __typename?: 'container_insights_temperatures_stddev_samp_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "container_insights_temperatures" */
export type Container_Insights_Temperatures_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Temperatures_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Temperatures_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['float8']['input']>;
  min?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Container_Insights_Temperatures_Sum_Fields = {
  __typename?: 'container_insights_temperatures_sum_fields';
  max?: Maybe<Scalars['float8']['output']>;
  min?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "container_insights.temperatures" */
export enum Container_Insights_Temperatures_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Max = 'max',
  /** column name */
  Min = 'min',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Container_Insights_Temperatures_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Container_Insights_Temperatures_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Container_Insights_Temperatures_Set_Input>;
  /** filter the rows which have to be updated */
  where: Container_Insights_Temperatures_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Container_Insights_Temperatures_Var_Pop_Fields = {
  __typename?: 'container_insights_temperatures_var_pop_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Container_Insights_Temperatures_Var_Samp_Fields = {
  __typename?: 'container_insights_temperatures_var_samp_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Container_Insights_Temperatures_Variance_Fields = {
  __typename?: 'container_insights_temperatures_variance_fields';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "container_insights.user_shipping_lines_authorizations" */
export type Container_Insights_User_Shipping_Lines_Authorizations = {
  __typename?: 'container_insights_user_shipping_lines_authorizations';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  shipping_line: Container_Insights_Shipping_Lines;
  shipping_line_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Container_Insights_Users;
  user_id: Scalars['String']['output'];
};

/** aggregated selection of "container_insights.user_shipping_lines_authorizations" */
export type Container_Insights_User_Shipping_Lines_Authorizations_Aggregate = {
  __typename?: 'container_insights_user_shipping_lines_authorizations_aggregate';
  aggregate?: Maybe<Container_Insights_User_Shipping_Lines_Authorizations_Aggregate_Fields>;
  nodes: Array<Container_Insights_User_Shipping_Lines_Authorizations>;
};

export type Container_Insights_User_Shipping_Lines_Authorizations_Aggregate_Bool_Exp =
  {
    count?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Aggregate_Bool_Exp_Count>;
  };

export type Container_Insights_User_Shipping_Lines_Authorizations_Aggregate_Bool_Exp_Count =
  {
    arguments?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Select_Column>
    >;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
    filter?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp>;
    predicate: Int_Comparison_Exp;
  };

/** aggregate fields of "container_insights.user_shipping_lines_authorizations" */
export type Container_Insights_User_Shipping_Lines_Authorizations_Aggregate_Fields =
  {
    __typename?: 'container_insights_user_shipping_lines_authorizations_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<Container_Insights_User_Shipping_Lines_Authorizations_Max_Fields>;
    min?: Maybe<Container_Insights_User_Shipping_Lines_Authorizations_Min_Fields>;
  };

/** aggregate fields of "container_insights.user_shipping_lines_authorizations" */
export type Container_Insights_User_Shipping_Lines_Authorizations_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Select_Column>
    >;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
  };

/** order by aggregate values of table "container_insights.user_shipping_lines_authorizations" */
export type Container_Insights_User_Shipping_Lines_Authorizations_Aggregate_Order_By =
  {
    count?: InputMaybe<Order_By>;
    max?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Max_Order_By>;
    min?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Min_Order_By>;
  };

/** input type for inserting array relation for remote table "container_insights.user_shipping_lines_authorizations" */
export type Container_Insights_User_Shipping_Lines_Authorizations_Arr_Rel_Insert_Input =
  {
    data: Array<Container_Insights_User_Shipping_Lines_Authorizations_Insert_Input>;
    /** upsert condition */
    on_conflict?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_On_Conflict>;
  };

/** Boolean expression to filter rows from the table "container_insights.user_shipping_lines_authorizations". All fields are combined with a logical 'AND'. */
export type Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp = {
  _and?: InputMaybe<
    Array<Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp>
  >;
  _not?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  shipping_line?: InputMaybe<Container_Insights_Shipping_Lines_Bool_Exp>;
  shipping_line_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Container_Insights_Users_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "container_insights.user_shipping_lines_authorizations" */
export enum Container_Insights_User_Shipping_Lines_Authorizations_Constraint {
  /** unique or primary key constraint on columns "user_id", "shipping_line_id" */
  UserShippingLinesAuthorizationsPkey = 'user_shipping_lines_authorizations_pkey',
}

/** columns and relationships of "container_insights.user_shipping_lines_authorizations_expanded" */
export type Container_Insights_User_Shipping_Lines_Authorizations_Expanded = {
  __typename?: 'container_insights_user_shipping_lines_authorizations_expanded';
  shipping_line_id?: Maybe<Scalars['uuid']['output']>;
  shipping_line_name?: Maybe<Scalars['String']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "container_insights.user_shipping_lines_authorizations_expanded" */
export type Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Aggregate =
  {
    __typename?: 'container_insights_user_shipping_lines_authorizations_expanded_aggregate';
    aggregate?: Maybe<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Aggregate_Fields>;
    nodes: Array<Container_Insights_User_Shipping_Lines_Authorizations_Expanded>;
  };

/** aggregate fields of "container_insights.user_shipping_lines_authorizations_expanded" */
export type Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Aggregate_Fields =
  {
    __typename?: 'container_insights_user_shipping_lines_authorizations_expanded_aggregate_fields';
    count: Scalars['Int']['output'];
    max?: Maybe<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Max_Fields>;
    min?: Maybe<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Min_Fields>;
  };

/** aggregate fields of "container_insights.user_shipping_lines_authorizations_expanded" */
export type Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Select_Column>
    >;
    distinct?: InputMaybe<Scalars['Boolean']['input']>;
  };

/** Boolean expression to filter rows from the table "container_insights.user_shipping_lines_authorizations_expanded". All fields are combined with a logical 'AND'. */
export type Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Bool_Exp =
  {
    _and?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Bool_Exp>
    >;
    _not?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Bool_Exp>;
    _or?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Bool_Exp>
    >;
    shipping_line_id?: InputMaybe<Uuid_Comparison_Exp>;
    shipping_line_name?: InputMaybe<String_Comparison_Exp>;
    user_email?: InputMaybe<String_Comparison_Exp>;
    user_id?: InputMaybe<String_Comparison_Exp>;
  };

/** aggregate max on columns */
export type Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Max_Fields =
  {
    __typename?: 'container_insights_user_shipping_lines_authorizations_expanded_max_fields';
    shipping_line_id?: Maybe<Scalars['uuid']['output']>;
    shipping_line_name?: Maybe<Scalars['String']['output']>;
    user_email?: Maybe<Scalars['String']['output']>;
    user_id?: Maybe<Scalars['String']['output']>;
  };

/** aggregate min on columns */
export type Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Min_Fields =
  {
    __typename?: 'container_insights_user_shipping_lines_authorizations_expanded_min_fields';
    shipping_line_id?: Maybe<Scalars['uuid']['output']>;
    shipping_line_name?: Maybe<Scalars['String']['output']>;
    user_email?: Maybe<Scalars['String']['output']>;
    user_id?: Maybe<Scalars['String']['output']>;
  };

/** Ordering options when selecting data from "container_insights.user_shipping_lines_authorizations_expanded". */
export type Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Order_By =
  {
    shipping_line_id?: InputMaybe<Order_By>;
    shipping_line_name?: InputMaybe<Order_By>;
    user_email?: InputMaybe<Order_By>;
    user_id?: InputMaybe<Order_By>;
  };

/** select columns of table "container_insights.user_shipping_lines_authorizations_expanded" */
export enum Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Select_Column {
  /** column name */
  ShippingLineId = 'shipping_line_id',
  /** column name */
  ShippingLineName = 'shipping_line_name',
  /** column name */
  UserEmail = 'user_email',
  /** column name */
  UserId = 'user_id',
}

/** Streaming cursor of the table "container_insights_user_shipping_lines_authorizations_expanded" */
export type Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Stream_Cursor_Input =
  {
    /** Stream column input with initial value */
    initial_value: Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
  };

/** Initial value of the column from where the streaming should start */
export type Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Stream_Cursor_Value_Input =
  {
    shipping_line_id?: InputMaybe<Scalars['uuid']['input']>;
    shipping_line_name?: InputMaybe<Scalars['String']['input']>;
    user_email?: InputMaybe<Scalars['String']['input']>;
    user_id?: InputMaybe<Scalars['String']['input']>;
  };

/** input type for inserting data into table "container_insights.user_shipping_lines_authorizations" */
export type Container_Insights_User_Shipping_Lines_Authorizations_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  shipping_line?: InputMaybe<Container_Insights_Shipping_Lines_Obj_Rel_Insert_Input>;
  shipping_line_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Container_Insights_Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Container_Insights_User_Shipping_Lines_Authorizations_Max_Fields = {
  __typename?: 'container_insights_user_shipping_lines_authorizations_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  shipping_line_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "container_insights.user_shipping_lines_authorizations" */
export type Container_Insights_User_Shipping_Lines_Authorizations_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  shipping_line_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Container_Insights_User_Shipping_Lines_Authorizations_Min_Fields = {
  __typename?: 'container_insights_user_shipping_lines_authorizations_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  shipping_line_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "container_insights.user_shipping_lines_authorizations" */
export type Container_Insights_User_Shipping_Lines_Authorizations_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  shipping_line_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "container_insights.user_shipping_lines_authorizations" */
export type Container_Insights_User_Shipping_Lines_Authorizations_Mutation_Response =
  {
    __typename?: 'container_insights_user_shipping_lines_authorizations_mutation_response';
    /** number of rows affected by the mutation */
    affected_rows: Scalars['Int']['output'];
    /** data from the rows affected by the mutation */
    returning: Array<Container_Insights_User_Shipping_Lines_Authorizations>;
  };

/** on_conflict condition type for table "container_insights.user_shipping_lines_authorizations" */
export type Container_Insights_User_Shipping_Lines_Authorizations_On_Conflict =
  {
    constraint: Container_Insights_User_Shipping_Lines_Authorizations_Constraint;
    update_columns?: Array<Container_Insights_User_Shipping_Lines_Authorizations_Update_Column>;
    where?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp>;
  };

/** Ordering options when selecting data from "container_insights.user_shipping_lines_authorizations". */
export type Container_Insights_User_Shipping_Lines_Authorizations_Order_By = {
  created_at?: InputMaybe<Order_By>;
  shipping_line?: InputMaybe<Container_Insights_Shipping_Lines_Order_By>;
  shipping_line_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Container_Insights_Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: container_insights.user_shipping_lines_authorizations */
export type Container_Insights_User_Shipping_Lines_Authorizations_Pk_Columns_Input =
  {
    shipping_line_id: Scalars['uuid']['input'];
    user_id: Scalars['String']['input'];
  };

/** select columns of table "container_insights.user_shipping_lines_authorizations" */
export enum Container_Insights_User_Shipping_Lines_Authorizations_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ShippingLineId = 'shipping_line_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "container_insights.user_shipping_lines_authorizations" */
export type Container_Insights_User_Shipping_Lines_Authorizations_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  shipping_line_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "container_insights_user_shipping_lines_authorizations" */
export type Container_Insights_User_Shipping_Lines_Authorizations_Stream_Cursor_Input =
  {
    /** Stream column input with initial value */
    initial_value: Container_Insights_User_Shipping_Lines_Authorizations_Stream_Cursor_Value_Input;
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>;
  };

/** Initial value of the column from where the streaming should start */
export type Container_Insights_User_Shipping_Lines_Authorizations_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  shipping_line_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "container_insights.user_shipping_lines_authorizations" */
export enum Container_Insights_User_Shipping_Lines_Authorizations_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ShippingLineId = 'shipping_line_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Container_Insights_User_Shipping_Lines_Authorizations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp;
};

/** columns and relationships of "container_insights.users" */
export type Container_Insights_Users = {
  __typename?: 'container_insights_users';
  avatar?: Maybe<Scalars['String']['output']>;
  company: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  /** Auth0 user id */
  id: Scalars['String']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  /** An array relationship */
  user_shipping_lines_authorizations: Array<Container_Insights_User_Shipping_Lines_Authorizations>;
  /** An aggregate relationship */
  user_shipping_lines_authorizations_aggregate: Container_Insights_User_Shipping_Lines_Authorizations_Aggregate;
};

/** columns and relationships of "container_insights.users" */
export type Container_Insights_UsersUser_Shipping_Lines_AuthorizationsArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_User_Shipping_Lines_Authorizations_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<
    Array<Container_Insights_User_Shipping_Lines_Authorizations_Order_By>
  >;
  where?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp>;
};

/** columns and relationships of "container_insights.users" */
export type Container_Insights_UsersUser_Shipping_Lines_Authorizations_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Order_By>
    >;
    where?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp>;
  };

/** aggregated selection of "container_insights.users" */
export type Container_Insights_Users_Aggregate = {
  __typename?: 'container_insights_users_aggregate';
  aggregate?: Maybe<Container_Insights_Users_Aggregate_Fields>;
  nodes: Array<Container_Insights_Users>;
};

/** aggregate fields of "container_insights.users" */
export type Container_Insights_Users_Aggregate_Fields = {
  __typename?: 'container_insights_users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Container_Insights_Users_Max_Fields>;
  min?: Maybe<Container_Insights_Users_Min_Fields>;
};

/** aggregate fields of "container_insights.users" */
export type Container_Insights_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Container_Insights_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "container_insights.users". All fields are combined with a logical 'AND'. */
export type Container_Insights_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Container_Insights_Users_Bool_Exp>>;
  _not?: InputMaybe<Container_Insights_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Container_Insights_Users_Bool_Exp>>;
  avatar?: InputMaybe<String_Comparison_Exp>;
  company?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  locale?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  user_shipping_lines_authorizations?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp>;
  user_shipping_lines_authorizations_aggregate?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "container_insights.users" */
export enum Container_Insights_Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey',
}

/** input type for inserting data into table "container_insights.users" */
export type Container_Insights_Users_Insert_Input = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  /** Auth0 user id */
  id?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user_shipping_lines_authorizations?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Container_Insights_Users_Max_Fields = {
  __typename?: 'container_insights_users_max_fields';
  avatar?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  /** Auth0 user id */
  id?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Container_Insights_Users_Min_Fields = {
  __typename?: 'container_insights_users_min_fields';
  avatar?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  /** Auth0 user id */
  id?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "container_insights.users" */
export type Container_Insights_Users_Mutation_Response = {
  __typename?: 'container_insights_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Container_Insights_Users>;
};

/** input type for inserting object relation for remote table "container_insights.users" */
export type Container_Insights_Users_Obj_Rel_Insert_Input = {
  data: Container_Insights_Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Container_Insights_Users_On_Conflict>;
};

/** on_conflict condition type for table "container_insights.users" */
export type Container_Insights_Users_On_Conflict = {
  constraint: Container_Insights_Users_Constraint;
  update_columns?: Array<Container_Insights_Users_Update_Column>;
  where?: InputMaybe<Container_Insights_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "container_insights.users". */
export type Container_Insights_Users_Order_By = {
  avatar?: InputMaybe<Order_By>;
  company?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  user_shipping_lines_authorizations_aggregate?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Aggregate_Order_By>;
};

/** primary key columns input for table: container_insights.users */
export type Container_Insights_Users_Pk_Columns_Input = {
  /** Auth0 user id */
  id: Scalars['String']['input'];
};

/** select columns of table "container_insights.users" */
export enum Container_Insights_Users_Select_Column {
  /** column name */
  Avatar = 'avatar',
  /** column name */
  Company = 'company',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Locale = 'locale',
  /** column name */
  Role = 'role',
}

/** input type for updating data in table "container_insights.users" */
export type Container_Insights_Users_Set_Input = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  /** Auth0 user id */
  id?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "container_insights_users" */
export type Container_Insights_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Container_Insights_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Container_Insights_Users_Stream_Cursor_Value_Input = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  /** Auth0 user id */
  id?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "container_insights.users" */
export enum Container_Insights_Users_Update_Column {
  /** column name */
  Avatar = 'avatar',
  /** column name */
  Company = 'company',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Locale = 'locale',
  /** column name */
  Role = 'role',
}

export type Container_Insights_Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Container_Insights_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Container_Insights_Users_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC',
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** Boolean expression to compare columns of type "detailed_transport_mode". All fields are combined with logical 'AND'. */
export type Detailed_Transport_Mode_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['detailed_transport_mode']['input']>;
  _gt?: InputMaybe<Scalars['detailed_transport_mode']['input']>;
  _gte?: InputMaybe<Scalars['detailed_transport_mode']['input']>;
  _in?: InputMaybe<Array<Scalars['detailed_transport_mode']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['detailed_transport_mode']['input']>;
  _lte?: InputMaybe<Scalars['detailed_transport_mode']['input']>;
  _neq?: InputMaybe<Scalars['detailed_transport_mode']['input']>;
  _nin?: InputMaybe<Array<Scalars['detailed_transport_mode']['input']>>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']['input']>;
  _gt?: InputMaybe<Scalars['geography']['input']>;
  _gte?: InputMaybe<Scalars['geography']['input']>;
  _in?: InputMaybe<Array<Scalars['geography']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geography']['input']>;
  _lte?: InputMaybe<Scalars['geography']['input']>;
  _neq?: InputMaybe<Scalars['geography']['input']>;
  _nin?: InputMaybe<Array<Scalars['geography']['input']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']['input']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']['input']>;
  _gt?: InputMaybe<Scalars['geometry']['input']>;
  _gte?: InputMaybe<Scalars['geometry']['input']>;
  _in?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geometry']['input']>;
  _lte?: InputMaybe<Scalars['geometry']['input']>;
  _neq?: InputMaybe<Scalars['geometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['geometry']['input']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']['input']>;
};

/** columns and relationships of "glec.tradelane_groups" */
export type Glec_Tradelane_Groups = {
  __typename?: 'glec_tradelane_groups';
  name: Scalars['String']['output'];
};

/** aggregated selection of "glec.tradelane_groups" */
export type Glec_Tradelane_Groups_Aggregate = {
  __typename?: 'glec_tradelane_groups_aggregate';
  aggregate?: Maybe<Glec_Tradelane_Groups_Aggregate_Fields>;
  nodes: Array<Glec_Tradelane_Groups>;
};

/** aggregate fields of "glec.tradelane_groups" */
export type Glec_Tradelane_Groups_Aggregate_Fields = {
  __typename?: 'glec_tradelane_groups_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Glec_Tradelane_Groups_Max_Fields>;
  min?: Maybe<Glec_Tradelane_Groups_Min_Fields>;
};

/** aggregate fields of "glec.tradelane_groups" */
export type Glec_Tradelane_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Glec_Tradelane_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "glec.tradelane_groups". All fields are combined with a logical 'AND'. */
export type Glec_Tradelane_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Glec_Tradelane_Groups_Bool_Exp>>;
  _not?: InputMaybe<Glec_Tradelane_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Glec_Tradelane_Groups_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "glec.tradelane_groups" */
export type Glec_Tradelane_Groups_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Glec_Tradelane_Groups_Max_Fields = {
  __typename?: 'glec_tradelane_groups_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Glec_Tradelane_Groups_Min_Fields = {
  __typename?: 'glec_tradelane_groups_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "glec.tradelane_groups" */
export type Glec_Tradelane_Groups_Mutation_Response = {
  __typename?: 'glec_tradelane_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Glec_Tradelane_Groups>;
};

/** Ordering options when selecting data from "glec.tradelane_groups". */
export type Glec_Tradelane_Groups_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** select columns of table "glec.tradelane_groups" */
export enum Glec_Tradelane_Groups_Select_Column {
  /** column name */
  Name = 'name',
}

/** input type for updating data in table "glec.tradelane_groups" */
export type Glec_Tradelane_Groups_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "glec_tradelane_groups" */
export type Glec_Tradelane_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Glec_Tradelane_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Glec_Tradelane_Groups_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Glec_Tradelane_Groups_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Glec_Tradelane_Groups_Set_Input>;
  /** filter the rows which have to be updated */
  where: Glec_Tradelane_Groups_Bool_Exp;
};

/** columns and relationships of "glec.tradelanes" */
export type Glec_Tradelanes = {
  __typename?: 'glec_tradelanes';
  group?: Maybe<Scalars['String']['output']>;
  tradelane: Scalars['String']['output'];
};

/** aggregated selection of "glec.tradelanes" */
export type Glec_Tradelanes_Aggregate = {
  __typename?: 'glec_tradelanes_aggregate';
  aggregate?: Maybe<Glec_Tradelanes_Aggregate_Fields>;
  nodes: Array<Glec_Tradelanes>;
};

/** aggregate fields of "glec.tradelanes" */
export type Glec_Tradelanes_Aggregate_Fields = {
  __typename?: 'glec_tradelanes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Glec_Tradelanes_Max_Fields>;
  min?: Maybe<Glec_Tradelanes_Min_Fields>;
};

/** aggregate fields of "glec.tradelanes" */
export type Glec_Tradelanes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Glec_Tradelanes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "glec.tradelanes". All fields are combined with a logical 'AND'. */
export type Glec_Tradelanes_Bool_Exp = {
  _and?: InputMaybe<Array<Glec_Tradelanes_Bool_Exp>>;
  _not?: InputMaybe<Glec_Tradelanes_Bool_Exp>;
  _or?: InputMaybe<Array<Glec_Tradelanes_Bool_Exp>>;
  group?: InputMaybe<String_Comparison_Exp>;
  tradelane?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "glec.tradelanes" */
export type Glec_Tradelanes_Insert_Input = {
  group?: InputMaybe<Scalars['String']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Glec_Tradelanes_Max_Fields = {
  __typename?: 'glec_tradelanes_max_fields';
  group?: Maybe<Scalars['String']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Glec_Tradelanes_Min_Fields = {
  __typename?: 'glec_tradelanes_min_fields';
  group?: Maybe<Scalars['String']['output']>;
  tradelane?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "glec.tradelanes" */
export type Glec_Tradelanes_Mutation_Response = {
  __typename?: 'glec_tradelanes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Glec_Tradelanes>;
};

/** Ordering options when selecting data from "glec.tradelanes". */
export type Glec_Tradelanes_Order_By = {
  group?: InputMaybe<Order_By>;
  tradelane?: InputMaybe<Order_By>;
};

/** select columns of table "glec.tradelanes" */
export enum Glec_Tradelanes_Select_Column {
  /** column name */
  Group = 'group',
  /** column name */
  Tradelane = 'tradelane',
}

/** input type for updating data in table "glec.tradelanes" */
export type Glec_Tradelanes_Set_Input = {
  group?: InputMaybe<Scalars['String']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "glec_tradelanes" */
export type Glec_Tradelanes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Glec_Tradelanes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Glec_Tradelanes_Stream_Cursor_Value_Input = {
  group?: InputMaybe<Scalars['String']['input']>;
  tradelane?: InputMaybe<Scalars['String']['input']>;
};

export type Glec_Tradelanes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Glec_Tradelanes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Glec_Tradelanes_Bool_Exp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "container_insights.ages" */
  delete_container_insights_ages?: Maybe<Container_Insights_Ages_Mutation_Response>;
  /** delete single row from the table: "container_insights.ages" */
  delete_container_insights_ages_by_pk?: Maybe<Container_Insights_Ages>;
  /** delete data from the table: "container_insights.bookings" */
  delete_container_insights_bookings?: Maybe<Container_Insights_Bookings_Mutation_Response>;
  /** delete single row from the table: "container_insights.bookings" */
  delete_container_insights_bookings_by_pk?: Maybe<Container_Insights_Bookings>;
  /** delete data from the table: "container_insights.controller_models" */
  delete_container_insights_controller_models?: Maybe<Container_Insights_Controller_Models_Mutation_Response>;
  /** delete single row from the table: "container_insights.controller_models" */
  delete_container_insights_controller_models_by_pk?: Maybe<Container_Insights_Controller_Models>;
  /** delete data from the table: "container_insights.energy_usage" */
  delete_container_insights_energy_usage?: Maybe<Container_Insights_Energy_Usage_Mutation_Response>;
  /** delete data from the table: "container_insights.energy_usage_expanded_v2" */
  delete_container_insights_energy_usage_expanded_v2?: Maybe<Container_Insights_Energy_Usage_Expanded_V2_Mutation_Response>;
  /** delete data from the table: "container_insights.legs" */
  delete_container_insights_legs?: Maybe<Container_Insights_Legs_Mutation_Response>;
  /** delete single row from the table: "container_insights.legs" */
  delete_container_insights_legs_by_pk?: Maybe<Container_Insights_Legs>;
  /** delete data from the table: "container_insights.manufacturers" */
  delete_container_insights_manufacturers?: Maybe<Container_Insights_Manufacturers_Mutation_Response>;
  /** delete single row from the table: "container_insights.manufacturers" */
  delete_container_insights_manufacturers_by_pk?: Maybe<Container_Insights_Manufacturers>;
  /** delete data from the table: "container_insights.reefers" */
  delete_container_insights_reefers?: Maybe<Container_Insights_Reefers_Mutation_Response>;
  /** delete single row from the table: "container_insights.reefers" */
  delete_container_insights_reefers_by_pk?: Maybe<Container_Insights_Reefers>;
  /** delete data from the table: "container_insights.refrigeration_unit_models" */
  delete_container_insights_refrigeration_unit_models?: Maybe<Container_Insights_Refrigeration_Unit_Models_Mutation_Response>;
  /** delete single row from the table: "container_insights.refrigeration_unit_models" */
  delete_container_insights_refrigeration_unit_models_by_pk?: Maybe<Container_Insights_Refrigeration_Unit_Models>;
  /** delete data from the table: "container_insights.shipping_lines" */
  delete_container_insights_shipping_lines?: Maybe<Container_Insights_Shipping_Lines_Mutation_Response>;
  /** delete single row from the table: "container_insights.shipping_lines" */
  delete_container_insights_shipping_lines_by_pk?: Maybe<Container_Insights_Shipping_Lines>;
  /** delete data from the table: "container_insights.telematic_companies" */
  delete_container_insights_telematic_companies?: Maybe<Container_Insights_Telematic_Companies_Mutation_Response>;
  /** delete single row from the table: "container_insights.telematic_companies" */
  delete_container_insights_telematic_companies_by_pk?: Maybe<Container_Insights_Telematic_Companies>;
  /** delete data from the table: "container_insights.telematic_device_assignment" */
  delete_container_insights_telematic_device_assignment?: Maybe<Container_Insights_Telematic_Device_Assignment_Mutation_Response>;
  /** delete single row from the table: "container_insights.telematic_device_assignment" */
  delete_container_insights_telematic_device_assignment_by_pk?: Maybe<Container_Insights_Telematic_Device_Assignment>;
  /** delete data from the table: "container_insights.telematic_devices" */
  delete_container_insights_telematic_devices?: Maybe<Container_Insights_Telematic_Devices_Mutation_Response>;
  /** delete single row from the table: "container_insights.telematic_devices" */
  delete_container_insights_telematic_devices_by_pk?: Maybe<Container_Insights_Telematic_Devices>;
  /** delete data from the table: "container_insights.temperature_breaches" */
  delete_container_insights_temperature_breaches?: Maybe<Container_Insights_Temperature_Breaches_Mutation_Response>;
  /** delete single row from the table: "container_insights.temperature_breaches" */
  delete_container_insights_temperature_breaches_by_pk?: Maybe<Container_Insights_Temperature_Breaches>;
  /** delete data from the table: "container_insights.temperatures" */
  delete_container_insights_temperatures?: Maybe<Container_Insights_Temperatures_Mutation_Response>;
  /** delete single row from the table: "container_insights.temperatures" */
  delete_container_insights_temperatures_by_pk?: Maybe<Container_Insights_Temperatures>;
  /** delete data from the table: "container_insights.user_shipping_lines_authorizations" */
  delete_container_insights_user_shipping_lines_authorizations?: Maybe<Container_Insights_User_Shipping_Lines_Authorizations_Mutation_Response>;
  /** delete single row from the table: "container_insights.user_shipping_lines_authorizations" */
  delete_container_insights_user_shipping_lines_authorizations_by_pk?: Maybe<Container_Insights_User_Shipping_Lines_Authorizations>;
  /** delete data from the table: "container_insights.users" */
  delete_container_insights_users?: Maybe<Container_Insights_Users_Mutation_Response>;
  /** delete single row from the table: "container_insights.users" */
  delete_container_insights_users_by_pk?: Maybe<Container_Insights_Users>;
  /** delete data from the table: "glec.tradelane_groups" */
  delete_glec_tradelane_groups?: Maybe<Glec_Tradelane_Groups_Mutation_Response>;
  /** delete data from the table: "glec.tradelanes" */
  delete_glec_tradelanes?: Maybe<Glec_Tradelanes_Mutation_Response>;
  /** insert data into the table: "container_insights.ages" */
  insert_container_insights_ages?: Maybe<Container_Insights_Ages_Mutation_Response>;
  /** insert a single row into the table: "container_insights.ages" */
  insert_container_insights_ages_one?: Maybe<Container_Insights_Ages>;
  /** insert data into the table: "container_insights.bookings" */
  insert_container_insights_bookings?: Maybe<Container_Insights_Bookings_Mutation_Response>;
  /** insert a single row into the table: "container_insights.bookings" */
  insert_container_insights_bookings_one?: Maybe<Container_Insights_Bookings>;
  /** insert data into the table: "container_insights.controller_models" */
  insert_container_insights_controller_models?: Maybe<Container_Insights_Controller_Models_Mutation_Response>;
  /** insert a single row into the table: "container_insights.controller_models" */
  insert_container_insights_controller_models_one?: Maybe<Container_Insights_Controller_Models>;
  /** insert data into the table: "container_insights.energy_usage" */
  insert_container_insights_energy_usage?: Maybe<Container_Insights_Energy_Usage_Mutation_Response>;
  /** insert data into the table: "container_insights.energy_usage_expanded_v2" */
  insert_container_insights_energy_usage_expanded_v2?: Maybe<Container_Insights_Energy_Usage_Expanded_V2_Mutation_Response>;
  /** insert a single row into the table: "container_insights.energy_usage_expanded_v2" */
  insert_container_insights_energy_usage_expanded_v2_one?: Maybe<Container_Insights_Energy_Usage_Expanded_V2>;
  /** insert a single row into the table: "container_insights.energy_usage" */
  insert_container_insights_energy_usage_one?: Maybe<Container_Insights_Energy_Usage>;
  /** insert data into the table: "container_insights.legs" */
  insert_container_insights_legs?: Maybe<Container_Insights_Legs_Mutation_Response>;
  /** insert a single row into the table: "container_insights.legs" */
  insert_container_insights_legs_one?: Maybe<Container_Insights_Legs>;
  /** insert data into the table: "container_insights.manufacturers" */
  insert_container_insights_manufacturers?: Maybe<Container_Insights_Manufacturers_Mutation_Response>;
  /** insert a single row into the table: "container_insights.manufacturers" */
  insert_container_insights_manufacturers_one?: Maybe<Container_Insights_Manufacturers>;
  /** insert data into the table: "container_insights.reefers" */
  insert_container_insights_reefers?: Maybe<Container_Insights_Reefers_Mutation_Response>;
  /** insert a single row into the table: "container_insights.reefers" */
  insert_container_insights_reefers_one?: Maybe<Container_Insights_Reefers>;
  /** insert data into the table: "container_insights.refrigeration_unit_models" */
  insert_container_insights_refrigeration_unit_models?: Maybe<Container_Insights_Refrigeration_Unit_Models_Mutation_Response>;
  /** insert a single row into the table: "container_insights.refrigeration_unit_models" */
  insert_container_insights_refrigeration_unit_models_one?: Maybe<Container_Insights_Refrigeration_Unit_Models>;
  /** insert data into the table: "container_insights.shipping_lines" */
  insert_container_insights_shipping_lines?: Maybe<Container_Insights_Shipping_Lines_Mutation_Response>;
  /** insert a single row into the table: "container_insights.shipping_lines" */
  insert_container_insights_shipping_lines_one?: Maybe<Container_Insights_Shipping_Lines>;
  /** insert data into the table: "container_insights.telematic_companies" */
  insert_container_insights_telematic_companies?: Maybe<Container_Insights_Telematic_Companies_Mutation_Response>;
  /** insert a single row into the table: "container_insights.telematic_companies" */
  insert_container_insights_telematic_companies_one?: Maybe<Container_Insights_Telematic_Companies>;
  /** insert data into the table: "container_insights.telematic_device_assignment" */
  insert_container_insights_telematic_device_assignment?: Maybe<Container_Insights_Telematic_Device_Assignment_Mutation_Response>;
  /** insert a single row into the table: "container_insights.telematic_device_assignment" */
  insert_container_insights_telematic_device_assignment_one?: Maybe<Container_Insights_Telematic_Device_Assignment>;
  /** insert data into the table: "container_insights.telematic_devices" */
  insert_container_insights_telematic_devices?: Maybe<Container_Insights_Telematic_Devices_Mutation_Response>;
  /** insert a single row into the table: "container_insights.telematic_devices" */
  insert_container_insights_telematic_devices_one?: Maybe<Container_Insights_Telematic_Devices>;
  /** insert data into the table: "container_insights.temperature_breaches" */
  insert_container_insights_temperature_breaches?: Maybe<Container_Insights_Temperature_Breaches_Mutation_Response>;
  /** insert a single row into the table: "container_insights.temperature_breaches" */
  insert_container_insights_temperature_breaches_one?: Maybe<Container_Insights_Temperature_Breaches>;
  /** insert data into the table: "container_insights.temperatures" */
  insert_container_insights_temperatures?: Maybe<Container_Insights_Temperatures_Mutation_Response>;
  /** insert a single row into the table: "container_insights.temperatures" */
  insert_container_insights_temperatures_one?: Maybe<Container_Insights_Temperatures>;
  /** insert data into the table: "container_insights.user_shipping_lines_authorizations" */
  insert_container_insights_user_shipping_lines_authorizations?: Maybe<Container_Insights_User_Shipping_Lines_Authorizations_Mutation_Response>;
  /** insert a single row into the table: "container_insights.user_shipping_lines_authorizations" */
  insert_container_insights_user_shipping_lines_authorizations_one?: Maybe<Container_Insights_User_Shipping_Lines_Authorizations>;
  /** insert data into the table: "container_insights.users" */
  insert_container_insights_users?: Maybe<Container_Insights_Users_Mutation_Response>;
  /** insert a single row into the table: "container_insights.users" */
  insert_container_insights_users_one?: Maybe<Container_Insights_Users>;
  /** insert data into the table: "glec.tradelane_groups" */
  insert_glec_tradelane_groups?: Maybe<Glec_Tradelane_Groups_Mutation_Response>;
  /** insert a single row into the table: "glec.tradelane_groups" */
  insert_glec_tradelane_groups_one?: Maybe<Glec_Tradelane_Groups>;
  /** insert data into the table: "glec.tradelanes" */
  insert_glec_tradelanes?: Maybe<Glec_Tradelanes_Mutation_Response>;
  /** insert a single row into the table: "glec.tradelanes" */
  insert_glec_tradelanes_one?: Maybe<Glec_Tradelanes>;
  postEnergyUsage?: Maybe<EnergyUsageResponse>;
  /** update data of the table: "container_insights.ages" */
  update_container_insights_ages?: Maybe<Container_Insights_Ages_Mutation_Response>;
  /** update single row of the table: "container_insights.ages" */
  update_container_insights_ages_by_pk?: Maybe<Container_Insights_Ages>;
  /** update multiples rows of table: "container_insights.ages" */
  update_container_insights_ages_many?: Maybe<
    Array<Maybe<Container_Insights_Ages_Mutation_Response>>
  >;
  /** update data of the table: "container_insights.bookings" */
  update_container_insights_bookings?: Maybe<Container_Insights_Bookings_Mutation_Response>;
  /** update single row of the table: "container_insights.bookings" */
  update_container_insights_bookings_by_pk?: Maybe<Container_Insights_Bookings>;
  /** update multiples rows of table: "container_insights.bookings" */
  update_container_insights_bookings_many?: Maybe<
    Array<Maybe<Container_Insights_Bookings_Mutation_Response>>
  >;
  /** update data of the table: "container_insights.controller_models" */
  update_container_insights_controller_models?: Maybe<Container_Insights_Controller_Models_Mutation_Response>;
  /** update single row of the table: "container_insights.controller_models" */
  update_container_insights_controller_models_by_pk?: Maybe<Container_Insights_Controller_Models>;
  /** update multiples rows of table: "container_insights.controller_models" */
  update_container_insights_controller_models_many?: Maybe<
    Array<Maybe<Container_Insights_Controller_Models_Mutation_Response>>
  >;
  /** update data of the table: "container_insights.energy_usage" */
  update_container_insights_energy_usage?: Maybe<Container_Insights_Energy_Usage_Mutation_Response>;
  /** update data of the table: "container_insights.energy_usage_expanded_v2" */
  update_container_insights_energy_usage_expanded_v2?: Maybe<Container_Insights_Energy_Usage_Expanded_V2_Mutation_Response>;
  /** update multiples rows of table: "container_insights.energy_usage_expanded_v2" */
  update_container_insights_energy_usage_expanded_v2_many?: Maybe<Array<Maybe<Container_Insights_Energy_Usage_Expanded_V2_Mutation_Response>>>;
  /** update multiples rows of table: "container_insights.energy_usage" */
  update_container_insights_energy_usage_many?: Maybe<
    Array<Maybe<Container_Insights_Energy_Usage_Mutation_Response>>
  >;
  /** update data of the table: "container_insights.legs" */
  update_container_insights_legs?: Maybe<Container_Insights_Legs_Mutation_Response>;
  /** update single row of the table: "container_insights.legs" */
  update_container_insights_legs_by_pk?: Maybe<Container_Insights_Legs>;
  /** update multiples rows of table: "container_insights.legs" */
  update_container_insights_legs_many?: Maybe<
    Array<Maybe<Container_Insights_Legs_Mutation_Response>>
  >;
  /** update data of the table: "container_insights.manufacturers" */
  update_container_insights_manufacturers?: Maybe<Container_Insights_Manufacturers_Mutation_Response>;
  /** update single row of the table: "container_insights.manufacturers" */
  update_container_insights_manufacturers_by_pk?: Maybe<Container_Insights_Manufacturers>;
  /** update multiples rows of table: "container_insights.manufacturers" */
  update_container_insights_manufacturers_many?: Maybe<
    Array<Maybe<Container_Insights_Manufacturers_Mutation_Response>>
  >;
  /** update data of the table: "container_insights.reefers" */
  update_container_insights_reefers?: Maybe<Container_Insights_Reefers_Mutation_Response>;
  /** update single row of the table: "container_insights.reefers" */
  update_container_insights_reefers_by_pk?: Maybe<Container_Insights_Reefers>;
  /** update multiples rows of table: "container_insights.reefers" */
  update_container_insights_reefers_many?: Maybe<
    Array<Maybe<Container_Insights_Reefers_Mutation_Response>>
  >;
  /** update data of the table: "container_insights.refrigeration_unit_models" */
  update_container_insights_refrigeration_unit_models?: Maybe<Container_Insights_Refrigeration_Unit_Models_Mutation_Response>;
  /** update single row of the table: "container_insights.refrigeration_unit_models" */
  update_container_insights_refrigeration_unit_models_by_pk?: Maybe<Container_Insights_Refrigeration_Unit_Models>;
  /** update multiples rows of table: "container_insights.refrigeration_unit_models" */
  update_container_insights_refrigeration_unit_models_many?: Maybe<
    Array<Maybe<Container_Insights_Refrigeration_Unit_Models_Mutation_Response>>
  >;
  /** update data of the table: "container_insights.shipping_lines" */
  update_container_insights_shipping_lines?: Maybe<Container_Insights_Shipping_Lines_Mutation_Response>;
  /** update single row of the table: "container_insights.shipping_lines" */
  update_container_insights_shipping_lines_by_pk?: Maybe<Container_Insights_Shipping_Lines>;
  /** update multiples rows of table: "container_insights.shipping_lines" */
  update_container_insights_shipping_lines_many?: Maybe<
    Array<Maybe<Container_Insights_Shipping_Lines_Mutation_Response>>
  >;
  /** update data of the table: "container_insights.telematic_companies" */
  update_container_insights_telematic_companies?: Maybe<Container_Insights_Telematic_Companies_Mutation_Response>;
  /** update single row of the table: "container_insights.telematic_companies" */
  update_container_insights_telematic_companies_by_pk?: Maybe<Container_Insights_Telematic_Companies>;
  /** update multiples rows of table: "container_insights.telematic_companies" */
  update_container_insights_telematic_companies_many?: Maybe<
    Array<Maybe<Container_Insights_Telematic_Companies_Mutation_Response>>
  >;
  /** update data of the table: "container_insights.telematic_device_assignment" */
  update_container_insights_telematic_device_assignment?: Maybe<Container_Insights_Telematic_Device_Assignment_Mutation_Response>;
  /** update single row of the table: "container_insights.telematic_device_assignment" */
  update_container_insights_telematic_device_assignment_by_pk?: Maybe<Container_Insights_Telematic_Device_Assignment>;
  /** update multiples rows of table: "container_insights.telematic_device_assignment" */
  update_container_insights_telematic_device_assignment_many?: Maybe<
    Array<
      Maybe<Container_Insights_Telematic_Device_Assignment_Mutation_Response>
    >
  >;
  /** update data of the table: "container_insights.telematic_devices" */
  update_container_insights_telematic_devices?: Maybe<Container_Insights_Telematic_Devices_Mutation_Response>;
  /** update single row of the table: "container_insights.telematic_devices" */
  update_container_insights_telematic_devices_by_pk?: Maybe<Container_Insights_Telematic_Devices>;
  /** update multiples rows of table: "container_insights.telematic_devices" */
  update_container_insights_telematic_devices_many?: Maybe<
    Array<Maybe<Container_Insights_Telematic_Devices_Mutation_Response>>
  >;
  /** update data of the table: "container_insights.temperature_breaches" */
  update_container_insights_temperature_breaches?: Maybe<Container_Insights_Temperature_Breaches_Mutation_Response>;
  /** update single row of the table: "container_insights.temperature_breaches" */
  update_container_insights_temperature_breaches_by_pk?: Maybe<Container_Insights_Temperature_Breaches>;
  /** update multiples rows of table: "container_insights.temperature_breaches" */
  update_container_insights_temperature_breaches_many?: Maybe<
    Array<Maybe<Container_Insights_Temperature_Breaches_Mutation_Response>>
  >;
  /** update data of the table: "container_insights.temperatures" */
  update_container_insights_temperatures?: Maybe<Container_Insights_Temperatures_Mutation_Response>;
  /** update single row of the table: "container_insights.temperatures" */
  update_container_insights_temperatures_by_pk?: Maybe<Container_Insights_Temperatures>;
  /** update multiples rows of table: "container_insights.temperatures" */
  update_container_insights_temperatures_many?: Maybe<
    Array<Maybe<Container_Insights_Temperatures_Mutation_Response>>
  >;
  /** update data of the table: "container_insights.user_shipping_lines_authorizations" */
  update_container_insights_user_shipping_lines_authorizations?: Maybe<Container_Insights_User_Shipping_Lines_Authorizations_Mutation_Response>;
  /** update single row of the table: "container_insights.user_shipping_lines_authorizations" */
  update_container_insights_user_shipping_lines_authorizations_by_pk?: Maybe<Container_Insights_User_Shipping_Lines_Authorizations>;
  /** update multiples rows of table: "container_insights.user_shipping_lines_authorizations" */
  update_container_insights_user_shipping_lines_authorizations_many?: Maybe<
    Array<
      Maybe<Container_Insights_User_Shipping_Lines_Authorizations_Mutation_Response>
    >
  >;
  /** update data of the table: "container_insights.users" */
  update_container_insights_users?: Maybe<Container_Insights_Users_Mutation_Response>;
  /** update single row of the table: "container_insights.users" */
  update_container_insights_users_by_pk?: Maybe<Container_Insights_Users>;
  /** update multiples rows of table: "container_insights.users" */
  update_container_insights_users_many?: Maybe<
    Array<Maybe<Container_Insights_Users_Mutation_Response>>
  >;
  /** update data of the table: "glec.tradelane_groups" */
  update_glec_tradelane_groups?: Maybe<Glec_Tradelane_Groups_Mutation_Response>;
  /** update multiples rows of table: "glec.tradelane_groups" */
  update_glec_tradelane_groups_many?: Maybe<
    Array<Maybe<Glec_Tradelane_Groups_Mutation_Response>>
  >;
  /** update data of the table: "glec.tradelanes" */
  update_glec_tradelanes?: Maybe<Glec_Tradelanes_Mutation_Response>;
  /** update multiples rows of table: "glec.tradelanes" */
  update_glec_tradelanes_many?: Maybe<
    Array<Maybe<Glec_Tradelanes_Mutation_Response>>
  >;
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_AgesArgs = {
  where: Container_Insights_Ages_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Ages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_BookingsArgs = {
  where: Container_Insights_Bookings_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Bookings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Controller_ModelsArgs = {
  where: Container_Insights_Controller_Models_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Controller_Models_By_PkArgs =
  {
    id: Scalars['uuid']['input'];
  };

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Energy_UsageArgs = {
  where: Container_Insights_Energy_Usage_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Energy_Usage_Expanded_V2Args = {
  where: Container_Insights_Energy_Usage_Expanded_V2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Container_Insights_LegsArgs = {
  where: Container_Insights_Legs_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Legs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_ManufacturersArgs = {
  where: Container_Insights_Manufacturers_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Manufacturers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_ReefersArgs = {
  where: Container_Insights_Reefers_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Reefers_By_PkArgs = {
  id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Refrigeration_Unit_ModelsArgs =
  {
    where: Container_Insights_Refrigeration_Unit_Models_Bool_Exp;
  };

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Refrigeration_Unit_Models_By_PkArgs =
  {
    id: Scalars['uuid']['input'];
  };

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Shipping_LinesArgs = {
  where: Container_Insights_Shipping_Lines_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Shipping_Lines_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Telematic_CompaniesArgs = {
  where: Container_Insights_Telematic_Companies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Telematic_Companies_By_PkArgs =
  {
    id: Scalars['uuid']['input'];
  };

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Telematic_Device_AssignmentArgs =
  {
    where: Container_Insights_Telematic_Device_Assignment_Bool_Exp;
  };

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Telematic_Device_Assignment_By_PkArgs =
  {
    reefer_id: Scalars['String']['input'];
    telematic_device_id: Scalars['uuid']['input'];
  };

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Telematic_DevicesArgs = {
  where: Container_Insights_Telematic_Devices_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Telematic_Devices_By_PkArgs =
  {
    id: Scalars['uuid']['input'];
  };

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Temperature_BreachesArgs = {
  where: Container_Insights_Temperature_Breaches_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Temperature_Breaches_By_PkArgs =
  {
    id: Scalars['uuid']['input'];
  };

/** mutation root */
export type Mutation_RootDelete_Container_Insights_TemperaturesArgs = {
  where: Container_Insights_Temperatures_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Temperatures_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_User_Shipping_Lines_AuthorizationsArgs =
  {
    where: Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp;
  };

/** mutation root */
export type Mutation_RootDelete_Container_Insights_User_Shipping_Lines_Authorizations_By_PkArgs =
  {
    shipping_line_id: Scalars['uuid']['input'];
    user_id: Scalars['String']['input'];
  };

/** mutation root */
export type Mutation_RootDelete_Container_Insights_UsersArgs = {
  where: Container_Insights_Users_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Container_Insights_Users_By_PkArgs = {
  id: Scalars['String']['input'];
};

/** mutation root */
export type Mutation_RootDelete_Glec_Tradelane_GroupsArgs = {
  where: Glec_Tradelane_Groups_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Glec_TradelanesArgs = {
  where: Glec_Tradelanes_Bool_Exp;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_AgesArgs = {
  objects: Array<Container_Insights_Ages_Insert_Input>;
  on_conflict?: InputMaybe<Container_Insights_Ages_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Ages_OneArgs = {
  object: Container_Insights_Ages_Insert_Input;
  on_conflict?: InputMaybe<Container_Insights_Ages_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_BookingsArgs = {
  objects: Array<Container_Insights_Bookings_Insert_Input>;
  on_conflict?: InputMaybe<Container_Insights_Bookings_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Bookings_OneArgs = {
  object: Container_Insights_Bookings_Insert_Input;
  on_conflict?: InputMaybe<Container_Insights_Bookings_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Controller_ModelsArgs = {
  objects: Array<Container_Insights_Controller_Models_Insert_Input>;
  on_conflict?: InputMaybe<Container_Insights_Controller_Models_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Controller_Models_OneArgs = {
  object: Container_Insights_Controller_Models_Insert_Input;
  on_conflict?: InputMaybe<Container_Insights_Controller_Models_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Energy_UsageArgs = {
  objects: Array<Container_Insights_Energy_Usage_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Energy_Usage_Expanded_V2Args = {
  objects: Array<Container_Insights_Energy_Usage_Expanded_V2_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Container_Insights_Energy_Usage_Expanded_V2_OneArgs = {
  object: Container_Insights_Energy_Usage_Expanded_V2_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Container_Insights_Energy_Usage_OneArgs = {
  object: Container_Insights_Energy_Usage_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_LegsArgs = {
  objects: Array<Container_Insights_Legs_Insert_Input>;
  on_conflict?: InputMaybe<Container_Insights_Legs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Legs_OneArgs = {
  object: Container_Insights_Legs_Insert_Input;
  on_conflict?: InputMaybe<Container_Insights_Legs_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_ManufacturersArgs = {
  objects: Array<Container_Insights_Manufacturers_Insert_Input>;
  on_conflict?: InputMaybe<Container_Insights_Manufacturers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Manufacturers_OneArgs = {
  object: Container_Insights_Manufacturers_Insert_Input;
  on_conflict?: InputMaybe<Container_Insights_Manufacturers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_ReefersArgs = {
  objects: Array<Container_Insights_Reefers_Insert_Input>;
  on_conflict?: InputMaybe<Container_Insights_Reefers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Reefers_OneArgs = {
  object: Container_Insights_Reefers_Insert_Input;
  on_conflict?: InputMaybe<Container_Insights_Reefers_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Refrigeration_Unit_ModelsArgs =
  {
    objects: Array<Container_Insights_Refrigeration_Unit_Models_Insert_Input>;
    on_conflict?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_On_Conflict>;
  };

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Refrigeration_Unit_Models_OneArgs =
  {
    object: Container_Insights_Refrigeration_Unit_Models_Insert_Input;
    on_conflict?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_On_Conflict>;
  };

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Shipping_LinesArgs = {
  objects: Array<Container_Insights_Shipping_Lines_Insert_Input>;
  on_conflict?: InputMaybe<Container_Insights_Shipping_Lines_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Shipping_Lines_OneArgs = {
  object: Container_Insights_Shipping_Lines_Insert_Input;
  on_conflict?: InputMaybe<Container_Insights_Shipping_Lines_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Telematic_CompaniesArgs = {
  objects: Array<Container_Insights_Telematic_Companies_Insert_Input>;
  on_conflict?: InputMaybe<Container_Insights_Telematic_Companies_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Telematic_Companies_OneArgs =
  {
    object: Container_Insights_Telematic_Companies_Insert_Input;
    on_conflict?: InputMaybe<Container_Insights_Telematic_Companies_On_Conflict>;
  };

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Telematic_Device_AssignmentArgs =
  {
    objects: Array<Container_Insights_Telematic_Device_Assignment_Insert_Input>;
    on_conflict?: InputMaybe<Container_Insights_Telematic_Device_Assignment_On_Conflict>;
  };

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Telematic_Device_Assignment_OneArgs =
  {
    object: Container_Insights_Telematic_Device_Assignment_Insert_Input;
    on_conflict?: InputMaybe<Container_Insights_Telematic_Device_Assignment_On_Conflict>;
  };

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Telematic_DevicesArgs = {
  objects: Array<Container_Insights_Telematic_Devices_Insert_Input>;
  on_conflict?: InputMaybe<Container_Insights_Telematic_Devices_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Telematic_Devices_OneArgs = {
  object: Container_Insights_Telematic_Devices_Insert_Input;
  on_conflict?: InputMaybe<Container_Insights_Telematic_Devices_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Temperature_BreachesArgs = {
  objects: Array<Container_Insights_Temperature_Breaches_Insert_Input>;
  on_conflict?: InputMaybe<Container_Insights_Temperature_Breaches_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Temperature_Breaches_OneArgs =
  {
    object: Container_Insights_Temperature_Breaches_Insert_Input;
    on_conflict?: InputMaybe<Container_Insights_Temperature_Breaches_On_Conflict>;
  };

/** mutation root */
export type Mutation_RootInsert_Container_Insights_TemperaturesArgs = {
  objects: Array<Container_Insights_Temperatures_Insert_Input>;
  on_conflict?: InputMaybe<Container_Insights_Temperatures_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Temperatures_OneArgs = {
  object: Container_Insights_Temperatures_Insert_Input;
  on_conflict?: InputMaybe<Container_Insights_Temperatures_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_User_Shipping_Lines_AuthorizationsArgs =
  {
    objects: Array<Container_Insights_User_Shipping_Lines_Authorizations_Insert_Input>;
    on_conflict?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_On_Conflict>;
  };

/** mutation root */
export type Mutation_RootInsert_Container_Insights_User_Shipping_Lines_Authorizations_OneArgs =
  {
    object: Container_Insights_User_Shipping_Lines_Authorizations_Insert_Input;
    on_conflict?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_On_Conflict>;
  };

/** mutation root */
export type Mutation_RootInsert_Container_Insights_UsersArgs = {
  objects: Array<Container_Insights_Users_Insert_Input>;
  on_conflict?: InputMaybe<Container_Insights_Users_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Container_Insights_Users_OneArgs = {
  object: Container_Insights_Users_Insert_Input;
  on_conflict?: InputMaybe<Container_Insights_Users_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Glec_Tradelane_GroupsArgs = {
  objects: Array<Glec_Tradelane_Groups_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Glec_Tradelane_Groups_OneArgs = {
  object: Glec_Tradelane_Groups_Insert_Input;
};

/** mutation root */
export type Mutation_RootInsert_Glec_TradelanesArgs = {
  objects: Array<Glec_Tradelanes_Insert_Input>;
};

/** mutation root */
export type Mutation_RootInsert_Glec_Tradelanes_OneArgs = {
  object: Glec_Tradelanes_Insert_Input;
};

/** mutation root */
export type Mutation_RootPostEnergyUsageArgs = {
  energyUsageInputInput?: InputMaybe<EnergyUsageInputInput>;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_AgesArgs = {
  _inc?: InputMaybe<Container_Insights_Ages_Inc_Input>;
  _set?: InputMaybe<Container_Insights_Ages_Set_Input>;
  where: Container_Insights_Ages_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Ages_By_PkArgs = {
  _inc?: InputMaybe<Container_Insights_Ages_Inc_Input>;
  _set?: InputMaybe<Container_Insights_Ages_Set_Input>;
  pk_columns: Container_Insights_Ages_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Ages_ManyArgs = {
  updates: Array<Container_Insights_Ages_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_BookingsArgs = {
  _inc?: InputMaybe<Container_Insights_Bookings_Inc_Input>;
  _set?: InputMaybe<Container_Insights_Bookings_Set_Input>;
  where: Container_Insights_Bookings_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Bookings_By_PkArgs = {
  _inc?: InputMaybe<Container_Insights_Bookings_Inc_Input>;
  _set?: InputMaybe<Container_Insights_Bookings_Set_Input>;
  pk_columns: Container_Insights_Bookings_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Bookings_ManyArgs = {
  updates: Array<Container_Insights_Bookings_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Controller_ModelsArgs = {
  _set?: InputMaybe<Container_Insights_Controller_Models_Set_Input>;
  where: Container_Insights_Controller_Models_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Controller_Models_By_PkArgs =
  {
    _set?: InputMaybe<Container_Insights_Controller_Models_Set_Input>;
    pk_columns: Container_Insights_Controller_Models_Pk_Columns_Input;
  };

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Controller_Models_ManyArgs =
  {
    updates: Array<Container_Insights_Controller_Models_Updates>;
  };

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Energy_UsageArgs = {
  _inc?: InputMaybe<Container_Insights_Energy_Usage_Inc_Input>;
  _set?: InputMaybe<Container_Insights_Energy_Usage_Set_Input>;
  where: Container_Insights_Energy_Usage_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Energy_Usage_Expanded_V2Args = {
  _inc?: InputMaybe<Container_Insights_Energy_Usage_Expanded_V2_Inc_Input>;
  _set?: InputMaybe<Container_Insights_Energy_Usage_Expanded_V2_Set_Input>;
  where: Container_Insights_Energy_Usage_Expanded_V2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Energy_Usage_Expanded_V2_ManyArgs = {
  updates: Array<Container_Insights_Energy_Usage_Expanded_V2_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Energy_Usage_ManyArgs = {
  updates: Array<Container_Insights_Energy_Usage_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_LegsArgs = {
  _set?: InputMaybe<Container_Insights_Legs_Set_Input>;
  where: Container_Insights_Legs_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Legs_By_PkArgs = {
  _set?: InputMaybe<Container_Insights_Legs_Set_Input>;
  pk_columns: Container_Insights_Legs_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Legs_ManyArgs = {
  updates: Array<Container_Insights_Legs_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_ManufacturersArgs = {
  _set?: InputMaybe<Container_Insights_Manufacturers_Set_Input>;
  where: Container_Insights_Manufacturers_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Manufacturers_By_PkArgs = {
  _set?: InputMaybe<Container_Insights_Manufacturers_Set_Input>;
  pk_columns: Container_Insights_Manufacturers_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Manufacturers_ManyArgs = {
  updates: Array<Container_Insights_Manufacturers_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_ReefersArgs = {
  _set?: InputMaybe<Container_Insights_Reefers_Set_Input>;
  where: Container_Insights_Reefers_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Reefers_By_PkArgs = {
  _set?: InputMaybe<Container_Insights_Reefers_Set_Input>;
  pk_columns: Container_Insights_Reefers_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Reefers_ManyArgs = {
  updates: Array<Container_Insights_Reefers_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Refrigeration_Unit_ModelsArgs =
  {
    _inc?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Inc_Input>;
    _set?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Set_Input>;
    where: Container_Insights_Refrigeration_Unit_Models_Bool_Exp;
  };

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Refrigeration_Unit_Models_By_PkArgs =
  {
    _inc?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Inc_Input>;
    _set?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Set_Input>;
    pk_columns: Container_Insights_Refrigeration_Unit_Models_Pk_Columns_Input;
  };

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Refrigeration_Unit_Models_ManyArgs =
  {
    updates: Array<Container_Insights_Refrigeration_Unit_Models_Updates>;
  };

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Shipping_LinesArgs = {
  _set?: InputMaybe<Container_Insights_Shipping_Lines_Set_Input>;
  where: Container_Insights_Shipping_Lines_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Shipping_Lines_By_PkArgs = {
  _set?: InputMaybe<Container_Insights_Shipping_Lines_Set_Input>;
  pk_columns: Container_Insights_Shipping_Lines_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Shipping_Lines_ManyArgs = {
  updates: Array<Container_Insights_Shipping_Lines_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Telematic_CompaniesArgs = {
  _inc?: InputMaybe<Container_Insights_Telematic_Companies_Inc_Input>;
  _set?: InputMaybe<Container_Insights_Telematic_Companies_Set_Input>;
  where: Container_Insights_Telematic_Companies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Telematic_Companies_By_PkArgs = {
  _inc?: InputMaybe<Container_Insights_Telematic_Companies_Inc_Input>;
  _set?: InputMaybe<Container_Insights_Telematic_Companies_Set_Input>;
  pk_columns: Container_Insights_Telematic_Companies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Telematic_Companies_ManyArgs =
  {
    updates: Array<Container_Insights_Telematic_Companies_Updates>;
  };

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Telematic_Device_AssignmentArgs =
  {
    _set?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Set_Input>;
    where: Container_Insights_Telematic_Device_Assignment_Bool_Exp;
  };

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Telematic_Device_Assignment_By_PkArgs =
  {
    _set?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Set_Input>;
    pk_columns: Container_Insights_Telematic_Device_Assignment_Pk_Columns_Input;
  };

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Telematic_Device_Assignment_ManyArgs =
  {
    updates: Array<Container_Insights_Telematic_Device_Assignment_Updates>;
  };

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Telematic_DevicesArgs = {
  _set?: InputMaybe<Container_Insights_Telematic_Devices_Set_Input>;
  where: Container_Insights_Telematic_Devices_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Telematic_Devices_By_PkArgs =
  {
    _set?: InputMaybe<Container_Insights_Telematic_Devices_Set_Input>;
    pk_columns: Container_Insights_Telematic_Devices_Pk_Columns_Input;
  };

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Telematic_Devices_ManyArgs =
  {
    updates: Array<Container_Insights_Telematic_Devices_Updates>;
  };

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Temperature_BreachesArgs = {
  _inc?: InputMaybe<Container_Insights_Temperature_Breaches_Inc_Input>;
  _set?: InputMaybe<Container_Insights_Temperature_Breaches_Set_Input>;
  where: Container_Insights_Temperature_Breaches_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Temperature_Breaches_By_PkArgs =
  {
    _inc?: InputMaybe<Container_Insights_Temperature_Breaches_Inc_Input>;
    _set?: InputMaybe<Container_Insights_Temperature_Breaches_Set_Input>;
    pk_columns: Container_Insights_Temperature_Breaches_Pk_Columns_Input;
  };

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Temperature_Breaches_ManyArgs =
  {
    updates: Array<Container_Insights_Temperature_Breaches_Updates>;
  };

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_TemperaturesArgs = {
  _inc?: InputMaybe<Container_Insights_Temperatures_Inc_Input>;
  _set?: InputMaybe<Container_Insights_Temperatures_Set_Input>;
  where: Container_Insights_Temperatures_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Temperatures_By_PkArgs = {
  _inc?: InputMaybe<Container_Insights_Temperatures_Inc_Input>;
  _set?: InputMaybe<Container_Insights_Temperatures_Set_Input>;
  pk_columns: Container_Insights_Temperatures_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Temperatures_ManyArgs = {
  updates: Array<Container_Insights_Temperatures_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_User_Shipping_Lines_AuthorizationsArgs =
  {
    _set?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Set_Input>;
    where: Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp;
  };

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_User_Shipping_Lines_Authorizations_By_PkArgs =
  {
    _set?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Set_Input>;
    pk_columns: Container_Insights_User_Shipping_Lines_Authorizations_Pk_Columns_Input;
  };

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_User_Shipping_Lines_Authorizations_ManyArgs =
  {
    updates: Array<Container_Insights_User_Shipping_Lines_Authorizations_Updates>;
  };

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_UsersArgs = {
  _set?: InputMaybe<Container_Insights_Users_Set_Input>;
  where: Container_Insights_Users_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Users_By_PkArgs = {
  _set?: InputMaybe<Container_Insights_Users_Set_Input>;
  pk_columns: Container_Insights_Users_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Container_Insights_Users_ManyArgs = {
  updates: Array<Container_Insights_Users_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Glec_Tradelane_GroupsArgs = {
  _set?: InputMaybe<Glec_Tradelane_Groups_Set_Input>;
  where: Glec_Tradelane_Groups_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Glec_Tradelane_Groups_ManyArgs = {
  updates: Array<Glec_Tradelane_Groups_Updates>;
};

/** mutation root */
export type Mutation_RootUpdate_Glec_TradelanesArgs = {
  _set?: InputMaybe<Glec_Tradelanes_Set_Input>;
  where: Glec_Tradelanes_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Glec_Tradelanes_ManyArgs = {
  updates: Array<Glec_Tradelanes_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last',
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "container_insights.ages" */
  container_insights_ages: Array<Container_Insights_Ages>;
  /** fetch aggregated fields from the table: "container_insights.ages" */
  container_insights_ages_aggregate: Container_Insights_Ages_Aggregate;
  /** fetch data from the table: "container_insights.ages" using primary key columns */
  container_insights_ages_by_pk?: Maybe<Container_Insights_Ages>;
  /** fetch data from the table: "container_insights.booking_legs" */
  container_insights_booking_legs: Array<Container_Insights_Booking_Legs>;
  /** fetch aggregated fields from the table: "container_insights.booking_legs" */
  container_insights_booking_legs_aggregate: Container_Insights_Booking_Legs_Aggregate;
  /** fetch data from the table: "container_insights.bookings" */
  container_insights_bookings: Array<Container_Insights_Bookings>;
  /** fetch aggregated fields from the table: "container_insights.bookings" */
  container_insights_bookings_aggregate: Container_Insights_Bookings_Aggregate;
  /** fetch data from the table: "container_insights.bookings" using primary key columns */
  container_insights_bookings_by_pk?: Maybe<Container_Insights_Bookings>;
  /** fetch data from the table: "container_insights.bookings_expanded" */
  container_insights_bookings_expanded: Array<Container_Insights_Bookings_Expanded>;
  /** fetch aggregated fields from the table: "container_insights.bookings_expanded" */
  container_insights_bookings_expanded_aggregate: Container_Insights_Bookings_Expanded_Aggregate;
  /** fetch data from the table: "container_insights.controller_models" */
  container_insights_controller_models: Array<Container_Insights_Controller_Models>;
  /** fetch aggregated fields from the table: "container_insights.controller_models" */
  container_insights_controller_models_aggregate: Container_Insights_Controller_Models_Aggregate;
  /** fetch data from the table: "container_insights.controller_models" using primary key columns */
  container_insights_controller_models_by_pk?: Maybe<Container_Insights_Controller_Models>;
  /** fetch data from the table: "container_insights.energy_usage" */
  container_insights_energy_usage: Array<Container_Insights_Energy_Usage>;
  /** fetch aggregated fields from the table: "container_insights.energy_usage" */
  container_insights_energy_usage_aggregate: Container_Insights_Energy_Usage_Aggregate;
  /** fetch data from the table: "container_insights.energy_usage_expanded" */
  container_insights_energy_usage_expanded: Array<Container_Insights_Energy_Usage_Expanded>;
  /** fetch aggregated fields from the table: "container_insights.energy_usage_expanded" */
  container_insights_energy_usage_expanded_aggregate: Container_Insights_Energy_Usage_Expanded_Aggregate;
  /** fetch data from the table: "container_insights.energy_usage_expanded_v2" */
  container_insights_energy_usage_expanded_v2: Array<Container_Insights_Energy_Usage_Expanded_V2>;
  /** fetch aggregated fields from the table: "container_insights.energy_usage_expanded_v2" */
  container_insights_energy_usage_expanded_v2_aggregate: Container_Insights_Energy_Usage_Expanded_V2_Aggregate;
  /** fetch data from the table: "container_insights.legs" */
  container_insights_legs: Array<Container_Insights_Legs>;
  /** fetch aggregated fields from the table: "container_insights.legs" */
  container_insights_legs_aggregate: Container_Insights_Legs_Aggregate;
  /** fetch data from the table: "container_insights.legs" using primary key columns */
  container_insights_legs_by_pk?: Maybe<Container_Insights_Legs>;
  /** fetch data from the table: "container_insights.legs_expanded" */
  container_insights_legs_expanded: Array<Container_Insights_Legs_Expanded>;
  /** fetch aggregated fields from the table: "container_insights.legs_expanded" */
  container_insights_legs_expanded_aggregate: Container_Insights_Legs_Expanded_Aggregate;
  /** fetch data from the table: "container_insights.manufacturers" */
  container_insights_manufacturers: Array<Container_Insights_Manufacturers>;
  /** fetch aggregated fields from the table: "container_insights.manufacturers" */
  container_insights_manufacturers_aggregate: Container_Insights_Manufacturers_Aggregate;
  /** fetch data from the table: "container_insights.manufacturers" using primary key columns */
  container_insights_manufacturers_by_pk?: Maybe<Container_Insights_Manufacturers>;
  /** fetch data from the table: "container_insights.reefers" */
  container_insights_reefers: Array<Container_Insights_Reefers>;
  /** fetch aggregated fields from the table: "container_insights.reefers" */
  container_insights_reefers_aggregate: Container_Insights_Reefers_Aggregate;
  /** fetch data from the table: "container_insights.reefers" using primary key columns */
  container_insights_reefers_by_pk?: Maybe<Container_Insights_Reefers>;
  /** fetch data from the table: "container_insights.reefers_expanded" */
  container_insights_reefers_expanded: Array<Container_Insights_Reefers_Expanded>;
  /** fetch aggregated fields from the table: "container_insights.reefers_expanded" */
  container_insights_reefers_expanded_aggregate: Container_Insights_Reefers_Expanded_Aggregate;
  /** fetch data from the table: "container_insights.refrigeration_unit_models" */
  container_insights_refrigeration_unit_models: Array<Container_Insights_Refrigeration_Unit_Models>;
  /** fetch aggregated fields from the table: "container_insights.refrigeration_unit_models" */
  container_insights_refrigeration_unit_models_aggregate: Container_Insights_Refrigeration_Unit_Models_Aggregate;
  /** fetch data from the table: "container_insights.refrigeration_unit_models" using primary key columns */
  container_insights_refrigeration_unit_models_by_pk?: Maybe<Container_Insights_Refrigeration_Unit_Models>;
  /** fetch data from the table: "container_insights.shipping_lines" */
  container_insights_shipping_lines: Array<Container_Insights_Shipping_Lines>;
  /** fetch aggregated fields from the table: "container_insights.shipping_lines" */
  container_insights_shipping_lines_aggregate: Container_Insights_Shipping_Lines_Aggregate;
  /** fetch data from the table: "container_insights.shipping_lines" using primary key columns */
  container_insights_shipping_lines_by_pk?: Maybe<Container_Insights_Shipping_Lines>;
  /** fetch data from the table: "container_insights.telematic_companies" */
  container_insights_telematic_companies: Array<Container_Insights_Telematic_Companies>;
  /** fetch aggregated fields from the table: "container_insights.telematic_companies" */
  container_insights_telematic_companies_aggregate: Container_Insights_Telematic_Companies_Aggregate;
  /** fetch data from the table: "container_insights.telematic_companies" using primary key columns */
  container_insights_telematic_companies_by_pk?: Maybe<Container_Insights_Telematic_Companies>;
  /** fetch data from the table: "container_insights.telematic_device_assignment" */
  container_insights_telematic_device_assignment: Array<Container_Insights_Telematic_Device_Assignment>;
  /** fetch aggregated fields from the table: "container_insights.telematic_device_assignment" */
  container_insights_telematic_device_assignment_aggregate: Container_Insights_Telematic_Device_Assignment_Aggregate;
  /** fetch data from the table: "container_insights.telematic_device_assignment" using primary key columns */
  container_insights_telematic_device_assignment_by_pk?: Maybe<Container_Insights_Telematic_Device_Assignment>;
  /** fetch data from the table: "container_insights.telematic_device_assignment_expanded" */
  container_insights_telematic_device_assignment_expanded: Array<Container_Insights_Telematic_Device_Assignment_Expanded>;
  /** fetch aggregated fields from the table: "container_insights.telematic_device_assignment_expanded" */
  container_insights_telematic_device_assignment_expanded_aggregate: Container_Insights_Telematic_Device_Assignment_Expanded_Aggregate;
  /** fetch data from the table: "container_insights.telematic_devices" */
  container_insights_telematic_devices: Array<Container_Insights_Telematic_Devices>;
  /** fetch aggregated fields from the table: "container_insights.telematic_devices" */
  container_insights_telematic_devices_aggregate: Container_Insights_Telematic_Devices_Aggregate;
  /** fetch data from the table: "container_insights.telematic_devices" using primary key columns */
  container_insights_telematic_devices_by_pk?: Maybe<Container_Insights_Telematic_Devices>;
  /** fetch data from the table: "container_insights.temperature_breaches" */
  container_insights_temperature_breaches: Array<Container_Insights_Temperature_Breaches>;
  /** fetch aggregated fields from the table: "container_insights.temperature_breaches" */
  container_insights_temperature_breaches_aggregate: Container_Insights_Temperature_Breaches_Aggregate;
  /** fetch data from the table: "container_insights.temperature_breaches" using primary key columns */
  container_insights_temperature_breaches_by_pk?: Maybe<Container_Insights_Temperature_Breaches>;
  /** fetch data from the table: "container_insights.temperature_breaches_expanded" */
  container_insights_temperature_breaches_expanded: Array<Container_Insights_Temperature_Breaches_Expanded>;
  /** fetch aggregated fields from the table: "container_insights.temperature_breaches_expanded" */
  container_insights_temperature_breaches_expanded_aggregate: Container_Insights_Temperature_Breaches_Expanded_Aggregate;
  /** fetch data from the table: "container_insights.temperatures" */
  container_insights_temperatures: Array<Container_Insights_Temperatures>;
  /** fetch aggregated fields from the table: "container_insights.temperatures" */
  container_insights_temperatures_aggregate: Container_Insights_Temperatures_Aggregate;
  /** fetch data from the table: "container_insights.temperatures" using primary key columns */
  container_insights_temperatures_by_pk?: Maybe<Container_Insights_Temperatures>;
  /** fetch data from the table: "container_insights.user_shipping_lines_authorizations" */
  container_insights_user_shipping_lines_authorizations: Array<Container_Insights_User_Shipping_Lines_Authorizations>;
  /** fetch aggregated fields from the table: "container_insights.user_shipping_lines_authorizations" */
  container_insights_user_shipping_lines_authorizations_aggregate: Container_Insights_User_Shipping_Lines_Authorizations_Aggregate;
  /** fetch data from the table: "container_insights.user_shipping_lines_authorizations" using primary key columns */
  container_insights_user_shipping_lines_authorizations_by_pk?: Maybe<Container_Insights_User_Shipping_Lines_Authorizations>;
  /** fetch data from the table: "container_insights.user_shipping_lines_authorizations_expanded" */
  container_insights_user_shipping_lines_authorizations_expanded: Array<Container_Insights_User_Shipping_Lines_Authorizations_Expanded>;
  /** fetch aggregated fields from the table: "container_insights.user_shipping_lines_authorizations_expanded" */
  container_insights_user_shipping_lines_authorizations_expanded_aggregate: Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Aggregate;
  /** fetch data from the table: "container_insights.users" */
  container_insights_users: Array<Container_Insights_Users>;
  /** fetch aggregated fields from the table: "container_insights.users" */
  container_insights_users_aggregate: Container_Insights_Users_Aggregate;
  /** fetch data from the table: "container_insights.users" using primary key columns */
  container_insights_users_by_pk?: Maybe<Container_Insights_Users>;
  /** Get Energy Usage by Month */
  get_energy_usage_by_month?: Maybe<EnergyUsageResponse>;
  /** fetch data from the table: "glec.tradelane_groups" */
  glec_tradelane_groups: Array<Glec_Tradelane_Groups>;
  /** fetch aggregated fields from the table: "glec.tradelane_groups" */
  glec_tradelane_groups_aggregate: Glec_Tradelane_Groups_Aggregate;
  /** fetch data from the table: "glec.tradelanes" */
  glec_tradelanes: Array<Glec_Tradelanes>;
  /** fetch aggregated fields from the table: "glec.tradelanes" */
  glec_tradelanes_aggregate: Glec_Tradelanes_Aggregate;
};

export type Query_RootContainer_Insights_AgesArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Ages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Ages_Order_By>>;
  where?: InputMaybe<Container_Insights_Ages_Bool_Exp>;
};

export type Query_RootContainer_Insights_Ages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Ages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Ages_Order_By>>;
  where?: InputMaybe<Container_Insights_Ages_Bool_Exp>;
};

export type Query_RootContainer_Insights_Ages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootContainer_Insights_Booking_LegsArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Booking_Legs_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Booking_Legs_Order_By>>;
  where?: InputMaybe<Container_Insights_Booking_Legs_Bool_Exp>;
};

export type Query_RootContainer_Insights_Booking_Legs_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Booking_Legs_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Booking_Legs_Order_By>>;
  where?: InputMaybe<Container_Insights_Booking_Legs_Bool_Exp>;
};

export type Query_RootContainer_Insights_BookingsArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Bookings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Bookings_Order_By>>;
  where?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
};

export type Query_RootContainer_Insights_Bookings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Bookings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Bookings_Order_By>>;
  where?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
};

export type Query_RootContainer_Insights_Bookings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootContainer_Insights_Bookings_ExpandedArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Bookings_Expanded_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Bookings_Expanded_Order_By>>;
  where?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
};

export type Query_RootContainer_Insights_Bookings_Expanded_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Bookings_Expanded_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Bookings_Expanded_Order_By>>;
  where?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
};

export type Query_RootContainer_Insights_Controller_ModelsArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Controller_Models_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Controller_Models_Order_By>>;
  where?: InputMaybe<Container_Insights_Controller_Models_Bool_Exp>;
};

export type Query_RootContainer_Insights_Controller_Models_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Controller_Models_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Controller_Models_Order_By>>;
  where?: InputMaybe<Container_Insights_Controller_Models_Bool_Exp>;
};

export type Query_RootContainer_Insights_Controller_Models_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootContainer_Insights_Energy_UsageArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Energy_Usage_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Energy_Usage_Order_By>>;
  where?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
};

export type Query_RootContainer_Insights_Energy_Usage_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Energy_Usage_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Energy_Usage_Order_By>>;
  where?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
};

export type Query_RootContainer_Insights_Energy_Usage_ExpandedArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_Order_By>>;
  where?: InputMaybe<Container_Insights_Energy_Usage_Expanded_Bool_Exp>;
};


export type Query_RootContainer_Insights_Energy_Usage_Expanded_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_Order_By>>;
  where?: InputMaybe<Container_Insights_Energy_Usage_Expanded_Bool_Exp>;
};


export type Query_RootContainer_Insights_Energy_Usage_Expanded_V2Args = {
  distinct_on?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_V2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_V2_Order_By>>;
  where?: InputMaybe<Container_Insights_Energy_Usage_Expanded_V2_Bool_Exp>;
};

export type Query_RootContainer_Insights_Energy_Usage_Expanded_V2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_V2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_V2_Order_By>>;
  where?: InputMaybe<Container_Insights_Energy_Usage_Expanded_V2_Bool_Exp>;
};

export type Query_RootContainer_Insights_LegsArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Legs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Legs_Order_By>>;
  where?: InputMaybe<Container_Insights_Legs_Bool_Exp>;
};

export type Query_RootContainer_Insights_Legs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Legs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Legs_Order_By>>;
  where?: InputMaybe<Container_Insights_Legs_Bool_Exp>;
};

export type Query_RootContainer_Insights_Legs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootContainer_Insights_Legs_ExpandedArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Legs_Expanded_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Legs_Expanded_Order_By>>;
  where?: InputMaybe<Container_Insights_Legs_Expanded_Bool_Exp>;
};

export type Query_RootContainer_Insights_Legs_Expanded_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Legs_Expanded_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Legs_Expanded_Order_By>>;
  where?: InputMaybe<Container_Insights_Legs_Expanded_Bool_Exp>;
};

export type Query_RootContainer_Insights_ManufacturersArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Manufacturers_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Manufacturers_Order_By>>;
  where?: InputMaybe<Container_Insights_Manufacturers_Bool_Exp>;
};

export type Query_RootContainer_Insights_Manufacturers_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Manufacturers_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Manufacturers_Order_By>>;
  where?: InputMaybe<Container_Insights_Manufacturers_Bool_Exp>;
};

export type Query_RootContainer_Insights_Manufacturers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootContainer_Insights_ReefersArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Reefers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Reefers_Order_By>>;
  where?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
};

export type Query_RootContainer_Insights_Reefers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Reefers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Reefers_Order_By>>;
  where?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
};

export type Query_RootContainer_Insights_Reefers_By_PkArgs = {
  id: Scalars['String']['input'];
};

export type Query_RootContainer_Insights_Reefers_ExpandedArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Reefers_Expanded_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Reefers_Expanded_Order_By>>;
  where?: InputMaybe<Container_Insights_Reefers_Expanded_Bool_Exp>;
};

export type Query_RootContainer_Insights_Reefers_Expanded_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Reefers_Expanded_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Reefers_Expanded_Order_By>>;
  where?: InputMaybe<Container_Insights_Reefers_Expanded_Bool_Exp>;
};

export type Query_RootContainer_Insights_Refrigeration_Unit_ModelsArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Refrigeration_Unit_Models_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<
    Array<Container_Insights_Refrigeration_Unit_Models_Order_By>
  >;
  where?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
};

export type Query_RootContainer_Insights_Refrigeration_Unit_Models_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Refrigeration_Unit_Models_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Refrigeration_Unit_Models_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
  };

export type Query_RootContainer_Insights_Refrigeration_Unit_Models_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootContainer_Insights_Shipping_LinesArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Shipping_Lines_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Shipping_Lines_Order_By>>;
  where?: InputMaybe<Container_Insights_Shipping_Lines_Bool_Exp>;
};

export type Query_RootContainer_Insights_Shipping_Lines_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Shipping_Lines_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Shipping_Lines_Order_By>>;
  where?: InputMaybe<Container_Insights_Shipping_Lines_Bool_Exp>;
};

export type Query_RootContainer_Insights_Shipping_Lines_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootContainer_Insights_Telematic_CompaniesArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Telematic_Companies_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Telematic_Companies_Order_By>>;
  where?: InputMaybe<Container_Insights_Telematic_Companies_Bool_Exp>;
};

export type Query_RootContainer_Insights_Telematic_Companies_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Telematic_Companies_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Telematic_Companies_Order_By>>;
  where?: InputMaybe<Container_Insights_Telematic_Companies_Bool_Exp>;
};

export type Query_RootContainer_Insights_Telematic_Companies_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootContainer_Insights_Telematic_Device_AssignmentArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Telematic_Device_Assignment_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<
    Array<Container_Insights_Telematic_Device_Assignment_Order_By>
  >;
  where?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Bool_Exp>;
};

export type Query_RootContainer_Insights_Telematic_Device_Assignment_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Bool_Exp>;
  };

export type Query_RootContainer_Insights_Telematic_Device_Assignment_By_PkArgs =
  {
    reefer_id: Scalars['String']['input'];
    telematic_device_id: Scalars['uuid']['input'];
  };

export type Query_RootContainer_Insights_Telematic_Device_Assignment_ExpandedArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Expanded_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Expanded_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Expanded_Bool_Exp>;
  };

export type Query_RootContainer_Insights_Telematic_Device_Assignment_Expanded_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Expanded_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Expanded_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Expanded_Bool_Exp>;
  };

export type Query_RootContainer_Insights_Telematic_DevicesArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Telematic_Devices_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Telematic_Devices_Order_By>>;
  where?: InputMaybe<Container_Insights_Telematic_Devices_Bool_Exp>;
};

export type Query_RootContainer_Insights_Telematic_Devices_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Telematic_Devices_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Telematic_Devices_Order_By>>;
  where?: InputMaybe<Container_Insights_Telematic_Devices_Bool_Exp>;
};

export type Query_RootContainer_Insights_Telematic_Devices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootContainer_Insights_Temperature_BreachesArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Temperature_Breaches_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<
    Array<Container_Insights_Temperature_Breaches_Order_By>
  >;
  where?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
};

export type Query_RootContainer_Insights_Temperature_Breaches_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Temperature_Breaches_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<
    Array<Container_Insights_Temperature_Breaches_Order_By>
  >;
  where?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
};

export type Query_RootContainer_Insights_Temperature_Breaches_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootContainer_Insights_Temperature_Breaches_ExpandedArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Temperature_Breaches_Expanded_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<
    Array<Container_Insights_Temperature_Breaches_Expanded_Order_By>
  >;
  where?: InputMaybe<Container_Insights_Temperature_Breaches_Expanded_Bool_Exp>;
};

export type Query_RootContainer_Insights_Temperature_Breaches_Expanded_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Temperature_Breaches_Expanded_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Temperature_Breaches_Expanded_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Temperature_Breaches_Expanded_Bool_Exp>;
  };

export type Query_RootContainer_Insights_TemperaturesArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Temperatures_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Temperatures_Order_By>>;
  where?: InputMaybe<Container_Insights_Temperatures_Bool_Exp>;
};

export type Query_RootContainer_Insights_Temperatures_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Temperatures_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Temperatures_Order_By>>;
  where?: InputMaybe<Container_Insights_Temperatures_Bool_Exp>;
};

export type Query_RootContainer_Insights_Temperatures_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Query_RootContainer_Insights_User_Shipping_Lines_AuthorizationsArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Order_By>
    >;
    where?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp>;
  };

export type Query_RootContainer_Insights_User_Shipping_Lines_Authorizations_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Order_By>
    >;
    where?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp>;
  };

export type Query_RootContainer_Insights_User_Shipping_Lines_Authorizations_By_PkArgs =
  {
    shipping_line_id: Scalars['uuid']['input'];
    user_id: Scalars['String']['input'];
  };

export type Query_RootContainer_Insights_User_Shipping_Lines_Authorizations_ExpandedArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Order_By>
    >;
    where?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Bool_Exp>;
  };

export type Query_RootContainer_Insights_User_Shipping_Lines_Authorizations_Expanded_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Order_By>
    >;
    where?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Bool_Exp>;
  };

export type Query_RootContainer_Insights_UsersArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Users_Order_By>>;
  where?: InputMaybe<Container_Insights_Users_Bool_Exp>;
};

export type Query_RootContainer_Insights_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Users_Order_By>>;
  where?: InputMaybe<Container_Insights_Users_Bool_Exp>;
};

export type Query_RootContainer_Insights_Users_By_PkArgs = {
  id: Scalars['String']['input'];
};

export type Query_RootGet_Energy_Usage_By_MonthArgs = {
  energyUsageInputInput?: InputMaybe<EnergyUsageInputInput>;
};

export type Query_RootGlec_Tradelane_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Glec_Tradelane_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Glec_Tradelane_Groups_Order_By>>;
  where?: InputMaybe<Glec_Tradelane_Groups_Bool_Exp>;
};

export type Query_RootGlec_Tradelane_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Glec_Tradelane_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Glec_Tradelane_Groups_Order_By>>;
  where?: InputMaybe<Glec_Tradelane_Groups_Bool_Exp>;
};

export type Query_RootGlec_TradelanesArgs = {
  distinct_on?: InputMaybe<Array<Glec_Tradelanes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Glec_Tradelanes_Order_By>>;
  where?: InputMaybe<Glec_Tradelanes_Bool_Exp>;
};

export type Query_RootGlec_Tradelanes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Glec_Tradelanes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Glec_Tradelanes_Order_By>>;
  where?: InputMaybe<Glec_Tradelanes_Bool_Exp>;
};

/** Boolean expression to compare columns of type "reefer_mode". All fields are combined with logical 'AND'. */
export type Reefer_Mode_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['reefer_mode']['input']>;
  _gt?: InputMaybe<Scalars['reefer_mode']['input']>;
  _gte?: InputMaybe<Scalars['reefer_mode']['input']>;
  _in?: InputMaybe<Array<Scalars['reefer_mode']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['reefer_mode']['input']>;
  _lte?: InputMaybe<Scalars['reefer_mode']['input']>;
  _neq?: InputMaybe<Scalars['reefer_mode']['input']>;
  _nin?: InputMaybe<Array<Scalars['reefer_mode']['input']>>;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geometry']['input'];
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "container_insights.ages" */
  container_insights_ages: Array<Container_Insights_Ages>;
  /** fetch aggregated fields from the table: "container_insights.ages" */
  container_insights_ages_aggregate: Container_Insights_Ages_Aggregate;
  /** fetch data from the table: "container_insights.ages" using primary key columns */
  container_insights_ages_by_pk?: Maybe<Container_Insights_Ages>;
  /** fetch data from the table in a streaming manner: "container_insights.ages" */
  container_insights_ages_stream: Array<Container_Insights_Ages>;
  /** fetch data from the table: "container_insights.booking_legs" */
  container_insights_booking_legs: Array<Container_Insights_Booking_Legs>;
  /** fetch aggregated fields from the table: "container_insights.booking_legs" */
  container_insights_booking_legs_aggregate: Container_Insights_Booking_Legs_Aggregate;
  /** fetch data from the table in a streaming manner: "container_insights.booking_legs" */
  container_insights_booking_legs_stream: Array<Container_Insights_Booking_Legs>;
  /** fetch data from the table: "container_insights.bookings" */
  container_insights_bookings: Array<Container_Insights_Bookings>;
  /** fetch aggregated fields from the table: "container_insights.bookings" */
  container_insights_bookings_aggregate: Container_Insights_Bookings_Aggregate;
  /** fetch data from the table: "container_insights.bookings" using primary key columns */
  container_insights_bookings_by_pk?: Maybe<Container_Insights_Bookings>;
  /** fetch data from the table: "container_insights.bookings_expanded" */
  container_insights_bookings_expanded: Array<Container_Insights_Bookings_Expanded>;
  /** fetch aggregated fields from the table: "container_insights.bookings_expanded" */
  container_insights_bookings_expanded_aggregate: Container_Insights_Bookings_Expanded_Aggregate;
  /** fetch data from the table in a streaming manner: "container_insights.bookings_expanded" */
  container_insights_bookings_expanded_stream: Array<Container_Insights_Bookings_Expanded>;
  /** fetch data from the table in a streaming manner: "container_insights.bookings" */
  container_insights_bookings_stream: Array<Container_Insights_Bookings>;
  /** fetch data from the table: "container_insights.controller_models" */
  container_insights_controller_models: Array<Container_Insights_Controller_Models>;
  /** fetch aggregated fields from the table: "container_insights.controller_models" */
  container_insights_controller_models_aggregate: Container_Insights_Controller_Models_Aggregate;
  /** fetch data from the table: "container_insights.controller_models" using primary key columns */
  container_insights_controller_models_by_pk?: Maybe<Container_Insights_Controller_Models>;
  /** fetch data from the table in a streaming manner: "container_insights.controller_models" */
  container_insights_controller_models_stream: Array<Container_Insights_Controller_Models>;
  /** fetch data from the table: "container_insights.energy_usage" */
  container_insights_energy_usage: Array<Container_Insights_Energy_Usage>;
  /** fetch aggregated fields from the table: "container_insights.energy_usage" */
  container_insights_energy_usage_aggregate: Container_Insights_Energy_Usage_Aggregate;
  /** fetch data from the table: "container_insights.energy_usage_expanded" */
  container_insights_energy_usage_expanded: Array<Container_Insights_Energy_Usage_Expanded>;
  /** fetch aggregated fields from the table: "container_insights.energy_usage_expanded" */
  container_insights_energy_usage_expanded_aggregate: Container_Insights_Energy_Usage_Expanded_Aggregate;
  /** fetch data from the table in a streaming manner: "container_insights.energy_usage_expanded" */
  container_insights_energy_usage_expanded_stream: Array<Container_Insights_Energy_Usage_Expanded>;
  /** fetch data from the table: "container_insights.energy_usage_expanded_v2" */
  container_insights_energy_usage_expanded_v2: Array<Container_Insights_Energy_Usage_Expanded_V2>;
  /** fetch aggregated fields from the table: "container_insights.energy_usage_expanded_v2" */
  container_insights_energy_usage_expanded_v2_aggregate: Container_Insights_Energy_Usage_Expanded_V2_Aggregate;
  /** fetch data from the table in a streaming manner: "container_insights.energy_usage_expanded_v2" */
  container_insights_energy_usage_expanded_v2_stream: Array<Container_Insights_Energy_Usage_Expanded_V2>;
  /** fetch data from the table in a streaming manner: "container_insights.energy_usage" */
  container_insights_energy_usage_stream: Array<Container_Insights_Energy_Usage>;
  /** fetch data from the table: "container_insights.legs" */
  container_insights_legs: Array<Container_Insights_Legs>;
  /** fetch aggregated fields from the table: "container_insights.legs" */
  container_insights_legs_aggregate: Container_Insights_Legs_Aggregate;
  /** fetch data from the table: "container_insights.legs" using primary key columns */
  container_insights_legs_by_pk?: Maybe<Container_Insights_Legs>;
  /** fetch data from the table: "container_insights.legs_expanded" */
  container_insights_legs_expanded: Array<Container_Insights_Legs_Expanded>;
  /** fetch aggregated fields from the table: "container_insights.legs_expanded" */
  container_insights_legs_expanded_aggregate: Container_Insights_Legs_Expanded_Aggregate;
  /** fetch data from the table in a streaming manner: "container_insights.legs_expanded" */
  container_insights_legs_expanded_stream: Array<Container_Insights_Legs_Expanded>;
  /** fetch data from the table in a streaming manner: "container_insights.legs" */
  container_insights_legs_stream: Array<Container_Insights_Legs>;
  /** fetch data from the table: "container_insights.manufacturers" */
  container_insights_manufacturers: Array<Container_Insights_Manufacturers>;
  /** fetch aggregated fields from the table: "container_insights.manufacturers" */
  container_insights_manufacturers_aggregate: Container_Insights_Manufacturers_Aggregate;
  /** fetch data from the table: "container_insights.manufacturers" using primary key columns */
  container_insights_manufacturers_by_pk?: Maybe<Container_Insights_Manufacturers>;
  /** fetch data from the table in a streaming manner: "container_insights.manufacturers" */
  container_insights_manufacturers_stream: Array<Container_Insights_Manufacturers>;
  /** fetch data from the table: "container_insights.reefers" */
  container_insights_reefers: Array<Container_Insights_Reefers>;
  /** fetch aggregated fields from the table: "container_insights.reefers" */
  container_insights_reefers_aggregate: Container_Insights_Reefers_Aggregate;
  /** fetch data from the table: "container_insights.reefers" using primary key columns */
  container_insights_reefers_by_pk?: Maybe<Container_Insights_Reefers>;
  /** fetch data from the table: "container_insights.reefers_expanded" */
  container_insights_reefers_expanded: Array<Container_Insights_Reefers_Expanded>;
  /** fetch aggregated fields from the table: "container_insights.reefers_expanded" */
  container_insights_reefers_expanded_aggregate: Container_Insights_Reefers_Expanded_Aggregate;
  /** fetch data from the table in a streaming manner: "container_insights.reefers_expanded" */
  container_insights_reefers_expanded_stream: Array<Container_Insights_Reefers_Expanded>;
  /** fetch data from the table in a streaming manner: "container_insights.reefers" */
  container_insights_reefers_stream: Array<Container_Insights_Reefers>;
  /** fetch data from the table: "container_insights.refrigeration_unit_models" */
  container_insights_refrigeration_unit_models: Array<Container_Insights_Refrigeration_Unit_Models>;
  /** fetch aggregated fields from the table: "container_insights.refrigeration_unit_models" */
  container_insights_refrigeration_unit_models_aggregate: Container_Insights_Refrigeration_Unit_Models_Aggregate;
  /** fetch data from the table: "container_insights.refrigeration_unit_models" using primary key columns */
  container_insights_refrigeration_unit_models_by_pk?: Maybe<Container_Insights_Refrigeration_Unit_Models>;
  /** fetch data from the table in a streaming manner: "container_insights.refrigeration_unit_models" */
  container_insights_refrigeration_unit_models_stream: Array<Container_Insights_Refrigeration_Unit_Models>;
  /** fetch data from the table: "container_insights.shipping_lines" */
  container_insights_shipping_lines: Array<Container_Insights_Shipping_Lines>;
  /** fetch aggregated fields from the table: "container_insights.shipping_lines" */
  container_insights_shipping_lines_aggregate: Container_Insights_Shipping_Lines_Aggregate;
  /** fetch data from the table: "container_insights.shipping_lines" using primary key columns */
  container_insights_shipping_lines_by_pk?: Maybe<Container_Insights_Shipping_Lines>;
  /** fetch data from the table in a streaming manner: "container_insights.shipping_lines" */
  container_insights_shipping_lines_stream: Array<Container_Insights_Shipping_Lines>;
  /** fetch data from the table: "container_insights.telematic_companies" */
  container_insights_telematic_companies: Array<Container_Insights_Telematic_Companies>;
  /** fetch aggregated fields from the table: "container_insights.telematic_companies" */
  container_insights_telematic_companies_aggregate: Container_Insights_Telematic_Companies_Aggregate;
  /** fetch data from the table: "container_insights.telematic_companies" using primary key columns */
  container_insights_telematic_companies_by_pk?: Maybe<Container_Insights_Telematic_Companies>;
  /** fetch data from the table in a streaming manner: "container_insights.telematic_companies" */
  container_insights_telematic_companies_stream: Array<Container_Insights_Telematic_Companies>;
  /** fetch data from the table: "container_insights.telematic_device_assignment" */
  container_insights_telematic_device_assignment: Array<Container_Insights_Telematic_Device_Assignment>;
  /** fetch aggregated fields from the table: "container_insights.telematic_device_assignment" */
  container_insights_telematic_device_assignment_aggregate: Container_Insights_Telematic_Device_Assignment_Aggregate;
  /** fetch data from the table: "container_insights.telematic_device_assignment" using primary key columns */
  container_insights_telematic_device_assignment_by_pk?: Maybe<Container_Insights_Telematic_Device_Assignment>;
  /** fetch data from the table: "container_insights.telematic_device_assignment_expanded" */
  container_insights_telematic_device_assignment_expanded: Array<Container_Insights_Telematic_Device_Assignment_Expanded>;
  /** fetch aggregated fields from the table: "container_insights.telematic_device_assignment_expanded" */
  container_insights_telematic_device_assignment_expanded_aggregate: Container_Insights_Telematic_Device_Assignment_Expanded_Aggregate;
  /** fetch data from the table in a streaming manner: "container_insights.telematic_device_assignment_expanded" */
  container_insights_telematic_device_assignment_expanded_stream: Array<Container_Insights_Telematic_Device_Assignment_Expanded>;
  /** fetch data from the table in a streaming manner: "container_insights.telematic_device_assignment" */
  container_insights_telematic_device_assignment_stream: Array<Container_Insights_Telematic_Device_Assignment>;
  /** fetch data from the table: "container_insights.telematic_devices" */
  container_insights_telematic_devices: Array<Container_Insights_Telematic_Devices>;
  /** fetch aggregated fields from the table: "container_insights.telematic_devices" */
  container_insights_telematic_devices_aggregate: Container_Insights_Telematic_Devices_Aggregate;
  /** fetch data from the table: "container_insights.telematic_devices" using primary key columns */
  container_insights_telematic_devices_by_pk?: Maybe<Container_Insights_Telematic_Devices>;
  /** fetch data from the table in a streaming manner: "container_insights.telematic_devices" */
  container_insights_telematic_devices_stream: Array<Container_Insights_Telematic_Devices>;
  /** fetch data from the table: "container_insights.temperature_breaches" */
  container_insights_temperature_breaches: Array<Container_Insights_Temperature_Breaches>;
  /** fetch aggregated fields from the table: "container_insights.temperature_breaches" */
  container_insights_temperature_breaches_aggregate: Container_Insights_Temperature_Breaches_Aggregate;
  /** fetch data from the table: "container_insights.temperature_breaches" using primary key columns */
  container_insights_temperature_breaches_by_pk?: Maybe<Container_Insights_Temperature_Breaches>;
  /** fetch data from the table: "container_insights.temperature_breaches_expanded" */
  container_insights_temperature_breaches_expanded: Array<Container_Insights_Temperature_Breaches_Expanded>;
  /** fetch aggregated fields from the table: "container_insights.temperature_breaches_expanded" */
  container_insights_temperature_breaches_expanded_aggregate: Container_Insights_Temperature_Breaches_Expanded_Aggregate;
  /** fetch data from the table in a streaming manner: "container_insights.temperature_breaches_expanded" */
  container_insights_temperature_breaches_expanded_stream: Array<Container_Insights_Temperature_Breaches_Expanded>;
  /** fetch data from the table in a streaming manner: "container_insights.temperature_breaches" */
  container_insights_temperature_breaches_stream: Array<Container_Insights_Temperature_Breaches>;
  /** fetch data from the table: "container_insights.temperatures" */
  container_insights_temperatures: Array<Container_Insights_Temperatures>;
  /** fetch aggregated fields from the table: "container_insights.temperatures" */
  container_insights_temperatures_aggregate: Container_Insights_Temperatures_Aggregate;
  /** fetch data from the table: "container_insights.temperatures" using primary key columns */
  container_insights_temperatures_by_pk?: Maybe<Container_Insights_Temperatures>;
  /** fetch data from the table in a streaming manner: "container_insights.temperatures" */
  container_insights_temperatures_stream: Array<Container_Insights_Temperatures>;
  /** fetch data from the table: "container_insights.user_shipping_lines_authorizations" */
  container_insights_user_shipping_lines_authorizations: Array<Container_Insights_User_Shipping_Lines_Authorizations>;
  /** fetch aggregated fields from the table: "container_insights.user_shipping_lines_authorizations" */
  container_insights_user_shipping_lines_authorizations_aggregate: Container_Insights_User_Shipping_Lines_Authorizations_Aggregate;
  /** fetch data from the table: "container_insights.user_shipping_lines_authorizations" using primary key columns */
  container_insights_user_shipping_lines_authorizations_by_pk?: Maybe<Container_Insights_User_Shipping_Lines_Authorizations>;
  /** fetch data from the table: "container_insights.user_shipping_lines_authorizations_expanded" */
  container_insights_user_shipping_lines_authorizations_expanded: Array<Container_Insights_User_Shipping_Lines_Authorizations_Expanded>;
  /** fetch aggregated fields from the table: "container_insights.user_shipping_lines_authorizations_expanded" */
  container_insights_user_shipping_lines_authorizations_expanded_aggregate: Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Aggregate;
  /** fetch data from the table in a streaming manner: "container_insights.user_shipping_lines_authorizations_expanded" */
  container_insights_user_shipping_lines_authorizations_expanded_stream: Array<Container_Insights_User_Shipping_Lines_Authorizations_Expanded>;
  /** fetch data from the table in a streaming manner: "container_insights.user_shipping_lines_authorizations" */
  container_insights_user_shipping_lines_authorizations_stream: Array<Container_Insights_User_Shipping_Lines_Authorizations>;
  /** fetch data from the table: "container_insights.users" */
  container_insights_users: Array<Container_Insights_Users>;
  /** fetch aggregated fields from the table: "container_insights.users" */
  container_insights_users_aggregate: Container_Insights_Users_Aggregate;
  /** fetch data from the table: "container_insights.users" using primary key columns */
  container_insights_users_by_pk?: Maybe<Container_Insights_Users>;
  /** fetch data from the table in a streaming manner: "container_insights.users" */
  container_insights_users_stream: Array<Container_Insights_Users>;
  /** fetch data from the table: "glec.tradelane_groups" */
  glec_tradelane_groups: Array<Glec_Tradelane_Groups>;
  /** fetch aggregated fields from the table: "glec.tradelane_groups" */
  glec_tradelane_groups_aggregate: Glec_Tradelane_Groups_Aggregate;
  /** fetch data from the table in a streaming manner: "glec.tradelane_groups" */
  glec_tradelane_groups_stream: Array<Glec_Tradelane_Groups>;
  /** fetch data from the table: "glec.tradelanes" */
  glec_tradelanes: Array<Glec_Tradelanes>;
  /** fetch aggregated fields from the table: "glec.tradelanes" */
  glec_tradelanes_aggregate: Glec_Tradelanes_Aggregate;
  /** fetch data from the table in a streaming manner: "glec.tradelanes" */
  glec_tradelanes_stream: Array<Glec_Tradelanes>;
};

export type Subscription_RootContainer_Insights_AgesArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Ages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Ages_Order_By>>;
  where?: InputMaybe<Container_Insights_Ages_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Ages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Ages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Ages_Order_By>>;
  where?: InputMaybe<Container_Insights_Ages_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Ages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootContainer_Insights_Ages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Container_Insights_Ages_Stream_Cursor_Input>>;
  where?: InputMaybe<Container_Insights_Ages_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Booking_LegsArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Booking_Legs_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Booking_Legs_Order_By>>;
  where?: InputMaybe<Container_Insights_Booking_Legs_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Booking_Legs_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Booking_Legs_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Booking_Legs_Order_By>>;
  where?: InputMaybe<Container_Insights_Booking_Legs_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Booking_Legs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<
    InputMaybe<Container_Insights_Booking_Legs_Stream_Cursor_Input>
  >;
  where?: InputMaybe<Container_Insights_Booking_Legs_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_BookingsArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Bookings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Bookings_Order_By>>;
  where?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Bookings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Bookings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Bookings_Order_By>>;
  where?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Bookings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootContainer_Insights_Bookings_ExpandedArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Bookings_Expanded_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Bookings_Expanded_Order_By>>;
  where?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Bookings_Expanded_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Bookings_Expanded_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Container_Insights_Bookings_Expanded_Order_By>>;
    where?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Bookings_Expanded_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<
    InputMaybe<Container_Insights_Bookings_Expanded_Stream_Cursor_Input>
  >;
  where?: InputMaybe<Container_Insights_Bookings_Expanded_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Bookings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Container_Insights_Bookings_Stream_Cursor_Input>>;
  where?: InputMaybe<Container_Insights_Bookings_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Controller_ModelsArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Controller_Models_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Controller_Models_Order_By>>;
  where?: InputMaybe<Container_Insights_Controller_Models_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Controller_Models_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Controller_Models_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Container_Insights_Controller_Models_Order_By>>;
    where?: InputMaybe<Container_Insights_Controller_Models_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Controller_Models_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootContainer_Insights_Controller_Models_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<
    InputMaybe<Container_Insights_Controller_Models_Stream_Cursor_Input>
  >;
  where?: InputMaybe<Container_Insights_Controller_Models_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Energy_UsageArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Energy_Usage_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Energy_Usage_Order_By>>;
  where?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Energy_Usage_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Energy_Usage_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Energy_Usage_Order_By>>;
  where?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Energy_Usage_ExpandedArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_Order_By>>;
  where?: InputMaybe<Container_Insights_Energy_Usage_Expanded_Bool_Exp>;
};


export type Subscription_RootContainer_Insights_Energy_Usage_Expanded_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_Order_By>>;
  where?: InputMaybe<Container_Insights_Energy_Usage_Expanded_Bool_Exp>;
};


export type Subscription_RootContainer_Insights_Energy_Usage_Expanded_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Container_Insights_Energy_Usage_Expanded_Stream_Cursor_Input>>;
  where?: InputMaybe<Container_Insights_Energy_Usage_Expanded_Bool_Exp>;
};


export type Subscription_RootContainer_Insights_Energy_Usage_Expanded_V2Args = {
  distinct_on?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_V2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_V2_Order_By>>;
  where?: InputMaybe<Container_Insights_Energy_Usage_Expanded_V2_Bool_Exp>;
};


export type Subscription_RootContainer_Insights_Energy_Usage_Expanded_V2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_V2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Energy_Usage_Expanded_V2_Order_By>>;
  where?: InputMaybe<Container_Insights_Energy_Usage_Expanded_V2_Bool_Exp>;
};


export type Subscription_RootContainer_Insights_Energy_Usage_Expanded_V2_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Container_Insights_Energy_Usage_Expanded_V2_Stream_Cursor_Input>>;
  where?: InputMaybe<Container_Insights_Energy_Usage_Expanded_V2_Bool_Exp>;
};


export type Subscription_RootContainer_Insights_Energy_Usage_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<
    InputMaybe<Container_Insights_Energy_Usage_Stream_Cursor_Input>
  >;
  where?: InputMaybe<Container_Insights_Energy_Usage_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_LegsArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Legs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Legs_Order_By>>;
  where?: InputMaybe<Container_Insights_Legs_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Legs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Legs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Legs_Order_By>>;
  where?: InputMaybe<Container_Insights_Legs_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Legs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootContainer_Insights_Legs_ExpandedArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Legs_Expanded_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Legs_Expanded_Order_By>>;
  where?: InputMaybe<Container_Insights_Legs_Expanded_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Legs_Expanded_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Legs_Expanded_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Legs_Expanded_Order_By>>;
  where?: InputMaybe<Container_Insights_Legs_Expanded_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Legs_Expanded_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<
    InputMaybe<Container_Insights_Legs_Expanded_Stream_Cursor_Input>
  >;
  where?: InputMaybe<Container_Insights_Legs_Expanded_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Legs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Container_Insights_Legs_Stream_Cursor_Input>>;
  where?: InputMaybe<Container_Insights_Legs_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_ManufacturersArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Manufacturers_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Manufacturers_Order_By>>;
  where?: InputMaybe<Container_Insights_Manufacturers_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Manufacturers_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Manufacturers_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Manufacturers_Order_By>>;
  where?: InputMaybe<Container_Insights_Manufacturers_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Manufacturers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootContainer_Insights_Manufacturers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<
    InputMaybe<Container_Insights_Manufacturers_Stream_Cursor_Input>
  >;
  where?: InputMaybe<Container_Insights_Manufacturers_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_ReefersArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Reefers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Reefers_Order_By>>;
  where?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Reefers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Reefers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Reefers_Order_By>>;
  where?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Reefers_By_PkArgs = {
  id: Scalars['String']['input'];
};

export type Subscription_RootContainer_Insights_Reefers_ExpandedArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Reefers_Expanded_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Reefers_Expanded_Order_By>>;
  where?: InputMaybe<Container_Insights_Reefers_Expanded_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Reefers_Expanded_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Reefers_Expanded_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Container_Insights_Reefers_Expanded_Order_By>>;
    where?: InputMaybe<Container_Insights_Reefers_Expanded_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Reefers_Expanded_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<
    InputMaybe<Container_Insights_Reefers_Expanded_Stream_Cursor_Input>
  >;
  where?: InputMaybe<Container_Insights_Reefers_Expanded_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Reefers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Container_Insights_Reefers_Stream_Cursor_Input>>;
  where?: InputMaybe<Container_Insights_Reefers_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Refrigeration_Unit_ModelsArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Refrigeration_Unit_Models_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Refrigeration_Unit_Models_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Refrigeration_Unit_Models_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Refrigeration_Unit_Models_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Refrigeration_Unit_Models_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Refrigeration_Unit_Models_By_PkArgs =
  {
    id: Scalars['uuid']['input'];
  };

export type Subscription_RootContainer_Insights_Refrigeration_Unit_Models_StreamArgs =
  {
    batch_size: Scalars['Int']['input'];
    cursor: Array<
      InputMaybe<Container_Insights_Refrigeration_Unit_Models_Stream_Cursor_Input>
    >;
    where?: InputMaybe<Container_Insights_Refrigeration_Unit_Models_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Shipping_LinesArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Shipping_Lines_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Shipping_Lines_Order_By>>;
  where?: InputMaybe<Container_Insights_Shipping_Lines_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Shipping_Lines_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Shipping_Lines_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Shipping_Lines_Order_By>>;
  where?: InputMaybe<Container_Insights_Shipping_Lines_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Shipping_Lines_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootContainer_Insights_Shipping_Lines_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<
    InputMaybe<Container_Insights_Shipping_Lines_Stream_Cursor_Input>
  >;
  where?: InputMaybe<Container_Insights_Shipping_Lines_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Telematic_CompaniesArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Telematic_Companies_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Telematic_Companies_Order_By>>;
  where?: InputMaybe<Container_Insights_Telematic_Companies_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Telematic_Companies_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Telematic_Companies_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Telematic_Companies_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Telematic_Companies_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Telematic_Companies_By_PkArgs =
  {
    id: Scalars['uuid']['input'];
  };

export type Subscription_RootContainer_Insights_Telematic_Companies_StreamArgs =
  {
    batch_size: Scalars['Int']['input'];
    cursor: Array<
      InputMaybe<Container_Insights_Telematic_Companies_Stream_Cursor_Input>
    >;
    where?: InputMaybe<Container_Insights_Telematic_Companies_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Telematic_Device_AssignmentArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Telematic_Device_Assignment_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Telematic_Device_Assignment_By_PkArgs =
  {
    reefer_id: Scalars['String']['input'];
    telematic_device_id: Scalars['uuid']['input'];
  };

export type Subscription_RootContainer_Insights_Telematic_Device_Assignment_ExpandedArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Expanded_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Expanded_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Expanded_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Telematic_Device_Assignment_Expanded_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Expanded_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Telematic_Device_Assignment_Expanded_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Expanded_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Telematic_Device_Assignment_Expanded_StreamArgs =
  {
    batch_size: Scalars['Int']['input'];
    cursor: Array<
      InputMaybe<Container_Insights_Telematic_Device_Assignment_Expanded_Stream_Cursor_Input>
    >;
    where?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Expanded_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Telematic_Device_Assignment_StreamArgs =
  {
    batch_size: Scalars['Int']['input'];
    cursor: Array<
      InputMaybe<Container_Insights_Telematic_Device_Assignment_Stream_Cursor_Input>
    >;
    where?: InputMaybe<Container_Insights_Telematic_Device_Assignment_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Telematic_DevicesArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Telematic_Devices_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Telematic_Devices_Order_By>>;
  where?: InputMaybe<Container_Insights_Telematic_Devices_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Telematic_Devices_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Telematic_Devices_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<Array<Container_Insights_Telematic_Devices_Order_By>>;
    where?: InputMaybe<Container_Insights_Telematic_Devices_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Telematic_Devices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootContainer_Insights_Telematic_Devices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<
    InputMaybe<Container_Insights_Telematic_Devices_Stream_Cursor_Input>
  >;
  where?: InputMaybe<Container_Insights_Telematic_Devices_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Temperature_BreachesArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Temperature_Breaches_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<
    Array<Container_Insights_Temperature_Breaches_Order_By>
  >;
  where?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Temperature_Breaches_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Temperature_Breaches_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Temperature_Breaches_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Temperature_Breaches_By_PkArgs =
  {
    id: Scalars['uuid']['input'];
  };

export type Subscription_RootContainer_Insights_Temperature_Breaches_ExpandedArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Temperature_Breaches_Expanded_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Temperature_Breaches_Expanded_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Temperature_Breaches_Expanded_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Temperature_Breaches_Expanded_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_Temperature_Breaches_Expanded_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_Temperature_Breaches_Expanded_Order_By>
    >;
    where?: InputMaybe<Container_Insights_Temperature_Breaches_Expanded_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Temperature_Breaches_Expanded_StreamArgs =
  {
    batch_size: Scalars['Int']['input'];
    cursor: Array<
      InputMaybe<Container_Insights_Temperature_Breaches_Expanded_Stream_Cursor_Input>
    >;
    where?: InputMaybe<Container_Insights_Temperature_Breaches_Expanded_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_Temperature_Breaches_StreamArgs =
  {
    batch_size: Scalars['Int']['input'];
    cursor: Array<
      InputMaybe<Container_Insights_Temperature_Breaches_Stream_Cursor_Input>
    >;
    where?: InputMaybe<Container_Insights_Temperature_Breaches_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_TemperaturesArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Temperatures_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Temperatures_Order_By>>;
  where?: InputMaybe<Container_Insights_Temperatures_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Temperatures_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Container_Insights_Temperatures_Select_Column>
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Temperatures_Order_By>>;
  where?: InputMaybe<Container_Insights_Temperatures_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Temperatures_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_RootContainer_Insights_Temperatures_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<
    InputMaybe<Container_Insights_Temperatures_Stream_Cursor_Input>
  >;
  where?: InputMaybe<Container_Insights_Temperatures_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_User_Shipping_Lines_AuthorizationsArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Order_By>
    >;
    where?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_User_Shipping_Lines_Authorizations_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Order_By>
    >;
    where?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_User_Shipping_Lines_Authorizations_By_PkArgs =
  {
    shipping_line_id: Scalars['uuid']['input'];
    user_id: Scalars['String']['input'];
  };

export type Subscription_RootContainer_Insights_User_Shipping_Lines_Authorizations_ExpandedArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Order_By>
    >;
    where?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_User_Shipping_Lines_Authorizations_Expanded_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Select_Column>
    >;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    order_by?: InputMaybe<
      Array<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Order_By>
    >;
    where?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_User_Shipping_Lines_Authorizations_Expanded_StreamArgs =
  {
    batch_size: Scalars['Int']['input'];
    cursor: Array<
      InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Stream_Cursor_Input>
    >;
    where?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Expanded_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_User_Shipping_Lines_Authorizations_StreamArgs =
  {
    batch_size: Scalars['Int']['input'];
    cursor: Array<
      InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Stream_Cursor_Input>
    >;
    where?: InputMaybe<Container_Insights_User_Shipping_Lines_Authorizations_Bool_Exp>;
  };

export type Subscription_RootContainer_Insights_UsersArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Users_Order_By>>;
  where?: InputMaybe<Container_Insights_Users_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Container_Insights_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Container_Insights_Users_Order_By>>;
  where?: InputMaybe<Container_Insights_Users_Bool_Exp>;
};

export type Subscription_RootContainer_Insights_Users_By_PkArgs = {
  id: Scalars['String']['input'];
};

export type Subscription_RootContainer_Insights_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Container_Insights_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Container_Insights_Users_Bool_Exp>;
};

export type Subscription_RootGlec_Tradelane_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Glec_Tradelane_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Glec_Tradelane_Groups_Order_By>>;
  where?: InputMaybe<Glec_Tradelane_Groups_Bool_Exp>;
};

export type Subscription_RootGlec_Tradelane_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Glec_Tradelane_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Glec_Tradelane_Groups_Order_By>>;
  where?: InputMaybe<Glec_Tradelane_Groups_Bool_Exp>;
};

export type Subscription_RootGlec_Tradelane_Groups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Glec_Tradelane_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Glec_Tradelane_Groups_Bool_Exp>;
};

export type Subscription_RootGlec_TradelanesArgs = {
  distinct_on?: InputMaybe<Array<Glec_Tradelanes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Glec_Tradelanes_Order_By>>;
  where?: InputMaybe<Glec_Tradelanes_Bool_Exp>;
};

export type Subscription_RootGlec_Tradelanes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Glec_Tradelanes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Glec_Tradelanes_Order_By>>;
  where?: InputMaybe<Glec_Tradelanes_Bool_Exp>;
};

export type Subscription_RootGlec_Tradelanes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Glec_Tradelanes_Stream_Cursor_Input>>;
  where?: InputMaybe<Glec_Tradelanes_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** Boolean expression to compare columns of type "transport_mode". All fields are combined with logical 'AND'. */
export type Transport_Mode_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['transport_mode']['input']>;
  _gt?: InputMaybe<Scalars['transport_mode']['input']>;
  _gte?: InputMaybe<Scalars['transport_mode']['input']>;
  _in?: InputMaybe<Array<Scalars['transport_mode']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['transport_mode']['input']>;
  _lte?: InputMaybe<Scalars['transport_mode']['input']>;
  _neq?: InputMaybe<Scalars['transport_mode']['input']>;
  _nin?: InputMaybe<Array<Scalars['transport_mode']['input']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};
